/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface IAdminNotificationNotificationLogRO {
  id: number
  title: string
  body?: string | null
  data?: any
  sendCount: number
  successCount: number
  failCount: number
  createDate: string
}

export interface IAdminNotificationSendNotificationAll {
  title: string
  body: string
  data?: any
  topic?: string
}

export interface IAdminUserRO {
  id: number
  username: string
  name: string
  role: IAdminUserRoRoleEnum
  password?: string
}

export interface IAdminUserCreate {
  username: string
  name: string
  password: string
  passwordConfirm: string
  role?: IAdminUserCreateRoleEnum
}

export interface IAdminUserUpdate {
  username?: string
  name?: string
  password?: string
  role?: IAdminUserUpdateRoleEnum
}

export interface IAdminUserFind {
  q?: string
}

export interface IAuthLoginRO {
  accessToken: string
  refreshToken: string
  accessTokenExpiresInMilliseconds: number
  refreshTokenExpiresInMilliseconds: number
}

export interface IAdminUserLogin {
  username: string
  password: string
}

export interface IAssetAssetRO {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IAssetUpload {
  /** @format binary */
  file: File
  crop?: string
}

export interface OAuthValidateDto {
  provider: OAuthValidateDtoProviderEnum
  code?: string
  token?: string
  noRedirect?: boolean
}

export interface AppleValidateDto {
  provider?: AppleValidateDtoProviderEnum
  appleId?: string
  id_token: string
  noRedirect?: boolean
}

export interface IAuthAccessTokenRO {
  accessToken: string
  accessTokenExpiresInMilliseconds: number
}

export interface IAuthSignIn {
  email: string
  password: string
}

export interface ITranslationResult {
  translatedText: string
  confidence?: number
  sourceLanguage: ITranslationResultSourceLanguageEnum
  targetLanguage: ITranslationResultTargetLanguageEnum
}

export interface ITranslationQuery {
  sourceText: string
  sourceLanguage?: ITranslationQuerySourceLanguageEnum
  targetLanguage?: ITranslationQueryTargetLanguageEnum
  providerType?: ITranslationQueryProviderTypeEnum
}

export interface ITranslationMultipleQuery {
  texts: string[]
  sourceLanguage?: ITranslationMultipleQuerySourceLanguageEnum
  targetLanguage?: ITranslationMultipleQueryTargetLanguageEnum
}

/** Construct a type with a set of properties K of type T */
export type RecordstringRecordstringstring = Record<string, Recordstringstring>

/** Construct a type with a set of properties K of type T */
export type Recordstringstring = Record<string, string>

export interface IBannerRO {
  id: number
  language: IBannerRoLanguageEnum
  order: number
  image: IAssetAssetROO2
  link: string | null
}

export interface IAssetAssetROO2 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IAdminBannerSave {
  language: IAdminBannerSaveLanguageEnum
  order: number
  imageId: number
  link?: string
}

/** Represents entity with its loaded relations (`populate` hint) and selected properties (`fields` hint). */
export interface LoadedBusinessInquiryneverNever {
  id: number
  status: LoadedBusinessInquiryneverNeverStatusEnum
  clinicName: string
  name: string
  position: string | null
  phoneNumber: string
  email: string | null
  content: string
  memo: string | null
  /** @format date-time */
  createDate: string
  /** @format date-time */
  contactDate: string | null
  '__@___loadedType@1736'?: BusinessInquiry
}

export interface BusinessInquiry {
  id: number
  status: BusinessInquiryStatusEnum
  clinicName: string
  name: string
  position: string | null
  phoneNumber: string
  email: string | null
  content: string
  memo: string | null
  /** @format date-time */
  createDate: string
  /** @format date-time */
  contactDate: string | null
}

export interface IAdminBusinessInquiryFind {
  page: number
  q?: string
  status?: IAdminBusinessInquiryFindStatusEnum
}

export interface IAdminBusinessInquiryUpdate {
  status: IAdminBusinessInquiryUpdateStatusEnum
  memo?: string
  /** @format date-time */
  contactDate?: string
}

export interface ICategoryROO1 {
  id: number
  order: number
  name: string
}

export interface IAdminCategorySave {
  name: string
  order: number
}

export interface IAdminClinicConfirmNewEquipmentRequest {
  status: IAdminClinicConfirmNewEquipmentRequestStatusEnum
  rejectReason?: string
}

export type IUserDataRONullable = {
  name: string
  email: string | null
  nickname: string
  nation: string
  nationNumber: string
  phoneNumber: string
  birthYear: number
  birthMonth: number
  birthDay: number
  interestCategories: ICategoryROO2[]
  contactPoints: IContactPointRO[]
  sns: ISnsRO[]
  /** @format date-time */
  agreeTermsDate: string
  /** @format date-time */
  agreeRequiredPrivacyInfoDate: string
  /** @format date-time */
  agreeOptionalPrivacyInfoDate: string | null
  /** @format date-time */
  agreeMarketingInfoDate: string | null
  /** @format date-time */
  createDate: string
  isProfileCompleted: boolean
}

export type IClinicAdminRONullable = {
  businessRegistrationNumber: string | null
  businessRegistrationCertificate: IAssetAssetROO3Nullable
  representativeName: string | null
  managerName: string | null
  managerPhone: string | null
  id: number
  ci: IAssetAssetROO3
  category: ICategoryROO2
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicAdminRoNullableStatusEnum
  region: IRegionROO1
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO1[]
  schedules: IClinicScheduleROO1[][]
  medicalCategories: IMedicalCategoryROO1[]
  wishlistCount: number
  isWishlisted: boolean
}

export type IAssetAssetROO3Nullable = {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IAdminUserROO1 {
  id: number
  role: IAdminUserRoO1RoleEnum
  status: IAdminUserRoO1StatusEnum
  email: string | null
  password: string | null
  /** @format date-time */
  createDate: string | null
  /** @format date-time */
  updateDate: string | null
  /** @format date-time */
  withdrawDate: string | null
  withdrawReason: string | null
  userData: IUserDataRONullable
  clinic: IClinicAdminRONullable
  oauthList: IAuthOAuth[]
}

export interface IUserDataRO {
  name: string
  email: string | null
  nickname: string
  nation: string
  nationNumber: string
  phoneNumber: string
  birthYear: number
  birthMonth: number
  birthDay: number
  interestCategories: ICategoryROO2[]
  contactPoints: IContactPointRO[]
  sns: ISnsRO[]
  /** @format date-time */
  agreeTermsDate: string
  /** @format date-time */
  agreeRequiredPrivacyInfoDate: string
  /** @format date-time */
  agreeOptionalPrivacyInfoDate: string | null
  /** @format date-time */
  agreeMarketingInfoDate: string | null
  /** @format date-time */
  createDate: string
  isProfileCompleted: boolean
}

export interface ICategoryROO2 {
  id: number
  order: number
  name: string
}

export interface IContactPointRO {
  id: number
  type: IContactPointRoTypeEnum
  value: string
  order: number
}

export interface ISnsRO {
  id: number
  type: ISnsRoTypeEnum
  value: string
  order: number
}

export interface IClinicAdminRO {
  businessRegistrationNumber: string | null
  businessRegistrationCertificate: IAssetAssetROO3Nullable
  representativeName: string | null
  managerName: string | null
  managerPhone: string | null
  id: number
  ci: IAssetAssetROO3
  category: ICategoryROO2
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicAdminRoStatusEnum
  region: IRegionROO1
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO1[]
  schedules: IClinicScheduleROO1[][]
  medicalCategories: IMedicalCategoryROO1[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface IAssetAssetROO3 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IRegionROO1 {
  id: number
  name: string
  order: number
}

export interface IClinicSnsROO1 {
  id: number
  type: IClinicSnsRoO1TypeEnum
  value: string
  order: number
}

export interface IClinicScheduleROO1 {
  day: IClinicScheduleRoO1DayEnum
  openingHour: number
  openingMinute: number
  closingHour: number
  closingMinute: number
  breakStartHour: number | null
  breakStartMinute: number | null
  breakEndHour: number | null
  breakEndMinute: number | null
  receptionStartHour: number | null
  receptionStartMinute: number | null
  receptionEndHour: number | null
  receptionEndMinute: number | null
  isRegularHoliday: boolean
}

export interface IMedicalCategoryROO1 {
  id: number
  order: number
  name: string
  language: string
}

export interface IAuthOAuth {
  oauthProvider: IAuthOAuthOauthProviderEnum
  oauthEmail: string
}

export interface IAdminClinicFind {
  page: number
  q?: string
  categoryIds: number[]
  regionIds: number[]
  status?: IAdminClinicFindStatusEnum
}

export interface IAdminClinicSave {
  email: string
  password?: string
  clinic: {
    status: IAdminClinicSaveStatusEnum
    ciId: number
    regionId: number
    categoryId: number
    name: string
    nameZhcn?: string
    nameZhtw?: string
    nameEn?: string
    nameJa?: string
    nameTh?: string
    nameMn?: string
    nameRu?: string
    address: string
    addressZhcn?: string
    addressZhtw?: string
    addressEn?: string
    addressJa?: string
    addressTh?: string
    addressMn?: string
    addressRu?: string
    addressDetail: string
    addressDetailZhcn?: string
    addressDetailZhtw?: string
    addressDetailEn?: string
    addressDetailJa?: string
    addressDetailTh?: string
    addressDetailMn?: string
    addressDetailRu?: string
    businessRegistrationNumber: string
    businessRegistrationCertificateId: number
    representativeName: string
    managerName: string
    managerPhone: string
    phone: string
  }
}

export interface IPaginationROIAdminClinicInterviewROnumber {
  rows: IAdminClinicInterviewRO[]
  count: number
  cursor: number | null
}

export interface IAdminClinicInterviewRO {
  id: number
  status: IAdminClinicInterviewRoStatusEnum
  clinicName: string
  doctorName: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  content: string
  contentZhcn: string | null
  contentZhtw: string | null
  contentEn: string | null
  contentJa: string | null
  contentTh: string | null
  contentMn: string | null
  contentRu: string | null
  /** @format date-time */
  createDate: string
  youtubeURL: string
  qna: IClinicDoctorProfileQnaO1[]
  /** @format date-time */
  approveDate: string | null
  /** @format date-time */
  updateDate: string | null
  /** @format date-time */
  rejectDate: string | null
  rejectReason: string | null
  tempData: {
    request: IClinicDoctorProfileQnaO1[]
  } | null
}

export interface IClinicDoctorProfileQnaO1 {
  question: string
  answer: string
  language: string
}

export interface IAdminClinicInterviewFind {
  page: number
  q?: string
  statusList: IAdminClinicInterviewFindStatusListEnum[]
}

export interface IAdminClinicConfirmDoctorProfileRequest {
  status: IAdminClinicConfirmDoctorProfileRequestStatusEnum
  rejectReason?: string
}

export interface IAdminPaginationROIAdminCommentRO {
  rows: IAdminCommentRO[]
  count: number
}

export interface IAdminCommentRO {
  id: number
  content: string
  /** @format date-time */
  createDate: string
  author: IAdminUserROO2
  article: {
    id: number
    type: IAdminCommentRoTypeEnum
    title: string
    content: string
  }
  active: boolean
  /** @format date-time */
  updateDate: string | null
}

export type IUserDataROO1Nullable = {
  name: string
  email: string | null
  nickname: string
  nation: string
  nationNumber: string
  phoneNumber: string
  birthYear: number
  birthMonth: number
  birthDay: number
  interestCategories: ICategoryROO3[]
  contactPoints: IContactPointROO1[]
  sns: ISnsROO1[]
  /** @format date-time */
  agreeTermsDate: string
  /** @format date-time */
  agreeRequiredPrivacyInfoDate: string
  /** @format date-time */
  agreeOptionalPrivacyInfoDate: string | null
  /** @format date-time */
  agreeMarketingInfoDate: string | null
  /** @format date-time */
  createDate: string
  isProfileCompleted: boolean
}

export type IClinicAdminROO1Nullable = {
  businessRegistrationNumber: string | null
  businessRegistrationCertificate: IAssetAssetROO4Nullable
  representativeName: string | null
  managerName: string | null
  managerPhone: string | null
  id: number
  ci: IAssetAssetROO4
  category: ICategoryROO3
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicAdminRoO1NullableStatusEnum
  region: IRegionROO2
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO2[]
  schedules: IClinicScheduleROO2[][]
  medicalCategories: IMedicalCategoryROO2[]
  wishlistCount: number
  isWishlisted: boolean
}

export type IAssetAssetROO4Nullable = {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IAdminUserROO2 {
  id: number
  role: IAdminUserRoO2RoleEnum
  status: IAdminUserRoO2StatusEnum
  email: string | null
  password: string | null
  /** @format date-time */
  createDate: string | null
  /** @format date-time */
  updateDate: string | null
  /** @format date-time */
  withdrawDate: string | null
  withdrawReason: string | null
  userData: IUserDataROO1Nullable
  clinic: IClinicAdminROO1Nullable
  oauthList: IAuthOAuthO1[]
}

export interface IUserDataROO1 {
  name: string
  email: string | null
  nickname: string
  nation: string
  nationNumber: string
  phoneNumber: string
  birthYear: number
  birthMonth: number
  birthDay: number
  interestCategories: ICategoryROO3[]
  contactPoints: IContactPointROO1[]
  sns: ISnsROO1[]
  /** @format date-time */
  agreeTermsDate: string
  /** @format date-time */
  agreeRequiredPrivacyInfoDate: string
  /** @format date-time */
  agreeOptionalPrivacyInfoDate: string | null
  /** @format date-time */
  agreeMarketingInfoDate: string | null
  /** @format date-time */
  createDate: string
  isProfileCompleted: boolean
}

export interface ICategoryROO3 {
  id: number
  order: number
  name: string
}

export interface IContactPointROO1 {
  id: number
  type: IContactPointRoO1TypeEnum
  value: string
  order: number
}

export interface ISnsROO1 {
  id: number
  type: ISnsRoO1TypeEnum
  value: string
  order: number
}

export interface IClinicAdminROO1 {
  businessRegistrationNumber: string | null
  businessRegistrationCertificate: IAssetAssetROO4Nullable
  representativeName: string | null
  managerName: string | null
  managerPhone: string | null
  id: number
  ci: IAssetAssetROO4
  category: ICategoryROO3
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicAdminRoO1StatusEnum
  region: IRegionROO2
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO2[]
  schedules: IClinicScheduleROO2[][]
  medicalCategories: IMedicalCategoryROO2[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface IAssetAssetROO4 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IRegionROO2 {
  id: number
  name: string
  order: number
}

export interface IClinicSnsROO2 {
  id: number
  type: IClinicSnsRoO2TypeEnum
  value: string
  order: number
}

export interface IClinicScheduleROO2 {
  day: IClinicScheduleRoO2DayEnum
  openingHour: number
  openingMinute: number
  closingHour: number
  closingMinute: number
  breakStartHour: number | null
  breakStartMinute: number | null
  breakEndHour: number | null
  breakEndMinute: number | null
  receptionStartHour: number | null
  receptionStartMinute: number | null
  receptionEndHour: number | null
  receptionEndMinute: number | null
  isRegularHoliday: boolean
}

export interface IMedicalCategoryROO2 {
  id: number
  order: number
  name: string
  language: string
}

export interface IAuthOAuthO1 {
  oauthProvider: IAuthOAuthO1OauthProviderEnum
  oauthEmail: string
}

export interface IAdminCommentFind {
  q?: string
  /** 댓글 조회 시 게시글 아이디 */
  articleId?: number
  /**
   * 댓글 조회 시 게시글 타입
   * - CLINIC_REVIEW: 병원 리뷰
   * - CLINIC_EXPERIENCE: 체험단 구인구직
   * - COMMUNITY_ARTICLE: 커뮤니티 게시글
   * - CLINIC_EQUIPMENT: 병원 신규 장비
   */
  articleType: IAdminCommentFindArticleTypeEnum
  status?: IAdminCommentFindStatusEnum
  page: number
  pageSize: number
}

export interface IAdminCommentDelete {
  type: IAdminCommentDeleteTypeEnum
}

export interface IAdminCommentUpdateStatus {
  type: IAdminCommentUpdateStatusTypeEnum
  status: IAdminCommentUpdateStatusStatusEnum
}

export interface IAdminPaginationROIAdminCommunityRO {
  rows: IAdminCommunityRO[]
  count: number
}

export type ICategoryROO4Nullable = {
  id: number
  order: number
  name: string
} | null

export type IRegionROO3Nullable = {
  id: number
  name: string
  order: number
} | null

export interface IAdminCommunityRO {
  id: number
  title: string
  content: string
  author: IAdminUserROO3
  category: ICategoryROO4Nullable
  board: ICommunityBoardSimpleRO
  tags: ICommunityArticleTagRO[]
  region: IRegionROO3Nullable
  viewCount: number
  likeCount: number
  bookmarkCount: number
  /** @format date-time */
  createDate: string
  /** @format date-time */
  updateDate: string | null
  /** @format date-time */
  deleteDate: string | null
  commentCount: number
  shareCountFacebook: number
  shareCountTwitter: number
  shareCountWechat: number
  shareCountKakao: number
  shareCountUrl: number
  inquiryStatus: IAdminCommunityRoInquiryStatusEnum
  articleStatus: IAdminCommunityRoArticleStatusEnum
  excludeFromPopular: boolean
}

export type IUserDataROO2Nullable = {
  name: string
  email: string | null
  nickname: string
  nation: string
  nationNumber: string
  phoneNumber: string
  birthYear: number
  birthMonth: number
  birthDay: number
  interestCategories: ICategoryROO4[]
  contactPoints: IContactPointROO2[]
  sns: ISnsROO2[]
  /** @format date-time */
  agreeTermsDate: string
  /** @format date-time */
  agreeRequiredPrivacyInfoDate: string
  /** @format date-time */
  agreeOptionalPrivacyInfoDate: string | null
  /** @format date-time */
  agreeMarketingInfoDate: string | null
  /** @format date-time */
  createDate: string
  isProfileCompleted: boolean
}

export type IClinicAdminROO2Nullable = {
  businessRegistrationNumber: string | null
  businessRegistrationCertificate: IAssetAssetROO5Nullable
  representativeName: string | null
  managerName: string | null
  managerPhone: string | null
  id: number
  ci: IAssetAssetROO5
  category: ICategoryROO4
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicAdminRoO2NullableStatusEnum
  region: IRegionROO3
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO3[]
  schedules: IClinicScheduleROO3[][]
  medicalCategories: IMedicalCategoryROO3[]
  wishlistCount: number
  isWishlisted: boolean
}

export type IAssetAssetROO5Nullable = {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IAdminUserROO3 {
  id: number
  role: IAdminUserRoO3RoleEnum
  status: IAdminUserRoO3StatusEnum
  email: string | null
  password: string | null
  /** @format date-time */
  createDate: string | null
  /** @format date-time */
  updateDate: string | null
  /** @format date-time */
  withdrawDate: string | null
  withdrawReason: string | null
  userData: IUserDataROO2Nullable
  clinic: IClinicAdminROO2Nullable
  oauthList: IAuthOAuthO2[]
}

export interface IUserDataROO2 {
  name: string
  email: string | null
  nickname: string
  nation: string
  nationNumber: string
  phoneNumber: string
  birthYear: number
  birthMonth: number
  birthDay: number
  interestCategories: ICategoryROO4[]
  contactPoints: IContactPointROO2[]
  sns: ISnsROO2[]
  /** @format date-time */
  agreeTermsDate: string
  /** @format date-time */
  agreeRequiredPrivacyInfoDate: string
  /** @format date-time */
  agreeOptionalPrivacyInfoDate: string | null
  /** @format date-time */
  agreeMarketingInfoDate: string | null
  /** @format date-time */
  createDate: string
  isProfileCompleted: boolean
}

export interface ICategoryROO4 {
  id: number
  order: number
  name: string
}

export interface IContactPointROO2 {
  id: number
  type: IContactPointRoO2TypeEnum
  value: string
  order: number
}

export interface ISnsROO2 {
  id: number
  type: ISnsRoO2TypeEnum
  value: string
  order: number
}

export interface IClinicAdminROO2 {
  businessRegistrationNumber: string | null
  businessRegistrationCertificate: IAssetAssetROO5Nullable
  representativeName: string | null
  managerName: string | null
  managerPhone: string | null
  id: number
  ci: IAssetAssetROO5
  category: ICategoryROO4
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicAdminRoO2StatusEnum
  region: IRegionROO3
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO3[]
  schedules: IClinicScheduleROO3[][]
  medicalCategories: IMedicalCategoryROO3[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface IAssetAssetROO5 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IRegionROO3 {
  id: number
  name: string
  order: number
}

export interface IClinicSnsROO3 {
  id: number
  type: IClinicSnsRoO3TypeEnum
  value: string
  order: number
}

export interface IClinicScheduleROO3 {
  day: IClinicScheduleRoO3DayEnum
  openingHour: number
  openingMinute: number
  closingHour: number
  closingMinute: number
  breakStartHour: number | null
  breakStartMinute: number | null
  breakEndHour: number | null
  breakEndMinute: number | null
  receptionStartHour: number | null
  receptionStartMinute: number | null
  receptionEndHour: number | null
  receptionEndMinute: number | null
  isRegularHoliday: boolean
}

export interface IMedicalCategoryROO3 {
  id: number
  order: number
  name: string
  language: string
}

export interface IAuthOAuthO2 {
  oauthProvider: IAuthOAuthO2OauthProviderEnum
  oauthEmail: string
}

export interface ICommunityBoardSimpleRO {
  id: number
  slug: string
  title: string
}

export interface ICommunityArticleTagRO {
  id: number
  title: string
}

export interface IAdminCommunityFind {
  page: number
  pageSize: number
  q?: string
  categoryId?: number
  boardId?: number
  status?: IAdminCommunityFindStatusEnum
}

export interface IAdminCommunitySaveNotice {
  title: string
  content: string
  articleStatus: IAdminCommunitySaveNoticeArticleStatusEnum
}

export interface IAdminCommunityUpdate {
  isDeleted?: boolean
  excludeFromPopular?: boolean
}

export type IConsultationFormPayloadDataNullable = {
  firstMiddleName: string
  lastName: string
  gender: IConsultationFormPayloadDataNullableGenderEnum
  birthDate: string
  preferredLanguage: string
  preferredLanguageOther?: string
  messengers: IConsultationFormPayloadMessengerContact[]
  procedureAreas: string[]
  procedureOther?: string
  improvementDescription: string
  budget: string
  plannedTiming: string
  previousSurgery: string
  medicalHistory: string
  currentMedications: string
  flightBooked: IConsultationFormPayloadDataNullableFlightBookedEnum
  preferredConsultationDate: string
  preferredSurgeryDate: string
  photoAssetIds: number[]
} | null

export interface IAdminConsultationRequestRO {
  referralPartnerName: string | null
  adminMemo: string | null
  linkedRevenueId: number | null
  procedureName: string | null
  revenueAmount: string | null
  revenueCurrency: string | null
  revenueDate: string | null
  id: number
  referrerCodeSnapshot: string | null
  referralPartnerId: number | null
  name: string
  phone: string
  email: string
  message: string
  nationality: string | null
  preferredClinic: string | null
  preferredVisitDate: string | null
  preferredContactChannel: string | null
  channel: IAdminConsultationRequestRoChannelEnum
  status: IAdminConsultationRequestRoStatusEnum
  /** @format date-time */
  reservationConfirmedAt: string | null
  formPayload: IConsultationFormPayloadDataNullable
  /** @format date-time */
  createDate: string
}

export interface IConsultationFormPayloadData {
  firstMiddleName: string
  lastName: string
  gender: IConsultationFormPayloadDataGenderEnum
  birthDate: string
  preferredLanguage: string
  preferredLanguageOther?: string
  messengers: IConsultationFormPayloadMessengerContact[]
  procedureAreas: string[]
  procedureOther?: string
  improvementDescription: string
  budget: string
  plannedTiming: string
  previousSurgery: string
  medicalHistory: string
  currentMedications: string
  flightBooked: IConsultationFormPayloadDataFlightBookedEnum
  preferredConsultationDate: string
  preferredSurgeryDate: string
  photoAssetIds: number[]
}

export interface IConsultationFormPayloadMessengerContact {
  type: string
  typeOther?: string
  contact: string
}

export interface IAdminConsultationRequestFind {
  page: number
  q?: string
  status?: IAdminConsultationRequestFindStatusEnum
  referralPartnerId?: number
  fromDate?: string
  toDate?: string
}

export interface IAdminConsultationRequestCreate {
  name: string
  phone: string
  email: string
  message: string
  channel: IAdminConsultationRequestCreateChannelEnum
  referralPartnerId?: number | null
  referrerCode?: string
  status?: IAdminConsultationRequestCreateStatusEnum
  adminMemo?: string
}

export interface IAdminConsultationRequestUpdate {
  status: IAdminConsultationRequestUpdateStatusEnum
  adminMemo?: string
  referralPartnerId?: number | null
  reservationConfirmedAt?: string
  procedureName?: string
  revenueAmount?: string
  revenueCurrency?: string
  /** @format date */
  revenueDate?: string
}

export interface IAdminPaginationROIAdminExperienceRO {
  rows: IAdminExperienceRO[]
  count: number
}

export type ICategoryROO5Nullable = {
  id: number
  order: number
  name: string
} | null

export type IRegionROO4Nullable = {
  id: number
  name: string
  order: number
} | null

export interface IAdminExperienceRO {
  id: number
  title: string
  content: string
  /** @format date-time */
  createDate: string
  author: IAdminUserROO4
  category: ICategoryROO5Nullable
  region: IRegionROO4Nullable
  articleStatus: IAdminExperienceRoArticleStatusEnum
}

export type IUserDataROO3Nullable = {
  name: string
  email: string | null
  nickname: string
  nation: string
  nationNumber: string
  phoneNumber: string
  birthYear: number
  birthMonth: number
  birthDay: number
  interestCategories: ICategoryROO5[]
  contactPoints: IContactPointROO3[]
  sns: ISnsROO3[]
  /** @format date-time */
  agreeTermsDate: string
  /** @format date-time */
  agreeRequiredPrivacyInfoDate: string
  /** @format date-time */
  agreeOptionalPrivacyInfoDate: string | null
  /** @format date-time */
  agreeMarketingInfoDate: string | null
  /** @format date-time */
  createDate: string
  isProfileCompleted: boolean
}

export type IClinicAdminROO3Nullable = {
  businessRegistrationNumber: string | null
  businessRegistrationCertificate: IAssetAssetROO6Nullable
  representativeName: string | null
  managerName: string | null
  managerPhone: string | null
  id: number
  ci: IAssetAssetROO6
  category: ICategoryROO5
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicAdminRoO3NullableStatusEnum
  region: IRegionROO4
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO4[]
  schedules: IClinicScheduleROO4[][]
  medicalCategories: IMedicalCategoryROO4[]
  wishlistCount: number
  isWishlisted: boolean
}

export type IAssetAssetROO6Nullable = {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IAdminUserROO4 {
  id: number
  role: IAdminUserRoO4RoleEnum
  status: IAdminUserRoO4StatusEnum
  email: string | null
  password: string | null
  /** @format date-time */
  createDate: string | null
  /** @format date-time */
  updateDate: string | null
  /** @format date-time */
  withdrawDate: string | null
  withdrawReason: string | null
  userData: IUserDataROO3Nullable
  clinic: IClinicAdminROO3Nullable
  oauthList: IAuthOAuthO3[]
}

export interface IUserDataROO3 {
  name: string
  email: string | null
  nickname: string
  nation: string
  nationNumber: string
  phoneNumber: string
  birthYear: number
  birthMonth: number
  birthDay: number
  interestCategories: ICategoryROO5[]
  contactPoints: IContactPointROO3[]
  sns: ISnsROO3[]
  /** @format date-time */
  agreeTermsDate: string
  /** @format date-time */
  agreeRequiredPrivacyInfoDate: string
  /** @format date-time */
  agreeOptionalPrivacyInfoDate: string | null
  /** @format date-time */
  agreeMarketingInfoDate: string | null
  /** @format date-time */
  createDate: string
  isProfileCompleted: boolean
}

export interface ICategoryROO5 {
  id: number
  order: number
  name: string
}

export interface IContactPointROO3 {
  id: number
  type: IContactPointRoO3TypeEnum
  value: string
  order: number
}

export interface ISnsROO3 {
  id: number
  type: ISnsRoO3TypeEnum
  value: string
  order: number
}

export interface IClinicAdminROO3 {
  businessRegistrationNumber: string | null
  businessRegistrationCertificate: IAssetAssetROO6Nullable
  representativeName: string | null
  managerName: string | null
  managerPhone: string | null
  id: number
  ci: IAssetAssetROO6
  category: ICategoryROO5
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicAdminRoO3StatusEnum
  region: IRegionROO4
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO4[]
  schedules: IClinicScheduleROO4[][]
  medicalCategories: IMedicalCategoryROO4[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface IAssetAssetROO6 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IRegionROO4 {
  id: number
  name: string
  order: number
}

export interface IClinicSnsROO4 {
  id: number
  type: IClinicSnsRoO4TypeEnum
  value: string
  order: number
}

export interface IClinicScheduleROO4 {
  day: IClinicScheduleRoO4DayEnum
  openingHour: number
  openingMinute: number
  closingHour: number
  closingMinute: number
  breakStartHour: number | null
  breakStartMinute: number | null
  breakEndHour: number | null
  breakEndMinute: number | null
  receptionStartHour: number | null
  receptionStartMinute: number | null
  receptionEndHour: number | null
  receptionEndMinute: number | null
  isRegularHoliday: boolean
}

export interface IMedicalCategoryROO4 {
  id: number
  order: number
  name: string
  language: string
}

export interface IAuthOAuthO3 {
  oauthProvider: IAuthOAuthO3OauthProviderEnum
  oauthEmail: string
}

export interface IAdminExperienceFind {
  q?: string
  page: number
  pageSize: number
  categoryId?: number
  regionId?: number
}

export interface IAdminExperienceUpdate {
  title: string
  content: string
  categoryId: number | null
  regionId: number | null
}

export interface IFaqRO {
  id: number
  question: string
  order: number
  answer: string
}

export interface IAdminFaqSave {
  question: string
  answer: string
  order: number
}

export interface IAdminFaqDelete {
  ids: number[]
}

export interface IFooterIconRO {
  id: number
  order: number
  icon: IAssetAssetROO7
  krLink: string | null
  zhLink: string | null
  jpLink: string | null
  enLink: string | null
  thLink: string | null
  side: IFooterIconRoSideEnum
}

export interface IAssetAssetROO7 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IAdminFooterIconSave {
  iconId: number
  krLink: string | null
  zhLink: string | null
  jpLink: string | null
  enLink: string | null
  thLink: string | null
  order: number
  side: IAdminFooterIconSaveSideEnum
}

export interface IPaginationROIAdminClinicNewEquipmentROnumber {
  rows: IAdminClinicNewEquipmentRO[]
  count: number
  cursor: number | null
}

export interface IAdminClinicNewEquipmentRO {
  id: number
  status: IAdminClinicNewEquipmentRoStatusEnum
  clinicName: string
  equipmentName: string
  equipmentNameZhcn: string | null
  equipmentNameZhtw: string | null
  equipmentNameEn: string | null
  equipmentNameJa: string | null
  equipmentNameTh: string | null
  equipmentNameMn: string | null
  equipmentNameRu: string | null
  content: string
  contentZhcn: string | null
  contentZhtw: string | null
  contentEn: string | null
  contentJa: string | null
  contentTh: string | null
  contentMn: string | null
  contentRu: string | null
  images: IClinicNewEquipmentImageRO[]
  /** @format date-time */
  createDate: string
  /** @format date-time */
  approveDate: string | null
  /** @format date-time */
  updateDate: string | null
  /** @format date-time */
  rejectDate: string | null
  rejectReason: string | null
}

export interface IClinicNewEquipmentImageRO {
  id: number
  image: IAssetAssetROO8
  isMain: boolean
  order: number
}

export interface IAssetAssetROO8 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IAdminClinicNewEquipmentFind {
  page: number
  q?: string
  statusList: IAdminClinicNewEquipmentFindStatusListEnum[]
}

export interface IAdminClinicConfirmDoctorProfileRequestO1 {
  status: IAdminClinicConfirmDoctorProfileRequestO1StatusEnum
  rejectReason?: string
}

export interface INoticeRO {
  id: number
  title: string
  content: string
  active: boolean
  order: number
}

export interface INoticeSave {
  title: string
  content: string
  order: number
  active: boolean
}

export interface IPaginationROIAdminPointTransactionROnumber {
  rows: IAdminPointTransactionRO[]
  count: number
  cursor: number | null
}

export interface IAdminPointTransactionRO {
  id: number
  description: string
  amount: number
  referenceType: IAdminPointTransactionRoReferenceTypeEnum
  transactionType: IAdminPointTransactionRoTransactionTypeEnum
  user: IAdminUserROO5
  /** @format date-time */
  createDate: string
  flag: string | null
}

export type IUserDataROO4Nullable = {
  name: string
  email: string | null
  nickname: string
  nation: string
  nationNumber: string
  phoneNumber: string
  birthYear: number
  birthMonth: number
  birthDay: number
  interestCategories: ICategoryROO6[]
  contactPoints: IContactPointROO4[]
  sns: ISnsROO4[]
  /** @format date-time */
  agreeTermsDate: string
  /** @format date-time */
  agreeRequiredPrivacyInfoDate: string
  /** @format date-time */
  agreeOptionalPrivacyInfoDate: string | null
  /** @format date-time */
  agreeMarketingInfoDate: string | null
  /** @format date-time */
  createDate: string
  isProfileCompleted: boolean
}

export type IClinicAdminROO4Nullable = {
  businessRegistrationNumber: string | null
  businessRegistrationCertificate: IAssetAssetROO9Nullable
  representativeName: string | null
  managerName: string | null
  managerPhone: string | null
  id: number
  ci: IAssetAssetROO9
  category: ICategoryROO6
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicAdminRoO4NullableStatusEnum
  region: IRegionROO5
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO5[]
  schedules: IClinicScheduleROO5[][]
  medicalCategories: IMedicalCategoryROO5[]
  wishlistCount: number
  isWishlisted: boolean
}

export type IAssetAssetROO9Nullable = {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IAdminUserROO5 {
  id: number
  role: IAdminUserRoO5RoleEnum
  status: IAdminUserRoO5StatusEnum
  email: string | null
  password: string | null
  /** @format date-time */
  createDate: string | null
  /** @format date-time */
  updateDate: string | null
  /** @format date-time */
  withdrawDate: string | null
  withdrawReason: string | null
  userData: IUserDataROO4Nullable
  clinic: IClinicAdminROO4Nullable
  oauthList: IAuthOAuthO4[]
}

export interface IUserDataROO4 {
  name: string
  email: string | null
  nickname: string
  nation: string
  nationNumber: string
  phoneNumber: string
  birthYear: number
  birthMonth: number
  birthDay: number
  interestCategories: ICategoryROO6[]
  contactPoints: IContactPointROO4[]
  sns: ISnsROO4[]
  /** @format date-time */
  agreeTermsDate: string
  /** @format date-time */
  agreeRequiredPrivacyInfoDate: string
  /** @format date-time */
  agreeOptionalPrivacyInfoDate: string | null
  /** @format date-time */
  agreeMarketingInfoDate: string | null
  /** @format date-time */
  createDate: string
  isProfileCompleted: boolean
}

export interface ICategoryROO6 {
  id: number
  order: number
  name: string
}

export interface IContactPointROO4 {
  id: number
  type: IContactPointRoO4TypeEnum
  value: string
  order: number
}

export interface ISnsROO4 {
  id: number
  type: ISnsRoO4TypeEnum
  value: string
  order: number
}

export interface IClinicAdminROO4 {
  businessRegistrationNumber: string | null
  businessRegistrationCertificate: IAssetAssetROO9Nullable
  representativeName: string | null
  managerName: string | null
  managerPhone: string | null
  id: number
  ci: IAssetAssetROO9
  category: ICategoryROO6
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicAdminRoO4StatusEnum
  region: IRegionROO5
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO5[]
  schedules: IClinicScheduleROO5[][]
  medicalCategories: IMedicalCategoryROO5[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface IAssetAssetROO9 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IRegionROO5 {
  id: number
  name: string
  order: number
}

export interface IClinicSnsROO5 {
  id: number
  type: IClinicSnsRoO5TypeEnum
  value: string
  order: number
}

export interface IClinicScheduleROO5 {
  day: IClinicScheduleRoO5DayEnum
  openingHour: number
  openingMinute: number
  closingHour: number
  closingMinute: number
  breakStartHour: number | null
  breakStartMinute: number | null
  breakEndHour: number | null
  breakEndMinute: number | null
  receptionStartHour: number | null
  receptionStartMinute: number | null
  receptionEndHour: number | null
  receptionEndMinute: number | null
  isRegularHoliday: boolean
}

export interface IMedicalCategoryROO5 {
  id: number
  order: number
  name: string
  language: string
}

export interface IAuthOAuthO4 {
  oauthProvider: IAuthOAuthO4OauthProviderEnum
  oauthEmail: string
}

export interface IAdminPointTransactionFind {
  page: number
  q?: string
  types: IAdminPointTransactionFindTypesEnum[]
  referenceTypes: IAdminPointTransactionFindReferenceTypesEnum[]
  /** @format date */
  startDate?: string
  /** @format date */
  endDate?: string
  userId?: number
  flag?: string
}

export interface IAdminPointTransactionCreate {
  type: IAdminPointTransactionCreateTypeEnum
  amount: number
  description: string
  referenceType: IAdminPointTransactionCreateReferenceTypeEnum
  userId: number
}

export interface IPaginationROIAdminPointRuleROnumber {
  rows: IAdminPointRuleRO[]
  count: number
  cursor: number | null
}

export interface IAdminPointRuleRO {
  id: number
  referenceType: IAdminPointRuleRoReferenceTypeEnum
  name: string
  amount: number
}

/** Represents entity with its loaded relations (`populate` hint) and selected properties (`fields` hint). */
export interface LoadedPointRuleneverNever {
  id: number
  referenceType: LoadedPointRuleneverNeverReferenceTypeEnum
  name: string
  amount: number
  '__@___loadedType@1736'?: PointRule
}

export interface PointRule {
  id: number
  referenceType: PointRuleReferenceTypeEnum
  name: string
  amount: number
}

export interface IAdminPointRuleUpdate {
  name: string
  amount: number
}

export interface IPaginationROIAdminProductROnumber {
  rows: IAdminProductRO[]
  count: number
  cursor: number | null
}

export type IAssetAssetROO10Nullable = {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IAdminProductRO {
  id: number
  category: IAdminProductRoCategoryEnum
  status: IAdminProductRoStatusEnum
  title: string
  titleZhcn: string | null
  titleZhtw: string | null
  titleEn: string | null
  titleJa: string | null
  titleTh: string | null
  titleMn: string | null
  titleRu: string | null
  content: string
  contentZhcn: string | null
  contentZhtw: string | null
  contentEn: string | null
  contentJa: string | null
  contentTh: string | null
  contentMn: string | null
  contentRu: string | null
  code: string
  codeZhcn: string | null
  codeZhtw: string | null
  codeEn: string | null
  codeJa: string | null
  codeTh: string | null
  codeMn: string | null
  codeRu: string | null
  price: number
  viewCount: number
  /** @format date-time */
  createDate: string
  thumbnail: IAssetAssetROO10Nullable
}

export interface IAssetAssetROO10 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IAdminProductFind {
  q?: string
  page: number
  category?: IAdminProductFindCategoryEnum
  status?: IAdminProductFindStatusEnum
  order?: IAdminProductFindOrderEnum
}

export interface IAdminProductCreate {
  category: IAdminProductCreateCategoryEnum
  title: string
  titleZhcn?: string | null
  titleZhtw?: string | null
  titleEn?: string | null
  titleJa?: string | null
  titleTh?: string | null
  titleMn?: string | null
  titleRu?: string | null
  content: string
  contentZhcn?: string | null
  contentZhtw?: string | null
  contentEn?: string | null
  contentJa?: string | null
  contentTh?: string | null
  contentMn?: string | null
  contentRu?: string | null
  code: string
  codeZhcn?: string | null
  codeZhtw?: string | null
  codeEn?: string | null
  codeJa?: string | null
  codeTh?: string | null
  codeMn?: string | null
  codeRu?: string | null
  price: number
  thumbnailId?: number
}

export interface IAdminProductUpdate {
  category?: IAdminProductUpdateCategoryEnum
  status?: IAdminProductUpdateStatusEnum
  title?: string
  titleZhcn?: string | null
  titleZhtw?: string | null
  titleEn?: string | null
  titleJa?: string | null
  titleTh?: string | null
  titleMn?: string | null
  titleRu?: string | null
  content?: string
  contentZhcn?: string | null
  contentZhtw?: string | null
  contentEn?: string | null
  contentJa?: string | null
  contentTh?: string | null
  contentMn?: string | null
  contentRu?: string | null
  code?: string
  codeZhcn?: string | null
  codeZhtw?: string | null
  codeEn?: string | null
  codeJa?: string | null
  codeTh?: string | null
  codeMn?: string | null
  codeRu?: string | null
  price?: number
  thumbnailId?: number
}

export type IAssetAssetROO11Nullable = {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export type IRegionROO6Nullable = {
  id: number
  name: string
  order: number
} | null

export type IClinicROO1Nullable = {
  id: number
  ci: IAssetAssetROO11
  category: ICategoryROO7
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicRoO1NullableStatusEnum
  region: IRegionROO6
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO6[]
  schedules: IClinicScheduleROO6[][]
  medicalCategories: IMedicalCategoryROO6[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface IAdminPromotionRO {
  id: number
  type: IAdminPromotionRoTypeEnum
  image: IAssetAssetROO11
  imageZhcn: IAssetAssetROO11Nullable
  imageZhtw: IAssetAssetROO11Nullable
  imageEn: IAssetAssetROO11Nullable
  imageJa: IAssetAssetROO11Nullable
  imageTh: IAssetAssetROO11Nullable
  status: IAdminPromotionRoStatusEnum
  category: ICategoryROO7
  region: IRegionROO6Nullable
  /** @format date-time */
  startDate: string | null
  /** @format date-time */
  endDate: string | null
  title: string
  titleZhcn: string | null
  titleZhtw: string | null
  titleEn: string | null
  titleJa: string | null
  titleTh: string | null
  titleMn: string | null
  titleRu: string | null
  content: string
  contentZhcn: string | null
  contentZhtw: string | null
  contentEn: string | null
  contentJa: string | null
  contentTh: string | null
  contentMn: string | null
  contentRu: string | null
  discountRate: number | null
  originalPrice: number | null
  discountPrice: number | null
  hashtags: IClinicPromotionHashtagRO[]
  participantCount: number
  clinic: IClinicROO1Nullable
  /** @format date-time */
  createDate: string
}

export interface IAssetAssetROO11 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface ICategoryROO7 {
  id: number
  order: number
  name: string
}

export interface IRegionROO6 {
  id: number
  name: string
  order: number
}

export interface IClinicPromotionHashtagRO {
  id: number
  hashtag: string
  language: string
  order: number
}

export interface IClinicROO1 {
  id: number
  ci: IAssetAssetROO11
  category: ICategoryROO7
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicRoO1StatusEnum
  region: IRegionROO6
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO6[]
  schedules: IClinicScheduleROO6[][]
  medicalCategories: IMedicalCategoryROO6[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface IClinicSnsROO6 {
  id: number
  type: IClinicSnsRoO6TypeEnum
  value: string
  order: number
}

export interface IClinicScheduleROO6 {
  day: IClinicScheduleRoO6DayEnum
  openingHour: number
  openingMinute: number
  closingHour: number
  closingMinute: number
  breakStartHour: number | null
  breakStartMinute: number | null
  breakEndHour: number | null
  breakEndMinute: number | null
  receptionStartHour: number | null
  receptionStartMinute: number | null
  receptionEndHour: number | null
  receptionEndMinute: number | null
  isRegularHoliday: boolean
}

export interface IMedicalCategoryROO6 {
  id: number
  order: number
  name: string
  language: string
}

export interface IAdminPromotionFind {
  q?: string
  type: IAdminPromotionFindTypeEnum[]
  categoryIds: number[]
  regionIds: number[]
  status: IAdminPromotionFindStatusEnum[]
  page: number
  /** @format date */
  startDate?: string
  /** @format date */
  endDate?: string
}

export interface IAdminPromotionDetailRO {
  participants: IClinicPromotionParticipantRO[]
  id: number
  type: IAdminPromotionDetailRoTypeEnum
  image: IAssetAssetROO11
  imageZhcn: IAssetAssetROO11Nullable
  imageZhtw: IAssetAssetROO11Nullable
  imageEn: IAssetAssetROO11Nullable
  imageJa: IAssetAssetROO11Nullable
  imageTh: IAssetAssetROO11Nullable
  status: IAdminPromotionDetailRoStatusEnum
  category: ICategoryROO7
  region: IRegionROO6Nullable
  /** @format date-time */
  startDate: string | null
  /** @format date-time */
  endDate: string | null
  title: string
  titleZhcn: string | null
  titleZhtw: string | null
  titleEn: string | null
  titleJa: string | null
  titleTh: string | null
  titleMn: string | null
  titleRu: string | null
  content: string
  contentZhcn: string | null
  contentZhtw: string | null
  contentEn: string | null
  contentJa: string | null
  contentTh: string | null
  contentMn: string | null
  contentRu: string | null
  discountRate: number | null
  originalPrice: number | null
  discountPrice: number | null
  hashtags: IClinicPromotionHashtagRO[]
  participantCount: number
  clinic: IClinicROO1Nullable
  /** @format date-time */
  createDate: string
}

export interface IClinicPromotionParticipantRO {
  id: number
  name: string
  email: string
  clinicName: string | null
  /** @format date-time */
  agreePrivacyDate: string
  /** @format date-time */
  createDate: string
  promotion: IClinicPromotionRO
  category: ICategoryROO7
}

export interface IClinicPromotionRO {
  id: number
  type: IClinicPromotionRoTypeEnum
  status: IClinicPromotionRoStatusEnum
  image: IAssetAssetROO11
  imageZhcn: IAssetAssetROO11Nullable
  imageZhtw: IAssetAssetROO11Nullable
  imageEn: IAssetAssetROO11Nullable
  imageJa: IAssetAssetROO11Nullable
  imageTh: IAssetAssetROO11Nullable
  category: ICategoryROO7
  region: IRegionROO6Nullable
  /** @format date-time */
  startDate: string | null
  /** @format date-time */
  endDate: string | null
  title: string
  titleZhcn: string | null
  titleZhtw: string | null
  titleEn: string | null
  titleJa: string | null
  titleTh: string | null
  titleMn: string | null
  titleRu: string | null
  content: string
  contentZhcn: string | null
  contentZhtw: string | null
  contentEn: string | null
  contentJa: string | null
  contentTh: string | null
  contentMn: string | null
  contentRu: string | null
  discountRate: number | null
  originalPrice: number | null
  discountPrice: number | null
  hashtags: IClinicPromotionHashtagRO[]
  clinic: IClinicROO1Nullable
  /** @format date-time */
  createDate: string
  participantCount: number
}

export interface IAdminPromotionSave {
  type: IAdminPromotionSaveTypeEnum
  imageId: number
  imageZhcnId?: number
  imageZhtwId?: number
  imageEnId?: number
  imageJaId?: number
  imageThId?: number
  categoryId: number
  clinicId?: number
  startDate: string
  endDate: string
  title: string
  titleZhcn?: string
  titleZhtw?: string
  titleEn?: string
  titleJa?: string
  titleTh?: string
  titleMn?: string
  titleRu?: string
  content: string
  contentZhcn?: string
  contentZhtw?: string
  contentEn?: string
  contentJa?: string
  contentTh?: string
  contentMn?: string
  contentRu?: string
  discountRate?: number
  originalPrice?: number
  discountPrice?: number
  tags: IClinicPromotionHashtagCreate[]
  isFinished?: boolean
}

export interface IClinicPromotionHashtagCreate {
  hashtag: string
  language: string
  order: number
}

export interface IAdminPaginationROIAdminQnaRO {
  rows: IAdminQnaRO[]
  count: number
}

export interface IAdminQnaRO {
  id: number
  title: string
  content: string
  inquiryStatus: IAdminQnaRoInquiryStatusEnum
  answer: string | null
  articleStatus: IAdminQnaRoArticleStatusEnum
  /** @format date-time */
  createDate: string
  author: IAdminUserROO6
}

export type IUserDataROO5Nullable = {
  name: string
  email: string | null
  nickname: string
  nation: string
  nationNumber: string
  phoneNumber: string
  birthYear: number
  birthMonth: number
  birthDay: number
  interestCategories: ICategoryROO8[]
  contactPoints: IContactPointROO5[]
  sns: ISnsROO5[]
  /** @format date-time */
  agreeTermsDate: string
  /** @format date-time */
  agreeRequiredPrivacyInfoDate: string
  /** @format date-time */
  agreeOptionalPrivacyInfoDate: string | null
  /** @format date-time */
  agreeMarketingInfoDate: string | null
  /** @format date-time */
  createDate: string
  isProfileCompleted: boolean
}

export type IClinicAdminROO5Nullable = {
  businessRegistrationNumber: string | null
  businessRegistrationCertificate: IAssetAssetROO12Nullable
  representativeName: string | null
  managerName: string | null
  managerPhone: string | null
  id: number
  ci: IAssetAssetROO12
  category: ICategoryROO8
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicAdminRoO5NullableStatusEnum
  region: IRegionROO7
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO7[]
  schedules: IClinicScheduleROO7[][]
  medicalCategories: IMedicalCategoryROO7[]
  wishlistCount: number
  isWishlisted: boolean
}

export type IAssetAssetROO12Nullable = {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IAdminUserROO6 {
  id: number
  role: IAdminUserRoO6RoleEnum
  status: IAdminUserRoO6StatusEnum
  email: string | null
  password: string | null
  /** @format date-time */
  createDate: string | null
  /** @format date-time */
  updateDate: string | null
  /** @format date-time */
  withdrawDate: string | null
  withdrawReason: string | null
  userData: IUserDataROO5Nullable
  clinic: IClinicAdminROO5Nullable
  oauthList: IAuthOAuthO5[]
}

export interface IUserDataROO5 {
  name: string
  email: string | null
  nickname: string
  nation: string
  nationNumber: string
  phoneNumber: string
  birthYear: number
  birthMonth: number
  birthDay: number
  interestCategories: ICategoryROO8[]
  contactPoints: IContactPointROO5[]
  sns: ISnsROO5[]
  /** @format date-time */
  agreeTermsDate: string
  /** @format date-time */
  agreeRequiredPrivacyInfoDate: string
  /** @format date-time */
  agreeOptionalPrivacyInfoDate: string | null
  /** @format date-time */
  agreeMarketingInfoDate: string | null
  /** @format date-time */
  createDate: string
  isProfileCompleted: boolean
}

export interface ICategoryROO8 {
  id: number
  order: number
  name: string
}

export interface IContactPointROO5 {
  id: number
  type: IContactPointRoO5TypeEnum
  value: string
  order: number
}

export interface ISnsROO5 {
  id: number
  type: ISnsRoO5TypeEnum
  value: string
  order: number
}

export interface IClinicAdminROO5 {
  businessRegistrationNumber: string | null
  businessRegistrationCertificate: IAssetAssetROO12Nullable
  representativeName: string | null
  managerName: string | null
  managerPhone: string | null
  id: number
  ci: IAssetAssetROO12
  category: ICategoryROO8
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicAdminRoO5StatusEnum
  region: IRegionROO7
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO7[]
  schedules: IClinicScheduleROO7[][]
  medicalCategories: IMedicalCategoryROO7[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface IAssetAssetROO12 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IRegionROO7 {
  id: number
  name: string
  order: number
}

export interface IClinicSnsROO7 {
  id: number
  type: IClinicSnsRoO7TypeEnum
  value: string
  order: number
}

export interface IClinicScheduleROO7 {
  day: IClinicScheduleRoO7DayEnum
  openingHour: number
  openingMinute: number
  closingHour: number
  closingMinute: number
  breakStartHour: number | null
  breakStartMinute: number | null
  breakEndHour: number | null
  breakEndMinute: number | null
  receptionStartHour: number | null
  receptionStartMinute: number | null
  receptionEndHour: number | null
  receptionEndMinute: number | null
  isRegularHoliday: boolean
}

export interface IMedicalCategoryROO7 {
  id: number
  order: number
  name: string
  language: string
}

export interface IAuthOAuthO5 {
  oauthProvider: IAuthOAuthO5OauthProviderEnum
  oauthEmail: string
}

export interface IAdminQnaFind {
  q?: string
  status?: IAdminQnaFindStatusEnum
  page: number
  pageSize: number
}

export interface IAdminQnaUpdate {
  articleStatus: IAdminQnaUpdateArticleStatusEnum
  inquiryStatus: IAdminQnaUpdateInquiryStatusEnum
  answer: string
}

export interface IReferralPartnerRO {
  id: number
  code: string
  slug: string
  name: string
  status: IReferralPartnerRoStatusEnum
  defaultLocale: IReferralPartnerRoDefaultLocaleEnum
  memo: string | null
  contactEmail: string | null
  ownerAdminId: number | null
  ownerAdminName: string | null
  /** @format date-time */
  createDate: string
  /** @format date-time */
  updateDate: string
}

export interface IAdminReferralPartnerFind {
  page: number
  q?: string
  status?: IAdminReferralPartnerFindStatusEnum
}

export interface IAdminReferralPartnerCheckCodeRO {
  available: boolean
  message?: string
}

export interface IAdminReferralPartnerCheckCode {
  code: string
  excludeId?: number
}

export interface IAdminReferralPartnerSave {
  code: string
  status: IAdminReferralPartnerSaveStatusEnum
  defaultLocale?: IAdminReferralPartnerSaveDefaultLocaleEnum
  memo?: string
  contactEmail?: string
  ownerAdminId?: number | null
}

export interface IAdminReferralRevenueRO {
  referralPartnerName: string
  id: number
  referralPartnerId: number
  consultationRequestId: number | null
  procedureName: string | null
  amount: string
  currency: string
  revenueDate: string
  memo: string | null
  /** @format date-time */
  createDate: string
  /** @format date-time */
  updateDate: string
}

export interface IAdminReferralRevenueFind {
  page: number
  referralPartnerId?: number
  fromDate?: string
  toDate?: string
}

export interface IAdminReferralRevenueSave {
  referralPartnerId: number
  consultationRequestId?: number
  amount: string
  currency?: string
  /** @format date */
  revenueDate: string
  memo?: string
}

export interface IAdminReferralRevenueUpdate {
  amount?: string
  currency?: string
  /** @format date */
  revenueDate?: string
  memo?: string
  consultationRequestId?: number | null
}

export interface IAdminReferralStatsRO {
  items: IAdminReferralStatsPartnerStats[]
}

export interface IAdminReferralStatsPartnerStats {
  referralPartnerId: number
  partnerCode: string
  partnerName: string
  visitCount: number
  consultationCount: number
  reservationCount: number
  revenueByCurrency: IAdminReferralStatsRevenueByCurrency[]
  totalRevenue: string
}

export interface IAdminReferralStatsRevenueByCurrency {
  currency: string
  amount: string
}

export interface IAdminReferralStatsFind {
  referralPartnerId?: number
  fromDate?: string
  toDate?: string
}

export interface IAdminReferralStatsRevenueDetailsRO {
  items: IAdminReferralStatsRevenueDetailRow[]
}

export interface IAdminReferralStatsRevenueDetailRow {
  consultationRequestId: number
  date: string
  patientName: string
  procedureName: string | null
  amount: string
  currency: string
}

export interface IAdminReferralStatsDetailFind {
  referralPartnerId: number
  fromDate?: string
  toDate?: string
}

export interface IAdminReferralStatsReservationDetailsRO {
  items: IAdminReferralStatsReservationDetailRow[]
}

export interface IAdminReferralStatsReservationDetailRow {
  consultationRequestId: number
  date: string
  patientName: string
  status: string
  procedureName: string | null
  amount: string | null
  currency: string | null
}

export interface IRegionROO8 {
  id: number
  name: string
  order: number
}

export interface IAdminRegionSave {
  name: string
  order: number
}

export interface IAdminPaginationROIAdminReportRO {
  rows: IAdminReportRO[]
  count: number
}

export interface IAdminReportRO {
  id: number
  user: IAdminUserROO7
  reason: IAdminReportRoReasonEnum
  status: IAdminReportRoStatusEnum
  description: string
  targetUrl: string | null
  /** @format date-time */
  createDate: string
  targetData: {
    id: number
    type: IAdminReportRoTypeEnum
    title: string
    content: string
  }
}

export type IUserDataROO6Nullable = {
  name: string
  email: string | null
  nickname: string
  nation: string
  nationNumber: string
  phoneNumber: string
  birthYear: number
  birthMonth: number
  birthDay: number
  interestCategories: ICategoryROO9[]
  contactPoints: IContactPointROO6[]
  sns: ISnsROO6[]
  /** @format date-time */
  agreeTermsDate: string
  /** @format date-time */
  agreeRequiredPrivacyInfoDate: string
  /** @format date-time */
  agreeOptionalPrivacyInfoDate: string | null
  /** @format date-time */
  agreeMarketingInfoDate: string | null
  /** @format date-time */
  createDate: string
  isProfileCompleted: boolean
}

export type IClinicAdminROO6Nullable = {
  businessRegistrationNumber: string | null
  businessRegistrationCertificate: IAssetAssetROO13Nullable
  representativeName: string | null
  managerName: string | null
  managerPhone: string | null
  id: number
  ci: IAssetAssetROO13
  category: ICategoryROO9
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicAdminRoO6NullableStatusEnum
  region: IRegionROO9
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO8[]
  schedules: IClinicScheduleROO8[][]
  medicalCategories: IMedicalCategoryROO8[]
  wishlistCount: number
  isWishlisted: boolean
}

export type IAssetAssetROO13Nullable = {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IAdminUserROO7 {
  id: number
  role: IAdminUserRoO7RoleEnum
  status: IAdminUserRoO7StatusEnum
  email: string | null
  password: string | null
  /** @format date-time */
  createDate: string | null
  /** @format date-time */
  updateDate: string | null
  /** @format date-time */
  withdrawDate: string | null
  withdrawReason: string | null
  userData: IUserDataROO6Nullable
  clinic: IClinicAdminROO6Nullable
  oauthList: IAuthOAuthO6[]
}

export interface IUserDataROO6 {
  name: string
  email: string | null
  nickname: string
  nation: string
  nationNumber: string
  phoneNumber: string
  birthYear: number
  birthMonth: number
  birthDay: number
  interestCategories: ICategoryROO9[]
  contactPoints: IContactPointROO6[]
  sns: ISnsROO6[]
  /** @format date-time */
  agreeTermsDate: string
  /** @format date-time */
  agreeRequiredPrivacyInfoDate: string
  /** @format date-time */
  agreeOptionalPrivacyInfoDate: string | null
  /** @format date-time */
  agreeMarketingInfoDate: string | null
  /** @format date-time */
  createDate: string
  isProfileCompleted: boolean
}

export interface ICategoryROO9 {
  id: number
  order: number
  name: string
}

export interface IContactPointROO6 {
  id: number
  type: IContactPointRoO6TypeEnum
  value: string
  order: number
}

export interface ISnsROO6 {
  id: number
  type: ISnsRoO6TypeEnum
  value: string
  order: number
}

export interface IClinicAdminROO6 {
  businessRegistrationNumber: string | null
  businessRegistrationCertificate: IAssetAssetROO13Nullable
  representativeName: string | null
  managerName: string | null
  managerPhone: string | null
  id: number
  ci: IAssetAssetROO13
  category: ICategoryROO9
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicAdminRoO6StatusEnum
  region: IRegionROO9
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO8[]
  schedules: IClinicScheduleROO8[][]
  medicalCategories: IMedicalCategoryROO8[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface IAssetAssetROO13 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IRegionROO9 {
  id: number
  name: string
  order: number
}

export interface IClinicSnsROO8 {
  id: number
  type: IClinicSnsRoO8TypeEnum
  value: string
  order: number
}

export interface IClinicScheduleROO8 {
  day: IClinicScheduleRoO8DayEnum
  openingHour: number
  openingMinute: number
  closingHour: number
  closingMinute: number
  breakStartHour: number | null
  breakStartMinute: number | null
  breakEndHour: number | null
  breakEndMinute: number | null
  receptionStartHour: number | null
  receptionStartMinute: number | null
  receptionEndHour: number | null
  receptionEndMinute: number | null
  isRegularHoliday: boolean
}

export interface IMedicalCategoryROO8 {
  id: number
  order: number
  name: string
  language: string
}

export interface IAuthOAuthO6 {
  oauthProvider: IAuthOAuthO6OauthProviderEnum
  oauthEmail: string
}

export interface IAdminReportFind {
  page: number
  pageSize: number
  q?: string
  status?: IAdminReportFindStatusEnum
  reason?: IAdminReportFindReasonEnum
}

export interface IAdminReportUpdate {
  status: IAdminReportUpdateStatusEnum
}

export type IUserDataROO7Nullable = {
  name: string
  email: string | null
  nickname: string
  nation: string
  nationNumber: string
  phoneNumber: string
  birthYear: number
  birthMonth: number
  birthDay: number
  interestCategories: ICategoryROO10[]
  contactPoints: IContactPointROO7[]
  sns: ISnsROO7[]
  /** @format date-time */
  agreeTermsDate: string
  /** @format date-time */
  agreeRequiredPrivacyInfoDate: string
  /** @format date-time */
  agreeOptionalPrivacyInfoDate: string | null
  /** @format date-time */
  agreeMarketingInfoDate: string | null
  /** @format date-time */
  createDate: string
  isProfileCompleted: boolean
}

export type IClinicAdminROO7Nullable = {
  businessRegistrationNumber: string | null
  businessRegistrationCertificate: IAssetAssetROO14Nullable
  representativeName: string | null
  managerName: string | null
  managerPhone: string | null
  id: number
  ci: IAssetAssetROO14
  category: ICategoryROO10
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicAdminRoO7NullableStatusEnum
  region: IRegionROO10
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO9[]
  schedules: IClinicScheduleROO9[][]
  medicalCategories: IMedicalCategoryROO9[]
  wishlistCount: number
  isWishlisted: boolean
}

export type IAssetAssetROO14Nullable = {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IAdminUserROO8 {
  id: number
  role: IAdminUserRoO8RoleEnum
  status: IAdminUserRoO8StatusEnum
  email: string | null
  password: string | null
  /** @format date-time */
  createDate: string | null
  /** @format date-time */
  updateDate: string | null
  /** @format date-time */
  withdrawDate: string | null
  withdrawReason: string | null
  userData: IUserDataROO7Nullable
  clinic: IClinicAdminROO7Nullable
  oauthList: IAuthOAuthO7[]
}

export interface IUserDataROO7 {
  name: string
  email: string | null
  nickname: string
  nation: string
  nationNumber: string
  phoneNumber: string
  birthYear: number
  birthMonth: number
  birthDay: number
  interestCategories: ICategoryROO10[]
  contactPoints: IContactPointROO7[]
  sns: ISnsROO7[]
  /** @format date-time */
  agreeTermsDate: string
  /** @format date-time */
  agreeRequiredPrivacyInfoDate: string
  /** @format date-time */
  agreeOptionalPrivacyInfoDate: string | null
  /** @format date-time */
  agreeMarketingInfoDate: string | null
  /** @format date-time */
  createDate: string
  isProfileCompleted: boolean
}

export interface ICategoryROO10 {
  id: number
  order: number
  name: string
}

export interface IContactPointROO7 {
  id: number
  type: IContactPointRoO7TypeEnum
  value: string
  order: number
}

export interface ISnsROO7 {
  id: number
  type: ISnsRoO7TypeEnum
  value: string
  order: number
}

export interface IClinicAdminROO7 {
  businessRegistrationNumber: string | null
  businessRegistrationCertificate: IAssetAssetROO14Nullable
  representativeName: string | null
  managerName: string | null
  managerPhone: string | null
  id: number
  ci: IAssetAssetROO14
  category: ICategoryROO10
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicAdminRoO7StatusEnum
  region: IRegionROO10
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO9[]
  schedules: IClinicScheduleROO9[][]
  medicalCategories: IMedicalCategoryROO9[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface IAssetAssetROO14 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IRegionROO10 {
  id: number
  name: string
  order: number
}

export interface IClinicSnsROO9 {
  id: number
  type: IClinicSnsRoO9TypeEnum
  value: string
  order: number
}

export interface IClinicScheduleROO9 {
  day: IClinicScheduleRoO9DayEnum
  openingHour: number
  openingMinute: number
  closingHour: number
  closingMinute: number
  breakStartHour: number | null
  breakStartMinute: number | null
  breakEndHour: number | null
  breakEndMinute: number | null
  receptionStartHour: number | null
  receptionStartMinute: number | null
  receptionEndHour: number | null
  receptionEndMinute: number | null
  isRegularHoliday: boolean
}

export interface IMedicalCategoryROO9 {
  id: number
  order: number
  name: string
  language: string
}

export interface IAuthOAuthO7 {
  oauthProvider: IAuthOAuthO7OauthProviderEnum
  oauthEmail: string
}

export interface IAdminUserFindO1 {
  q?: string
  page: number
  role?: IAdminUserFindO1RoleEnum
  status?: IAdminUserFindO1StatusEnum
  type: IAdminUserFindO1TypeEnum
  nation?: string
  pageSize?: number
}

export interface IAdminUserUpdateO1 {
  role: IAdminUserUpdateO1RoleEnum
  status: IAdminUserUpdateO1StatusEnum
  email?: string
  password?: string
  withdrawReason?: string
  userData?: {
    name: string
    nickname: string
    nation: string
    nationNumber: string
    phoneNumber: string
    birthYear: number
    birthMonth: number
    birthDay: number
    interestCategories: number[]
    contactPoints: {
      type: IAdminUserUpdateO1TypeEnum
      value: string
      order: number
    }[]
    sns: {
      type: IAdminUserUpdateO1TypeEnum1
      value: string
      order: number
    }[]
  }
  clinic?: {
    ciId: number
    categoryId: number
    name: string
    nameZhcn?: string
    nameZhtw?: string
    nameEn?: string
    nameJa?: string
    nameTh?: string
    address: string
    addressZhcn?: string
    addressZhtw?: string
    addressEn?: string
    addressJa?: string
    addressTh?: string
    addressDetail: string
    addressDetailZhcn?: string
    addressDetailZhtw?: string
    addressDetailEn?: string
    addressDetailJa?: string
    addressDetailTh?: string
    regionId: number
    phone: string
    schedules: {
      day: IAdminUserUpdateO1DayEnum
      isRegularHoliday: boolean
      openingHour: number
      openingMinute: number
      closingHour: number
      closingMinute: number
      breakStartHour?: number
      breakStartMinute?: number
      breakEndHour?: number
      breakEndMinute?: number
      receptionStartHour?: number
      receptionStartMinute?: number
      receptionEndHour?: number
      receptionEndMinute?: number
    }[]
    sns: {
      type: IAdminUserUpdateO1TypeEnum2
      value: string
      order: number
    }[]
    clinicImages: {
      assetId: number
      isMain: boolean
      order: number
    }[]
    clinicDoctorProfiles: {
      status: IAdminUserUpdateO1StatusEnum1
      name: string
      content: string
      youtubeURL?: string
      qna: IClinicDoctorProfileQnaO2[]
      images: {
        assetId: number
        order: number
        isMain: boolean
      }[]
      tempData: {
        request: IClinicDoctorProfileSave
        response: IClinicDoctorProfileROO1
      } | null
    }[]
    medicalCategories: {
      name: string
      order: number
      language: IAdminUserUpdateO1LanguageEnum
    }[]
    medicalImages: {
      assetId: number
      order: number
    }[]
  }
}

export interface IClinicDoctorProfileQnaO2 {
  question: string
  answer: string
  language: string
}

export interface IClinicDoctorProfileSave {
  name: string
  nameZhcn?: string
  nameZhtw?: string
  nameEn?: string
  nameJa?: string
  nameTh?: string
  nameMn?: string
  nameRu?: string
  content: string
  contentZhcn?: string
  contentZhtw?: string
  contentEn?: string
  contentJa?: string
  contentTh?: string
  contentMn?: string
  contentRu?: string
  youtubeURL: string | null
  images: IClinicDoctorProfileImageSave[]
  qna: IClinicDoctorProfileQnaO2[] | null
}

export interface IClinicDoctorProfileImageSave {
  imageId: number
  isMain: boolean
  order: number
}

export type IClinicDoctorProfileTempROO1Nullable = {
  request: IClinicDoctorProfileQnaO2[] | null
  response: IClinicDoctorProfileROO1
}

export interface IClinicDoctorProfileROO1 {
  id: number
  status: IClinicDoctorProfileRoO1StatusEnum
  name: string
  nameZhcn?: string | null
  nameZhtw?: string | null
  nameEn?: string | null
  nameJa?: string | null
  nameTh?: string | null
  nameMn?: string | null
  nameRu?: string | null
  content: string
  contentZhcn?: string | null
  contentZhtw?: string | null
  contentEn?: string | null
  contentJa?: string | null
  contentTh?: string | null
  contentMn?: string | null
  contentRu?: string | null
  qna: IClinicDoctorProfileQnaO2[] | null
  youtubeURL: string | null
  images: IClinicDoctorProfileImageROO1[]
  clinic: IClinicROO2
  tempData: IClinicDoctorProfileTempROO1Nullable
  /** @format date-time */
  approveDate: string | null
  /** @format date-time */
  updateDate: string | null
  /** @format date-time */
  rejectDate: string | null
  rejectReason: string | null
  /** @format date-time */
  createDate: string
}

export interface IClinicDoctorProfileImageROO1 {
  id: number
  image: IAssetAssetROO14
  isMain: boolean
  order: number
}

export interface IClinicROO2 {
  id: number
  ci: IAssetAssetROO14
  category: ICategoryROO10
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicRoO2StatusEnum
  region: IRegionROO10
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO9[]
  schedules: IClinicScheduleROO9[][]
  medicalCategories: IMedicalCategoryROO9[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface IClinicDoctorProfileTempROO1 {
  request: IClinicDoctorProfileQnaO2[] | null
  response: IClinicDoctorProfileROO1
}

export interface IBusinessInquiryRO {
  id: number
  clinicName: string
  name: string
  position: string | null
  phoneNumber: string
  email: string | null
  content: string
  /** @format date-time */
  createDate: string
}

export interface IBusinessInquiryCreate {
  clinicName: string
  name: string
  position?: string
  phoneNumber: string
  email?: string
  content: string
}

export interface IReferralPartnerResolveRO {
  code: string
  name: string
  active: boolean
  defaultLocale: IReferralPartnerResolveRoDefaultLocaleEnum
}

export interface IReferralPartnerResolveBySlug {
  slug: string
}

export interface IReferralPartnerValidateRO {
  code: string
  active: boolean
}

export interface IReferralPartnerValidateByCode {
  code: string
}

/** 공개 상담 폼 등 — 활성 파트너 코드 목록 */
export interface IReferralPartnerPublicListItem {
  code: string
}

export interface IReferralVisitTrack {
  code: string
  source: IReferralVisitTrackSourceEnum
  landingPath?: string
}

export type IConsultationFormPayloadDataO1Nullable = {
  firstMiddleName: string
  lastName: string
  gender: IConsultationFormPayloadDataO1NullableGenderEnum
  birthDate: string
  preferredLanguage: string
  preferredLanguageOther?: string
  messengers: IConsultationFormPayloadMessengerContactO1[]
  procedureAreas: string[]
  procedureOther?: string
  improvementDescription: string
  budget: string
  plannedTiming: string
  previousSurgery: string
  medicalHistory: string
  currentMedications: string
  flightBooked: IConsultationFormPayloadDataO1NullableFlightBookedEnum
  preferredConsultationDate: string
  preferredSurgeryDate: string
  photoAssetIds: number[]
} | null

export interface IConsultationRequestRO {
  id: number
  referrerCodeSnapshot: string | null
  referralPartnerId: number | null
  name: string
  phone: string
  email: string
  message: string
  nationality: string | null
  preferredClinic: string | null
  preferredVisitDate: string | null
  preferredContactChannel: string | null
  channel: IConsultationRequestRoChannelEnum
  status: IConsultationRequestRoStatusEnum
  /** @format date-time */
  reservationConfirmedAt: string | null
  formPayload: IConsultationFormPayloadDataO1Nullable
  /** @format date-time */
  createDate: string
}

export interface IConsultationFormPayloadDataO1 {
  firstMiddleName: string
  lastName: string
  gender: IConsultationFormPayloadDataO1GenderEnum
  birthDate: string
  preferredLanguage: string
  preferredLanguageOther?: string
  messengers: IConsultationFormPayloadMessengerContactO1[]
  procedureAreas: string[]
  procedureOther?: string
  improvementDescription: string
  budget: string
  plannedTiming: string
  previousSurgery: string
  medicalHistory: string
  currentMedications: string
  flightBooked: IConsultationFormPayloadDataO1FlightBookedEnum
  preferredConsultationDate: string
  preferredSurgeryDate: string
  photoAssetIds: number[]
}

export interface IConsultationFormPayloadMessengerContactO1 {
  type: string
  typeOther?: string
  contact: string
}

export interface IConsultationRequestCreate {
  name: string
  phone: string
  email: string
  message: string
  nationality?: string
  preferredClinic?: string
  preferredVisitDate?: string
  preferredContactChannel?: string
  referrerCode?: string
  channel?: IConsultationRequestCreateChannelEnum
  formPayload?: IConsultationFormPayloadDataO1
}

export interface ICategoryROO11 {
  id: number
  order: number
  name: string
}

export interface ICategoryFind {
  includeCommon?: boolean
}

export interface IRegionROO11 {
  id: number
  name: string
  order: number
}

export interface IPaginationROIMediaROnumber {
  rows: IMediaRO[]
  count: number
  cursor: number | null
}

export interface IMediaRO {
  id: number
  link: string
}

export interface IMediaFind {
  type: IMediaFindTypeEnum
  categoryIds: number[]
  regionIds: number[]
  search?: string
  page?: number
  cursor?: number
}

export interface IBannerROO1 {
  id: number
  language: IBannerRoO1LanguageEnum
  order: number
  image: IAssetAssetROO15
  link: string | null
}

export interface IAssetAssetROO15 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface INoticeROO1 {
  id: number
  title: string
  content: string
  active: boolean
  order: number
}

export interface IFooterIconROO1 {
  id: number
  order: number
  icon: IAssetAssetROO15
  krLink: string | null
  zhLink: string | null
  jpLink: string | null
  enLink: string | null
  thLink: string | null
  side: IFooterIconRoO1SideEnum
}

export interface IErrorLogRO {
  id: number
  route: string
  content: string
  /** @format date-time */
  createDate: string
}

export interface IErrorLogCreate {
  route: string
  content: string
}

export type IClinicDoctorProfileTempROO3Nullable = {
  request: IClinicDoctorProfileQnaO4[] | null
  response: IClinicDoctorProfileROO3
}

export interface IClinicDoctorProfileROO3 {
  id: number
  status: IClinicDoctorProfileRoO3StatusEnum
  name: string
  nameZhcn?: string | null
  nameZhtw?: string | null
  nameEn?: string | null
  nameJa?: string | null
  nameTh?: string | null
  nameMn?: string | null
  nameRu?: string | null
  content: string
  contentZhcn?: string | null
  contentZhtw?: string | null
  contentEn?: string | null
  contentJa?: string | null
  contentTh?: string | null
  contentMn?: string | null
  contentRu?: string | null
  qna: IClinicDoctorProfileQnaO4[] | null
  youtubeURL: string | null
  images: IClinicDoctorProfileImageROO3[]
  clinic: IClinicROO4
  tempData: IClinicDoctorProfileTempROO3Nullable
  /** @format date-time */
  approveDate: string | null
  /** @format date-time */
  updateDate: string | null
  /** @format date-time */
  rejectDate: string | null
  rejectReason: string | null
  /** @format date-time */
  createDate: string
}

export interface IClinicDoctorProfileQnaO4 {
  question: string
  answer: string
  language: string
}

export interface IClinicDoctorProfileImageROO3 {
  id: number
  image: IAssetAssetROO16
  isMain: boolean
  order: number
}

export interface IAssetAssetROO16 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IClinicROO4 {
  id: number
  ci: IAssetAssetROO16
  category: ICategoryROO12
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicRoO4StatusEnum
  region: IRegionROO12
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO11[]
  schedules: IClinicScheduleROO11[][]
  medicalCategories: IMedicalCategoryROO11[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface ICategoryROO12 {
  id: number
  order: number
  name: string
}

export interface IRegionROO12 {
  id: number
  name: string
  order: number
}

export interface IClinicSnsROO11 {
  id: number
  type: IClinicSnsRoO11TypeEnum
  value: string
  order: number
}

export interface IClinicScheduleROO11 {
  day: IClinicScheduleRoO11DayEnum
  openingHour: number
  openingMinute: number
  closingHour: number
  closingMinute: number
  breakStartHour: number | null
  breakStartMinute: number | null
  breakEndHour: number | null
  breakEndMinute: number | null
  receptionStartHour: number | null
  receptionStartMinute: number | null
  receptionEndHour: number | null
  receptionEndMinute: number | null
  isRegularHoliday: boolean
}

export interface IMedicalCategoryROO11 {
  id: number
  order: number
  name: string
  language: string
}

export interface IClinicDoctorProfileTempROO3 {
  request: IClinicDoctorProfileQnaO4[] | null
  response: IClinicDoctorProfileROO3
}

export interface IClinicDoctorProfileSaveO1 {
  name: string
  nameZhcn?: string
  nameZhtw?: string
  nameEn?: string
  nameJa?: string
  nameTh?: string
  nameMn?: string
  nameRu?: string
  content: string
  contentZhcn?: string
  contentZhtw?: string
  contentEn?: string
  contentJa?: string
  contentTh?: string
  contentMn?: string
  contentRu?: string
  youtubeURL: string | null
  images: IClinicDoctorProfileImageSaveO1[]
  qna: IClinicDoctorProfileQnaO4[] | null
}

export interface IClinicDoctorProfileImageSaveO1 {
  imageId: number
  isMain: boolean
  order: number
}

export interface IPaginationROIClinicDoctorProfileROnumber {
  rows: IClinicDoctorProfileROO3[]
  count: number
  cursor: number | null
}

export interface IClinicDoctorProfileFind {
  order: IClinicDoctorProfileFindOrderEnum
  categoryIds: number[]
  regionIds: number[]
  keyword?: string
  page?: number
  cursor?: number
  interviewOnly?: boolean
}

export interface IClinicDoctorProfileFindMyInterviews {
  status: IClinicDoctorProfileFindMyInterviewsStatusEnum[]
  page?: number
  cursor?: number
}

export interface IPaginationROICommunityArticleArticleListROstring {
  rows: ICommunityArticleArticleListRO[]
  count: number
  cursor: string | null
}

export type ICategoryROO13Nullable = {
  id: number
  order: number
  name: string
} | null

export type IRegionROO13Nullable = {
  id: number
  name: string
  order: number
} | null

export interface ICommunityArticleArticleListRO {
  board: ICommunityBoardSimpleROO1
  category: ICategoryROO13Nullable
  author: IUserRO
  viewCount: number
  likeCount: number
  commentCount: number
  isBookmarked: boolean
  isLiked: boolean
  region: IRegionROO13Nullable
  inquiryStatus: ICommunityArticleArticleListRoInquiryStatusEnum
  answer: string | null
  articleId: string
  title: string
  /** @format date-time */
  createDate: string
  /** @format date-time */
  updateDate: string | null
}

export interface ICommunityBoardSimpleROO1 {
  id: number
  slug: string
  title: string
}

export interface ICategoryROO13 {
  id: number
  order: number
  name: string
}

export interface IUserRO {
  id: number
  nickname: string
  /** 컨텐츠 작성자 관리자 유무 확인용 */
  isAdmin: boolean
}

export interface IRegionROO13 {
  id: number
  name: string
  order: number
}

export interface IClinicExperienceSearchQuery {
  pageSize: number
  keyword?: string
  page?: number
  cursor?: string
  orderBy?: IClinicExperienceSearchQueryOrderByEnum
  categoryIds?: number[]
  regionId?: number
}

export interface ICommunityArticleSiblingsRO {
  prevArticleId: string | null
  nextArticleId: string | null
}

export interface ICommunityArticleSiblingsQuery {
  slug?: string
  categoryId?: number
  regionId?: number
  orderBy?: ICommunityArticleSiblingsQueryOrderByEnum
  rangeType?: ICommunityArticleSiblingsQueryRangeTypeEnum
}

export interface ICommunityArticleArticleDetailRO {
  board: ICommunityBoardSimpleROO1
  author: IUserRO
  category: ICategoryROO13Nullable
  tags: ICommunityArticleTagROO1[]
  viewCount: number
  likeCount: number
  commentCount: number
  isBookmarked: boolean
  isLiked: boolean
  content: string
  prevArticleId: string | null
  nextArticleId: string | null
  region: IRegionROO13Nullable
  inquiryStatus: ICommunityArticleArticleDetailRoInquiryStatusEnum
  answer: string | null
  articleId: string
  title: string
  /** @format date-time */
  createDate: string
  /** @format date-time */
  updateDate: string | null
}

export interface ICommunityArticleTagROO1 {
  id: number
  title: string
}

export interface ICommunityArticleCreate {
  title: string
  content: string
  slug: string
  categoryId: number
  regionId?: number
}

export interface ICommunityArticleUpdate {
  title: string
  content: string
  categoryId: number
  regionId?: number
}

export interface ICommunityArticleShare {
  shareType: ICommunityArticleShareShareTypeEnum
}

export interface IPaginationROICommentCommentROstring {
  rows: ICommentCommentRO[]
  count: number
  cursor: string | null
}

export type ICommentCommentRONullable = {
  id: number
  content: string
  /** @format date-time */
  createDate: string
  /** @format date-time */
  updateDate: string | null
  author: IUserROO1
  parent: ICommentCommentRONullable
}

export interface ICommentCommentRO {
  id: number
  content: string
  /** @format date-time */
  createDate: string
  /** @format date-time */
  updateDate: string | null
  author: IUserROO1
  parent: ICommentCommentRONullable
}

export interface IUserROO1 {
  id: number
  nickname: string
  /** 컨텐츠 작성자 관리자 유무 확인용 */
  isAdmin: boolean
}

export interface ICommentCommentSearchQueryByArticle {
  articleId: string
  cursor?: string
  page?: number
  pageSize: number
}

export interface ICommentCommentCreate {
  /** @minLength 1 */
  content: string
  articleId: string
  parentId?: number
}

export interface ICommentCommentUpdate {
  /** @minLength 1 */
  content: string
}

export interface IClinicNewEquipmentSiblingsRO {
  prevArticleId: string | null
  nextArticleId: string | null
}

export interface IClinicNewEquipmentSiblingsQuery {
  categoryId?: number
  regionId?: number
  orderBy?: IClinicNewEquipmentSiblingsQueryOrderByEnum
}

export type IClinicNewEquipmentTempRONullable = {
  request: IClinicNewEquipmentSave
  response: IClinicNewEquipmentRO
} | null

export interface IClinicNewEquipmentRO {
  articleId: string
  status: IClinicNewEquipmentRoStatusEnum
  title: string
  titleZhcn: string | null
  titleZhtw: string | null
  titleEn: string | null
  titleJa: string | null
  titleTh: string | null
  titleMn: string | null
  titleRu: string | null
  content: string
  contentZhcn: string | null
  contentZhtw: string | null
  contentEn: string | null
  contentJa: string | null
  contentTh: string | null
  contentMn: string | null
  contentRu: string | null
  images: IClinicNewEquipmentImageROO1[]
  tempData: IClinicNewEquipmentTempRONullable
  /** @format date-time */
  approveDate: string | null
  /** @format date-time */
  updateDate: string | null
  /** @format date-time */
  rejectDate: string | null
  rejectReason: string | null
  /** @format date-time */
  createDate: string
  commentCount: number
  likeCount: number
  viewCount: number
  shareCount: number
  isLiked?: boolean
  prevArticleId: string | null
  nextArticleId: string | null
  clinic: IClinicROO7
}

export interface IClinicNewEquipmentImageROO1 {
  id: number
  image: IAssetAssetROO19
  isMain: boolean
  order: number
}

export interface IAssetAssetROO19 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IClinicNewEquipmentTempRO {
  request: IClinicNewEquipmentSave
  response: IClinicNewEquipmentRO
}

export interface IClinicNewEquipmentSave {
  title: string
  titleZhcn?: string | null
  titleZhtw?: string | null
  titleEn?: string | null
  titleJa?: string | null
  titleTh?: string | null
  titleMn?: string | null
  titleRu?: string | null
  content: string
  contentZhcn?: string | null
  contentZhtw?: string | null
  contentEn?: string | null
  contentJa?: string | null
  contentTh?: string | null
  contentMn?: string | null
  contentRu?: string | null
  images: IClinicNewEquipmentImageSave[]
}

export interface IClinicNewEquipmentImageSave {
  imageId: number
  isMain: boolean
  order: number
}

export interface IClinicROO7 {
  id: number
  ci: IAssetAssetROO19
  category: ICategoryROO15
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicRoO7StatusEnum
  region: IRegionROO15
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO14[]
  schedules: IClinicScheduleROO14[][]
  medicalCategories: IMedicalCategoryROO14[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface ICategoryROO15 {
  id: number
  order: number
  name: string
}

export interface IRegionROO15 {
  id: number
  name: string
  order: number
}

export interface IClinicSnsROO14 {
  id: number
  type: IClinicSnsRoO14TypeEnum
  value: string
  order: number
}

export interface IClinicScheduleROO14 {
  day: IClinicScheduleRoO14DayEnum
  openingHour: number
  openingMinute: number
  closingHour: number
  closingMinute: number
  breakStartHour: number | null
  breakStartMinute: number | null
  breakEndHour: number | null
  breakEndMinute: number | null
  receptionStartHour: number | null
  receptionStartMinute: number | null
  receptionEndHour: number | null
  receptionEndMinute: number | null
  isRegularHoliday: boolean
}

export interface IMedicalCategoryROO14 {
  id: number
  order: number
  name: string
  language: string
}

export interface IClinicNewEquipmentFind {
  order: IClinicNewEquipmentFindOrderEnum
  categoryIds: number[]
  regionIds: number[]
  keyword?: string
  page?: number
  cursor?: number
}

export interface IPaginationROIClinicNewEquipmentROnumber {
  rows: IClinicNewEquipmentRO[]
  count: number
  cursor: number | null
}

export interface IClinicNewEquipmentFindMyEquipments {
  status?: IClinicNewEquipmentFindMyEquipmentsStatusEnum[]
  page?: number
  cursor?: number
}

export interface ICommunityArticleShareO1 {
  shareType: ICommunityArticleShareO1ShareTypeEnum
}

export interface IPaginationROIClinicPromotionROnumber {
  rows: IClinicPromotionROO1[]
  count: number
  cursor: number | null
}

export type IAssetAssetROO20Nullable = {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export type IRegionROO16Nullable = {
  id: number
  name: string
  order: number
} | null

export type IClinicROO8Nullable = {
  id: number
  ci: IAssetAssetROO20
  category: ICategoryROO16
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicRoO8NullableStatusEnum
  region: IRegionROO16
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO15[]
  schedules: IClinicScheduleROO15[][]
  medicalCategories: IMedicalCategoryROO15[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface IClinicPromotionROO1 {
  id: number
  type: IClinicPromotionRoO1TypeEnum
  status: IClinicPromotionRoO1StatusEnum
  image: IAssetAssetROO20
  imageZhcn: IAssetAssetROO20Nullable
  imageZhtw: IAssetAssetROO20Nullable
  imageEn: IAssetAssetROO20Nullable
  imageJa: IAssetAssetROO20Nullable
  imageTh: IAssetAssetROO20Nullable
  category: ICategoryROO16
  region: IRegionROO16Nullable
  /** @format date-time */
  startDate: string | null
  /** @format date-time */
  endDate: string | null
  title: string
  titleZhcn: string | null
  titleZhtw: string | null
  titleEn: string | null
  titleJa: string | null
  titleTh: string | null
  titleMn: string | null
  titleRu: string | null
  content: string
  contentZhcn: string | null
  contentZhtw: string | null
  contentEn: string | null
  contentJa: string | null
  contentTh: string | null
  contentMn: string | null
  contentRu: string | null
  discountRate: number | null
  originalPrice: number | null
  discountPrice: number | null
  hashtags: IClinicPromotionHashtagROO1[]
  clinic: IClinicROO8Nullable
  /** @format date-time */
  createDate: string
  participantCount: number
}

export interface IAssetAssetROO20 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface ICategoryROO16 {
  id: number
  order: number
  name: string
}

export interface IRegionROO16 {
  id: number
  name: string
  order: number
}

export interface IClinicPromotionHashtagROO1 {
  id: number
  hashtag: string
  language: string
  order: number
}

export interface IClinicROO8 {
  id: number
  ci: IAssetAssetROO20
  category: ICategoryROO16
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicRoO8StatusEnum
  region: IRegionROO16
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO15[]
  schedules: IClinicScheduleROO15[][]
  medicalCategories: IMedicalCategoryROO15[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface IClinicSnsROO15 {
  id: number
  type: IClinicSnsRoO15TypeEnum
  value: string
  order: number
}

export interface IClinicScheduleROO15 {
  day: IClinicScheduleRoO15DayEnum
  openingHour: number
  openingMinute: number
  closingHour: number
  closingMinute: number
  breakStartHour: number | null
  breakStartMinute: number | null
  breakEndHour: number | null
  breakEndMinute: number | null
  receptionStartHour: number | null
  receptionStartMinute: number | null
  receptionEndHour: number | null
  receptionEndMinute: number | null
  isRegularHoliday: boolean
}

export interface IMedicalCategoryROO15 {
  id: number
  order: number
  name: string
  language: string
}

export interface IClinicPromotionFind {
  order: IClinicPromotionFindOrderEnum
  types: IClinicPromotionFindTypesEnum[]
  categoryIds: number[]
  regionIds: number[]
  keyword?: string
  page?: number
  cursor?: number
}

export interface IClinicPromotionParticipantROO1 {
  id: number
  name: string
  email: string
  clinicName: string | null
  /** @format date-time */
  agreePrivacyDate: string
  /** @format date-time */
  createDate: string
  promotion: IClinicPromotionROO1
  category: ICategoryROO16
}

export interface IClinicPromotionParticipantParticipate {
  promotionId: number
  categoryId: number
  name: string
  email: string
}

export type IAssetAssetROO21Nullable = {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IClinicReviewRO {
  articleId: string
  type: IClinicReviewRoTypeEnum
  category: ICategoryROO17
  clinic: IClinicROO9
  score: number
  content: string
  beforeImage: IAssetAssetROO21Nullable
  afterImage: IAssetAssetROO21Nullable
  images: IClinicReviewImageRO[]
  hashtags: IReviewHashtagRO[]
  likeCount: number
  viewCount: number
  commentCount: number
  /** @format date-time */
  createDate: string
  isLiked: boolean
  prevArticleId: string | null
  nextArticleId: string | null
  reelsLink: string | null
  tiktokLink: string | null
  shortsLink: string | null
}

export interface ICategoryROO17 {
  id: number
  order: number
  name: string
}

export interface IClinicROO9 {
  id: number
  ci: IAssetAssetROO21
  category: ICategoryROO17
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicRoO9StatusEnum
  region: IRegionROO17
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO16[]
  schedules: IClinicScheduleROO16[][]
  medicalCategories: IMedicalCategoryROO16[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface IAssetAssetROO21 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IRegionROO17 {
  id: number
  name: string
  order: number
}

export interface IClinicSnsROO16 {
  id: number
  type: IClinicSnsRoO16TypeEnum
  value: string
  order: number
}

export interface IClinicScheduleROO16 {
  day: IClinicScheduleRoO16DayEnum
  openingHour: number
  openingMinute: number
  closingHour: number
  closingMinute: number
  breakStartHour: number | null
  breakStartMinute: number | null
  breakEndHour: number | null
  breakEndMinute: number | null
  receptionStartHour: number | null
  receptionStartMinute: number | null
  receptionEndHour: number | null
  receptionEndMinute: number | null
  isRegularHoliday: boolean
}

export interface IMedicalCategoryROO16 {
  id: number
  order: number
  name: string
  language: string
}

export interface IClinicReviewImageRO {
  id: number
  image: IAssetAssetROO21
  isMain: boolean
  order: number
}

export interface IReviewHashtagRO {
  id: number
  hashtag: string
  order: number
}

export interface IClinicReviewCreate {
  type: IClinicReviewCreateTypeEnum
  categoryId: number
  clinicId: number
  images: {
    id: number
    order: number
    isMain: boolean
  }[]
  beforeImageId?: number
  afterImageId?: number
  hashtags: {
    order: number
    hashtag: string
  }[]
  score: number
  content: string
  reelsLink?: string
  tiktokLink?: string
  shortsLink?: string
}

export interface IPaginationROIClinicReviewROnumber {
  rows: IClinicReviewRO[]
  count: number
  cursor: number | null
}

export interface IClinicReviewFindMyClinicReview {
  /** @format date */
  startDate?: string
  /** @format date */
  endDate?: string
  types: IClinicReviewFindMyClinicReviewTypesEnum[]
  page?: number
  cursor?: number
}

export interface IPaginationROIClinicReviewROstringnumber {
  rows: IClinicReviewRO[]
  count: number
  cursor: string | null | number | null
}

export interface IClinicReviewFindClinicReview {
  types: IClinicReviewFindClinicReviewTypesEnum[]
  page?: number
  cursor?: number
  order: IClinicReviewFindClinicReviewOrderEnum
  categoryIds: number[]
  q?: string
  clinicId?: number
  pageSize?: number
}

export interface IClinicReviewDetailRO {
  author: IUserROO2
  articleId: string
  type: IClinicReviewDetailRoTypeEnum
  category: ICategoryROO17
  clinic: IClinicROO9
  score: number
  content: string
  beforeImage: IAssetAssetROO21Nullable
  afterImage: IAssetAssetROO21Nullable
  images: IClinicReviewImageRO[]
  hashtags: IReviewHashtagRO[]
  likeCount: number
  viewCount: number
  commentCount: number
  /** @format date-time */
  createDate: string
  isLiked: boolean
  prevArticleId: string | null
  nextArticleId: string | null
  reelsLink: string | null
  tiktokLink: string | null
  shortsLink: string | null
}

export interface IUserROO2 {
  id: number
  nickname: string
  /** 컨텐츠 작성자 관리자 유무 확인용 */
  isAdmin: boolean
}

export interface IClinicReviewSiblingsRO {
  prevArticleId: string | null
  nextArticleId: string | null
}

export interface IClinicReviewSiblingsQuery {
  categoryId?: number
  orderBy?: IClinicReviewSiblingsQueryOrderByEnum
  type?: IClinicReviewSiblingsQueryTypeEnum
}

export interface ICommunityArticleShareO2 {
  shareType: ICommunityArticleShareO2ShareTypeEnum
}

export interface IClinicWishlistToggleRO {
  isWishlisted: boolean
  wishlistCount: number
}

export interface IPaginationROIClinicWishlistROnumber {
  rows: IClinicWishlistRO[]
  count: number
  cursor: number | null
}

export interface IClinicWishlistRO {
  id: number
  clinic: IClinicROO10
  user: IClinicWishlistUserRO
  /** @format date-time */
  createDate: string
}

export interface IClinicROO10 {
  id: number
  ci: IAssetAssetROO22
  category: ICategoryROO18
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicRoO10StatusEnum
  region: IRegionROO18
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO17[]
  schedules: IClinicScheduleROO17[][]
  medicalCategories: IMedicalCategoryROO17[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface IAssetAssetROO22 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface ICategoryROO18 {
  id: number
  order: number
  name: string
}

export interface IRegionROO18 {
  id: number
  name: string
  order: number
}

export interface IClinicSnsROO17 {
  id: number
  type: IClinicSnsRoO17TypeEnum
  value: string
  order: number
}

export interface IClinicScheduleROO17 {
  day: IClinicScheduleRoO17DayEnum
  openingHour: number
  openingMinute: number
  closingHour: number
  closingMinute: number
  breakStartHour: number | null
  breakStartMinute: number | null
  breakEndHour: number | null
  breakEndMinute: number | null
  receptionStartHour: number | null
  receptionStartMinute: number | null
  receptionEndHour: number | null
  receptionEndMinute: number | null
  isRegularHoliday: boolean
}

export interface IMedicalCategoryROO17 {
  id: number
  order: number
  name: string
  language: string
}

export interface IClinicWishlistUserRO {
  id: number
  nickname: string
  nation: string
}

export interface IClinicWishlistFindWishlist {
  cursor?: number
  categoryIds?: number[]
  regionIds?: number[]
  page?: number
  pageSize?: number
}

export interface IClinicDetailRO {
  clinicImages: IClinicImageRO[]
  medicalImages: IAssetAssetROO23[]
  clinicDoctorProfiles: IClinicDoctorProfileROO10[]
  id: number
  ci: IAssetAssetROO23
  category: ICategoryROO19
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicDetailRoStatusEnum
  region: IRegionROO19
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO18[]
  schedules: IClinicScheduleROO18[][]
  medicalCategories: IMedicalCategoryROO18[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface IClinicImageRO {
  id: number
  image: IAssetAssetROO23
  isMain: boolean
  order: number
}

export interface IAssetAssetROO23 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export type IClinicDoctorProfileTempROO10Nullable = {
  request: IClinicDoctorProfileQnaO11[] | null
  response: IClinicDoctorProfileROO10
}

export interface IClinicDoctorProfileROO10 {
  id: number
  status: IClinicDoctorProfileRoO10StatusEnum
  name: string
  nameZhcn?: string | null
  nameZhtw?: string | null
  nameEn?: string | null
  nameJa?: string | null
  nameTh?: string | null
  nameMn?: string | null
  nameRu?: string | null
  content: string
  contentZhcn?: string | null
  contentZhtw?: string | null
  contentEn?: string | null
  contentJa?: string | null
  contentTh?: string | null
  contentMn?: string | null
  contentRu?: string | null
  qna: IClinicDoctorProfileQnaO11[] | null
  youtubeURL: string | null
  images: IClinicDoctorProfileImageROO10[]
  clinic: IClinicROO11
  tempData: IClinicDoctorProfileTempROO10Nullable
  /** @format date-time */
  approveDate: string | null
  /** @format date-time */
  updateDate: string | null
  /** @format date-time */
  rejectDate: string | null
  rejectReason: string | null
  /** @format date-time */
  createDate: string
}

export interface IClinicDoctorProfileQnaO11 {
  question: string
  answer: string
  language: string
}

export interface IClinicDoctorProfileImageROO10 {
  id: number
  image: IAssetAssetROO23
  isMain: boolean
  order: number
}

export interface IClinicROO11 {
  id: number
  ci: IAssetAssetROO23
  category: ICategoryROO19
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicRoO11StatusEnum
  region: IRegionROO19
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO18[]
  schedules: IClinicScheduleROO18[][]
  medicalCategories: IMedicalCategoryROO18[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface ICategoryROO19 {
  id: number
  order: number
  name: string
}

export interface IRegionROO19 {
  id: number
  name: string
  order: number
}

export interface IClinicSnsROO18 {
  id: number
  type: IClinicSnsRoO18TypeEnum
  value: string
  order: number
}

export interface IClinicScheduleROO18 {
  day: IClinicScheduleRoO18DayEnum
  openingHour: number
  openingMinute: number
  closingHour: number
  closingMinute: number
  breakStartHour: number | null
  breakStartMinute: number | null
  breakEndHour: number | null
  breakEndMinute: number | null
  receptionStartHour: number | null
  receptionStartMinute: number | null
  receptionEndHour: number | null
  receptionEndMinute: number | null
  isRegularHoliday: boolean
}

export interface IMedicalCategoryROO18 {
  id: number
  order: number
  name: string
  language: string
}

export interface IClinicDoctorProfileTempROO10 {
  request: IClinicDoctorProfileQnaO11[] | null
  response: IClinicDoctorProfileROO10
}

export interface IClinicSave {
  ciId: number
  password?: string
  categoryId: number
  name: string
  nameZhcn?: string
  nameZhtw?: string
  nameEn?: string
  nameJa?: string
  nameTh?: string
  nameMn?: string
  nameRu?: string
  address: string
  addressZhcn?: string
  addressZhtw?: string
  addressEn?: string
  addressJa?: string
  addressTh?: string
  addressMn?: string
  addressRu?: string
  addressDetail: string
  addressDetailZhcn?: string
  addressDetailZhtw?: string
  addressDetailEn?: string
  addressDetailJa?: string
  addressDetailTh?: string
  addressDetailMn?: string
  addressDetailRu?: string
  regionId: number
  phone: string
  sns: IClinicSnsSave[]
  clinicImageIds: IClinicImageSave[]
  schedules: IClinicScheduleROO18[]
  medicalCategoryIds: IMedicalCategorySave[]
  medicalImageIds: number[]
}

export interface IClinicSnsSave {
  type: IClinicSnsSaveTypeEnum
  value: string
  order: number
}

export interface IClinicImageSave {
  imageId: number
  isMain: boolean
  order: number
}

export interface IMedicalCategorySave {
  order: number
  name: string
  language: string
}

export interface IPaginationROIClinicROnumber {
  rows: IClinicROO11[]
  count: number
  cursor: number | null
}

export interface IClinicFind {
  categoryIds: number[]
  regionIds: number[]
  order: IClinicFindOrderEnum
  cursor?: number
  page?: number
  q?: string
}

export interface IClinicMine {
  email: string | null
  clinicImages: IClinicImageRO[]
  medicalImages: IAssetAssetROO23[]
  clinicDoctorProfiles: IClinicDoctorProfileROO10[]
  id: number
  ci: IAssetAssetROO23
  category: ICategoryROO19
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicMineStatusEnum
  region: IRegionROO19
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO18[]
  schedules: IClinicScheduleROO18[][]
  medicalCategories: IMedicalCategoryROO18[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface ICommunityArticleSiblingsROO1 {
  prevArticleId: string | null
  nextArticleId: string | null
}

export interface ICommunityArticleSiblingsQueryO1 {
  slug?: string
  categoryId?: number
  regionId?: number
  orderBy?: ICommunityArticleSiblingsQueryO1OrderByEnum
  rangeType?: ICommunityArticleSiblingsQueryO1RangeTypeEnum
}

export interface IPaginationROICommunityArticleArticleListROstringO1 {
  rows: ICommunityArticleArticleListROO1[]
  count: number
  cursor: string | null
}

export type ICategoryROO20Nullable = {
  id: number
  order: number
  name: string
} | null

export type IRegionROO20Nullable = {
  id: number
  name: string
  order: number
} | null

export interface ICommunityArticleArticleListROO1 {
  board: ICommunityBoardSimpleROO2
  category: ICategoryROO20Nullable
  author: IUserROO3
  viewCount: number
  likeCount: number
  commentCount: number
  isBookmarked: boolean
  isLiked: boolean
  region: IRegionROO20Nullable
  inquiryStatus: ICommunityArticleArticleListRoO1InquiryStatusEnum
  answer: string | null
  articleId: string
  title: string
  /** @format date-time */
  createDate: string
  /** @format date-time */
  updateDate: string | null
}

export interface ICommunityBoardSimpleROO2 {
  id: number
  slug: string
  title: string
}

export interface ICategoryROO20 {
  id: number
  order: number
  name: string
}

export interface IUserROO3 {
  id: number
  nickname: string
  /** 컨텐츠 작성자 관리자 유무 확인용 */
  isAdmin: boolean
}

export interface IRegionROO20 {
  id: number
  name: string
  order: number
}

export interface ICommunityArticleSearchQuery {
  boardSlug?: string
  regionId?: number
  pageSize: number
  rangeType: ICommunityArticleSearchQueryRangeTypeEnum
  keyword?: string
  page?: number
  cursor?: string
  orderBy?: ICommunityArticleSearchQueryOrderByEnum
  categoryIds?: number[]
}

export interface ICommunityArticleBaseSearchQuery {
  pageSize: number
  rangeType: ICommunityArticleBaseSearchQueryRangeTypeEnum
  keyword?: string
  page?: number
  cursor?: string
  orderBy?: ICommunityArticleBaseSearchQueryOrderByEnum
  categoryIds?: number[]
}

export interface IPaginationROIFaqROstring {
  rows: IFaqROO1[]
  count: number
  cursor: string | null
}

export interface IFaqROO1 {
  id: number
  question: string
  order: number
  answer: string
}

export interface IFaqFind {
  keyword?: string
}

export interface IPaginationROICommunityArticleInquiryROstring {
  rows: ICommunityArticleInquiryRO[]
  count: number
  cursor: string | null
}

export interface ICommunityArticleInquiryRO {
  inquiryStatus: ICommunityArticleInquiryRoInquiryStatusEnum
  answer: string | null
  board: ICommunityBoardSimpleROO2
  category: ICategoryROO20Nullable
  author: IUserROO3
  viewCount: number
  likeCount: number
  commentCount: number
  isBookmarked: boolean
  isLiked: boolean
  region: IRegionROO20Nullable
  articleId: string
  title: string
  /** @format date-time */
  createDate: string
  /** @format date-time */
  updateDate: string | null
}

export interface IPaginationROIProductROnumber {
  rows: IProductRO[]
  count: number
  cursor: number | null
}

export interface IProductRO {
  id: number
  category: IProductRoCategoryEnum
  status: IProductRoStatusEnum
  title: string
  titleZhcn: string | null
  titleZhtw: string | null
  titleEn: string | null
  titleJa: string | null
  titleTh: string | null
  titleMn: string | null
  titleRu: string | null
  content: string
  contentZhcn: string | null
  contentZhtw: string | null
  contentEn: string | null
  contentJa: string | null
  contentTh: string | null
  contentMn: string | null
  contentRu: string | null
  code: string
  codeZhcn: string | null
  codeZhtw: string | null
  codeEn: string | null
  codeJa: string | null
  codeTh: string | null
  codeMn: string | null
  codeRu: string | null
  price: number
  /** @format date-time */
  createDate: string
  thumbnail: IAssetAssetROO24
}

export interface IAssetAssetROO24 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IProductFind {
  q?: string
  category?: IProductFindCategoryEnum[]
  order: IProductFindOrderEnum
  cursor?: number
  page?: number
}

export interface IReportCreateReport {
  targetArticleId: string
  target: IReportCreateReportTargetEnum
  /** @minLength 1 */
  description: string
  reason: IReportCreateReportReasonEnum
  targetUrl: string
}

export interface IUserROO4 {
  id: number
  nickname: string
  /** 컨텐츠 작성자 관리자 유무 확인용 */
  isAdmin: boolean
}

export interface IUserSignup {
  email?: string
  password?: string
  agreeOptionalPrivacyInfo?: boolean
  agreeMarketing?: boolean
}

export interface IUserUpdateProfile {
  name: string
  nickname: string
  password?: string
  nation: string
  nationNumber: string
  phoneNumber: string
  birthYear?: number
  birthMonth?: number
  birthDay?: number
  interestCategories: ICategorySignup[]
  contactPoints: IContactPointSignup[]
  sns: ISnsSignup[]
}

export interface ICategorySignup {
  id: number
}

export interface IContactPointSignup {
  type: IContactPointSignupTypeEnum
  value: string
  order: number
}

export interface ISnsSignup {
  type: ISnsSignupTypeEnum
  value: string
  order: number
}

export interface IUserCheckEmailRO {
  status: IUserCheckEmailRoStatusEnum
}

export interface IUserCheckEmail {
  email: string
  type: IUserCheckEmailTypeEnum
}

export interface IUserCheckNicknameRO {
  status: IUserCheckNicknameRoStatusEnum
}

export interface IUserCheckNickname {
  nickname: string
  type: IUserCheckNicknameTypeEnum
}

export interface IUserMine {
  userData?: IUserDataROO8
  role: IUserMineRoleEnum
  oAuth: IAuthOAuthO8[]
  id: number
  nickname: string
  /** 컨텐츠 작성자 관리자 유무 확인용 */
  isAdmin: boolean
}

export interface IUserDataROO8 {
  name: string
  email: string | null
  nickname: string
  nation: string
  nationNumber: string
  phoneNumber: string
  birthYear: number
  birthMonth: number
  birthDay: number
  interestCategories: ICategoryROO23[]
  contactPoints: IContactPointROO8[]
  sns: ISnsROO8[]
  /** @format date-time */
  agreeTermsDate: string
  /** @format date-time */
  agreeRequiredPrivacyInfoDate: string
  /** @format date-time */
  agreeOptionalPrivacyInfoDate: string | null
  /** @format date-time */
  agreeMarketingInfoDate: string | null
  /** @format date-time */
  createDate: string
  isProfileCompleted: boolean
}

export interface ICategoryROO23 {
  id: number
  order: number
  name: string
}

export interface IContactPointROO8 {
  id: number
  type: IContactPointRoO8TypeEnum
  value: string
  order: number
}

export interface ISnsROO8 {
  id: number
  type: ISnsRoO8TypeEnum
  value: string
  order: number
}

export interface IAuthOAuthO8 {
  oauthProvider: IAuthOAuthO8OauthProviderEnum
  oauthEmail: string
}

export interface IUserSummaryRO {
  point: number
  reviewCount: number
  wishlistClinicCount: number
  myBoardCount: number
  bookmarkCount: number
  promotionCount: number
  likeCount: number
  commentCount: number
  clinic?: IUserSummaryClinic
}

export interface IUserSummaryClinic {
  dockerProfileCount: number
  newEquipmentCount: number
  clinicReviewCount: number
  wishlistUserCount: number
}

export interface IPaginationROIClinicReviewROnumberO1 {
  rows: IClinicReviewROO1[]
  count: number
  cursor: number | null
}

export type IAssetAssetROO26Nullable = {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IClinicReviewROO1 {
  articleId: string
  type: IClinicReviewRoO1TypeEnum
  category: ICategoryROO23
  clinic: IClinicROO14
  score: number
  content: string
  beforeImage: IAssetAssetROO26Nullable
  afterImage: IAssetAssetROO26Nullable
  images: IClinicReviewImageROO1[]
  hashtags: IReviewHashtagROO1[]
  likeCount: number
  viewCount: number
  commentCount: number
  /** @format date-time */
  createDate: string
  isLiked: boolean
  prevArticleId: string | null
  nextArticleId: string | null
  reelsLink: string | null
  tiktokLink: string | null
  shortsLink: string | null
}

export interface IClinicROO14 {
  id: number
  ci: IAssetAssetROO26
  category: ICategoryROO23
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicRoO14StatusEnum
  region: IRegionROO23
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO21[]
  schedules: IClinicScheduleROO21[][]
  medicalCategories: IMedicalCategoryROO21[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface IAssetAssetROO26 {
  id: number
  filename: string
  originalFilename: string
  contentType: string
  size: number
  key: string
  /** @format date-time */
  createDate: string
  path: string
  thumbnailKey: string | null
  thumbnailWidth: number | null
  thumbnailHeight: number | null
  thumbnailPath: string | null
  width: number | null
  height: number | null
  blurredImage: string | null
}

export interface IRegionROO23 {
  id: number
  name: string
  order: number
}

export interface IClinicSnsROO21 {
  id: number
  type: IClinicSnsRoO21TypeEnum
  value: string
  order: number
}

export interface IClinicScheduleROO21 {
  day: IClinicScheduleRoO21DayEnum
  openingHour: number
  openingMinute: number
  closingHour: number
  closingMinute: number
  breakStartHour: number | null
  breakStartMinute: number | null
  breakEndHour: number | null
  breakEndMinute: number | null
  receptionStartHour: number | null
  receptionStartMinute: number | null
  receptionEndHour: number | null
  receptionEndMinute: number | null
  isRegularHoliday: boolean
}

export interface IMedicalCategoryROO21 {
  id: number
  order: number
  name: string
  language: string
}

export interface IClinicReviewImageROO1 {
  id: number
  image: IAssetAssetROO26
  isMain: boolean
  order: number
}

export interface IReviewHashtagROO1 {
  id: number
  hashtag: string
  order: number
}

export interface IUserFindMyReview {
  types: IUserFindMyReviewTypesEnum[]
  /** @format date */
  startDate?: string
  /** @format date */
  endDate?: string
  categoryIds: number[]
  page?: number
  cursor?: number
}

export interface IPaginationROIClinicPromotionParticipantROnumber {
  rows: IClinicPromotionParticipantROO2[]
  count: number
  cursor: number | null
}

export interface IClinicPromotionParticipantROO2 {
  id: number
  name: string
  email: string
  clinicName: string | null
  /** @format date-time */
  agreePrivacyDate: string
  /** @format date-time */
  createDate: string
  promotion: IClinicPromotionROO2
  category: ICategoryROO23
}

export type IRegionROO23Nullable = {
  id: number
  name: string
  order: number
} | null

export type IClinicROO14Nullable = {
  id: number
  ci: IAssetAssetROO26
  category: ICategoryROO23
  name: string
  nameZhcn: string | null
  nameZhtw: string | null
  nameEn: string | null
  nameJa: string | null
  nameTh: string | null
  nameMn: string | null
  nameRu: string | null
  status: IClinicRoO14NullableStatusEnum
  region: IRegionROO23
  address: string
  addressZhcn: string | null
  addressZhtw: string | null
  addressEn: string | null
  addressJa: string | null
  addressTh: string | null
  addressMn: string | null
  addressRu: string | null
  addressDetail: string
  addressDetailZhcn: string | null
  addressDetailZhtw: string | null
  addressDetailEn: string | null
  addressDetailJa: string | null
  addressDetailTh: string | null
  addressDetailMn: string | null
  addressDetailRu: string | null
  phone: string
  sns: IClinicSnsROO21[]
  schedules: IClinicScheduleROO21[][]
  medicalCategories: IMedicalCategoryROO21[]
  wishlistCount: number
  isWishlisted: boolean
}

export interface IClinicPromotionROO2 {
  id: number
  type: IClinicPromotionRoO2TypeEnum
  status: IClinicPromotionRoO2StatusEnum
  image: IAssetAssetROO26
  imageZhcn: IAssetAssetROO26Nullable
  imageZhtw: IAssetAssetROO26Nullable
  imageEn: IAssetAssetROO26Nullable
  imageJa: IAssetAssetROO26Nullable
  imageTh: IAssetAssetROO26Nullable
  category: ICategoryROO23
  region: IRegionROO23Nullable
  /** @format date-time */
  startDate: string | null
  /** @format date-time */
  endDate: string | null
  title: string
  titleZhcn: string | null
  titleZhtw: string | null
  titleEn: string | null
  titleJa: string | null
  titleTh: string | null
  titleMn: string | null
  titleRu: string | null
  content: string
  contentZhcn: string | null
  contentZhtw: string | null
  contentEn: string | null
  contentJa: string | null
  contentTh: string | null
  contentMn: string | null
  contentRu: string | null
  discountRate: number | null
  originalPrice: number | null
  discountPrice: number | null
  hashtags: IClinicPromotionHashtagROO2[]
  clinic: IClinicROO14Nullable
  /** @format date-time */
  createDate: string
  participantCount: number
}

export interface IClinicPromotionHashtagROO2 {
  id: number
  hashtag: string
  language: string
  order: number
}

export interface IUserFindMyPromotion {
  /** @format date */
  startDate?: string
  /** @format date */
  endDate?: string
  type?: IUserFindMyPromotionTypeEnum
  categoryIds: number[]
  regionIds: number[]
  page?: number
  cursor?: number
}

export interface IPaginationROICommunityArticleArticleListROstringO2 {
  rows: ICommunityArticleArticleListROO2[]
  count: number
  cursor: string | null
}

export type ICategoryROO23Nullable = {
  id: number
  order: number
  name: string
} | null

export interface ICommunityArticleArticleListROO2 {
  board: ICommunityBoardSimpleROO3
  category: ICategoryROO23Nullable
  author: IUserROO4
  viewCount: number
  likeCount: number
  commentCount: number
  isBookmarked: boolean
  isLiked: boolean
  region: IRegionROO23Nullable
  inquiryStatus: ICommunityArticleArticleListRoO2InquiryStatusEnum
  answer: string | null
  articleId: string
  title: string
  /** @format date-time */
  createDate: string
  /** @format date-time */
  updateDate: string | null
}

export interface ICommunityBoardSimpleROO3 {
  id: number
  slug: string
  title: string
}

export interface IUserFindMyBoardArticle {
  /** @format date */
  startDate?: string
  /** @format date */
  endDate?: string
  categoryIds: number[]
  pageSize: number
  page?: number
  cursor?: string
  slug?: string
}

export interface IPaginationROROArticleListROstring {
  rows: (IClinicReviewROO1 | ICommunityArticleArticleListROO2)[]
  count: number
  cursor: string | null
}

export interface IUserFindMyLike {
  pageSize: number
  page?: number
  cursor?: string
  type: IUserFindMyLikeTypeEnum
}

export interface IPaginationROICommentCommentROWithArticleInfostring {
  rows: ICommentCommentROWithArticleInfo[]
  count: number
  cursor: string | null
}

export type ICommunityBoardSimpleROO3Nullable = {
  id: number
  slug: string
  title: string
} | null

export type ICommentCommentROO1Nullable = {
  id: number
  content: string
  /** @format date-time */
  createDate: string
  /** @format date-time */
  updateDate: string | null
  author: IUserROO4
  parent: ICommentCommentROO1Nullable
}

export interface ICommentCommentROWithArticleInfo {
  article: {
    articleId: string
    title: string
    category: ICategoryROO23Nullable
    board: ICommunityBoardSimpleROO3Nullable
    type: ICommentCommentRoWithArticleInfoTypeEnum
  }
  id: number
  content: string
  /** @format date-time */
  createDate: string
  /** @format date-time */
  updateDate: string | null
  author: IUserROO4
  parent: ICommentCommentROO1Nullable
}

export interface ICommentCommentROO1 {
  id: number
  content: string
  /** @format date-time */
  createDate: string
  /** @format date-time */
  updateDate: string | null
  author: IUserROO4
  parent: ICommentCommentROO1Nullable
}

export interface IUserFindMyComments {
  type: IUserFindMyCommentsTypeEnum
  pageSize: number
  page?: number
  cursor?: string
}

export interface IUserFindEmailRO {
  status: IUserFindEmailRoStatusEnum
  email: string | null
}

export interface IUserFindEmail {
  name: string
  nationNumber: string
  phoneNumber: string
}

export interface IUserFindPasswordRO {
  status: IUserFindPasswordRoStatusEnum
  email?: string
}

export interface IUserFindPassword {
  email: string
  name: string
}

export interface IUserResendPasswordRO {
  status: IUserResendPasswordRoStatusEnum
}

export interface IUserResendPassword {
  email: string
}

export interface IUserChangePasswordRO {
  status: IUserChangePasswordRoStatusEnum
}

export interface IUserChangePassword {
  password: string
  code: string
}

export interface IPaginationROIPointHistoryROnumber {
  rows: IPointHistoryRO[]
  count: number
  cursor: number | null
}

export interface IPointHistoryRO {
  id: number
  type: IPointHistoryRoTypeEnum
  amount: number
  balanceAfter: number
  description: string
  /** @format date-time */
  expiresDate: string | null
  /** @format date-time */
  createDate: string
  flag: string | null
}

export interface IPointHistoryGetTransactionsQuery {
  /** @format date */
  startDate?: string
  /** @format date */
  endDate?: string
  transactionType?: IPointHistoryGetTransactionsQueryTransactionTypeEnum
  amount?: number
  cursor?: number
  page?: number
}

export interface IPointRO {
  balance: number
  totalEarned: number
  totalUsed: number
}

export interface IPointEarn {
  amount?: number
  referenceId?: string
  referenceType: IPointEarnReferenceTypeEnum
  /** @format date */
  expiresDate?: string
}

export interface IPointUse {
  amount: number
  description: string
  referenceId?: string
  referenceType: IPointUseReferenceTypeEnum
}

/** Represents entity with its loaded relations (`populate` hint) and selected properties (`fields` hint). */
export type LoadedPointRuleneverNeverNullable = {
  id: number
  referenceType: LoadedPointRuleneverNeverNullableReferenceTypeEnum
  name: string
  amount: number
  '__@___loadedType@1736'?: PointRule
} | null

export type IAdminUserROO8Nullable = {
  id: number
  role: IAdminUserRoO8NullableRoleEnum
  status: IAdminUserRoO8NullableStatusEnum
  email: string | null
  password: string | null
  /** @format date-time */
  createDate: string | null
  /** @format date-time */
  updateDate: string | null
  /** @format date-time */
  withdrawDate: string | null
  withdrawReason: string | null
  userData: IUserDataROO7Nullable
  clinic: IClinicAdminROO7Nullable
  oauthList: IAuthOAuthO7[]
}

export enum IAdminUserRoRoleEnum {
  SUPER_ADMIN = 'SUPER_ADMIN',
  PARTNER_ADMIN = 'PARTNER_ADMIN',
}

export enum IAdminUserCreateRoleEnum {
  SUPER_ADMIN = 'SUPER_ADMIN',
  PARTNER_ADMIN = 'PARTNER_ADMIN',
}

export enum IAdminUserUpdateRoleEnum {
  SUPER_ADMIN = 'SUPER_ADMIN',
  PARTNER_ADMIN = 'PARTNER_ADMIN',
}

export enum OAuthValidateDtoProviderEnum {
  KAKAO = 'KAKAO',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
  NAVER = 'NAVER',
  LINE = 'LINE',
}

export enum AppleValidateDtoProviderEnum {
  KAKAO = 'KAKAO',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
  NAVER = 'NAVER',
  LINE = 'LINE',
}

export enum ITranslationResultSourceLanguageEnum {
  ZhCN = 'zh-CN',
  ZhTW = 'zh-TW',
  Zh = 'zh',
  En = 'en',
  Ko = 'ko',
  Ja = 'ja',
  Th = 'th',
  Mn = 'mn',
  Ru = 'ru',
}

export enum ITranslationResultTargetLanguageEnum {
  ZhCN = 'zh-CN',
  ZhTW = 'zh-TW',
  Zh = 'zh',
  En = 'en',
  Ko = 'ko',
  Ja = 'ja',
  Th = 'th',
  Mn = 'mn',
  Ru = 'ru',
}

export enum ITranslationQuerySourceLanguageEnum {
  ZhCN = 'zh-CN',
  ZhTW = 'zh-TW',
  Zh = 'zh',
  En = 'en',
  Ko = 'ko',
  Ja = 'ja',
  Th = 'th',
  Mn = 'mn',
  Ru = 'ru',
}

export enum ITranslationQueryTargetLanguageEnum {
  ZhCN = 'zh-CN',
  ZhTW = 'zh-TW',
  Zh = 'zh',
  En = 'en',
  Ko = 'ko',
  Ja = 'ja',
  Th = 'th',
  Mn = 'mn',
  Ru = 'ru',
}

export enum ITranslationQueryProviderTypeEnum {
  Google = 'google',
  Papago = 'papago',
  Deepl = 'deepl',
}

export enum ITranslationMultipleQuerySourceLanguageEnum {
  ZhCN = 'zh-CN',
  ZhTW = 'zh-TW',
  Zh = 'zh',
  En = 'en',
  Ko = 'ko',
  Ja = 'ja',
  Th = 'th',
  Mn = 'mn',
  Ru = 'ru',
}

export enum ITranslationMultipleQueryTargetLanguageEnum {
  ZhCN = 'zh-CN',
  ZhTW = 'zh-TW',
  Zh = 'zh',
  En = 'en',
  Ko = 'ko',
  Ja = 'ja',
  Th = 'th',
  Mn = 'mn',
  Ru = 'ru',
}

export enum IBannerRoLanguageEnum {
  ZhCN = 'zh-CN',
  ZhTW = 'zh-TW',
  Zh = 'zh',
  En = 'en',
  Ko = 'ko',
  Ja = 'ja',
  Th = 'th',
  Mn = 'mn',
  Ru = 'ru',
}

export enum IAdminBannerSaveLanguageEnum {
  ZhCN = 'zh-CN',
  ZhTW = 'zh-TW',
  Zh = 'zh',
  En = 'en',
  Ko = 'ko',
  Ja = 'ja',
  Th = 'th',
  Mn = 'mn',
  Ru = 'ru',
}

export enum LoadedBusinessInquiryneverNeverStatusEnum {
  PENDING = 'PENDING',
  CONTACTING = 'CONTACTING',
  CONTACT_COMPLETED = 'CONTACT_COMPLETED',
  PARTNERSHIP_COMPLETED = 'PARTNERSHIP_COMPLETED',
  ON_HOLD = 'ON_HOLD',
  ENDED = 'ENDED',
}

export enum BusinessInquiryStatusEnum {
  PENDING = 'PENDING',
  CONTACTING = 'CONTACTING',
  CONTACT_COMPLETED = 'CONTACT_COMPLETED',
  PARTNERSHIP_COMPLETED = 'PARTNERSHIP_COMPLETED',
  ON_HOLD = 'ON_HOLD',
  ENDED = 'ENDED',
}

export enum IAdminBusinessInquiryFindStatusEnum {
  PENDING = 'PENDING',
  CONTACTING = 'CONTACTING',
  CONTACT_COMPLETED = 'CONTACT_COMPLETED',
  PARTNERSHIP_COMPLETED = 'PARTNERSHIP_COMPLETED',
  ON_HOLD = 'ON_HOLD',
  ENDED = 'ENDED',
}

export enum IAdminBusinessInquiryUpdateStatusEnum {
  PENDING = 'PENDING',
  CONTACTING = 'CONTACTING',
  CONTACT_COMPLETED = 'CONTACT_COMPLETED',
  PARTNERSHIP_COMPLETED = 'PARTNERSHIP_COMPLETED',
  ON_HOLD = 'ON_HOLD',
  ENDED = 'ENDED',
}

export enum IAdminClinicConfirmNewEquipmentRequestStatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export enum IClinicAdminRoNullableStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IAdminUserRoO1RoleEnum {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  PARTNER_CLINIC = 'PARTNER_CLINIC',
  SYSTEM = 'SYSTEM',
}

export enum IAdminUserRoO1StatusEnum {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  WITHDRAWN = 'WITHDRAWN',
  DELETED = 'DELETED',
}

export enum IContactPointRoTypeEnum {
  LINE = 'LINE',
  WHATSAPP = 'WHATSAPP',
  WECHAT = 'WECHAT',
  KAKAOTALK = 'KAKAOTALK',
}

export enum ISnsRoTypeEnum {
  INSTAGRAM = 'INSTAGRAM',
  TIKTOK = 'TIKTOK',
  YOUTUBE = 'YOUTUBE',
  ETC = 'ETC',
}

export enum IClinicAdminRoStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicSnsRoO1TypeEnum {
  YOUTUBE = 'YOUTUBE',
  INSTAGRAM = 'INSTAGRAM',
  KAKAOTALK = 'KAKAOTALK',
  HOMEPAGE = 'HOMEPAGE',
}

export enum IClinicScheduleRoO1DayEnum {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export enum IAuthOAuthOauthProviderEnum {
  KAKAO = 'KAKAO',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
  NAVER = 'NAVER',
  LINE = 'LINE',
}

export enum IAdminClinicFindStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IAdminClinicSaveStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IAdminClinicInterviewRoStatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export enum IAdminClinicInterviewFindStatusListEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export enum IAdminClinicConfirmDoctorProfileRequestStatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export enum IAdminCommentRoTypeEnum {
  ClinicReview = 'clinic_review',
  ClinicExperience = 'clinic_experience',
  CommunityArticle = 'community_article',
  ClinicEquipment = 'clinic_equipment',
}

export enum IClinicAdminRoO1NullableStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IAdminUserRoO2RoleEnum {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  PARTNER_CLINIC = 'PARTNER_CLINIC',
  SYSTEM = 'SYSTEM',
}

export enum IAdminUserRoO2StatusEnum {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  WITHDRAWN = 'WITHDRAWN',
  DELETED = 'DELETED',
}

export enum IContactPointRoO1TypeEnum {
  LINE = 'LINE',
  WHATSAPP = 'WHATSAPP',
  WECHAT = 'WECHAT',
  KAKAOTALK = 'KAKAOTALK',
}

export enum ISnsRoO1TypeEnum {
  INSTAGRAM = 'INSTAGRAM',
  TIKTOK = 'TIKTOK',
  YOUTUBE = 'YOUTUBE',
  ETC = 'ETC',
}

export enum IClinicAdminRoO1StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicSnsRoO2TypeEnum {
  YOUTUBE = 'YOUTUBE',
  INSTAGRAM = 'INSTAGRAM',
  KAKAOTALK = 'KAKAOTALK',
  HOMEPAGE = 'HOMEPAGE',
}

export enum IClinicScheduleRoO2DayEnum {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export enum IAuthOAuthO1OauthProviderEnum {
  KAKAO = 'KAKAO',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
  NAVER = 'NAVER',
  LINE = 'LINE',
}

/**
 * 댓글 조회 시 게시글 타입
 * - CLINIC_REVIEW: 병원 리뷰
 * - CLINIC_EXPERIENCE: 체험단 구인구직
 * - COMMUNITY_ARTICLE: 커뮤니티 게시글
 * - CLINIC_EQUIPMENT: 병원 신규 장비
 */
export enum IAdminCommentFindArticleTypeEnum {
  ClinicReview = 'clinic_review',
  ClinicExperience = 'clinic_experience',
  CommunityArticle = 'community_article',
  ClinicEquipment = 'clinic_equipment',
}

export enum IAdminCommentFindStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IAdminCommentDeleteTypeEnum {
  ClinicReview = 'clinic_review',
  ClinicExperience = 'clinic_experience',
  CommunityArticle = 'community_article',
  ClinicEquipment = 'clinic_equipment',
}

export enum IAdminCommentUpdateStatusTypeEnum {
  ClinicReview = 'clinic_review',
  ClinicExperience = 'clinic_experience',
  CommunityArticle = 'community_article',
  ClinicEquipment = 'clinic_equipment',
}

export enum IAdminCommentUpdateStatusStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IAdminCommunityRoInquiryStatusEnum {
  WAITING = 'WAITING',
  ANSWERED = 'ANSWERED',
}

export enum IAdminCommunityRoArticleStatusEnum {
  VISIBLE = 'VISIBLE',
  HIDDEN = 'HIDDEN',
}

export enum IClinicAdminRoO2NullableStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IAdminUserRoO3RoleEnum {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  PARTNER_CLINIC = 'PARTNER_CLINIC',
  SYSTEM = 'SYSTEM',
}

export enum IAdminUserRoO3StatusEnum {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  WITHDRAWN = 'WITHDRAWN',
  DELETED = 'DELETED',
}

export enum IContactPointRoO2TypeEnum {
  LINE = 'LINE',
  WHATSAPP = 'WHATSAPP',
  WECHAT = 'WECHAT',
  KAKAOTALK = 'KAKAOTALK',
}

export enum ISnsRoO2TypeEnum {
  INSTAGRAM = 'INSTAGRAM',
  TIKTOK = 'TIKTOK',
  YOUTUBE = 'YOUTUBE',
  ETC = 'ETC',
}

export enum IClinicAdminRoO2StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicSnsRoO3TypeEnum {
  YOUTUBE = 'YOUTUBE',
  INSTAGRAM = 'INSTAGRAM',
  KAKAOTALK = 'KAKAOTALK',
  HOMEPAGE = 'HOMEPAGE',
}

export enum IClinicScheduleRoO3DayEnum {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export enum IAuthOAuthO2OauthProviderEnum {
  KAKAO = 'KAKAO',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
  NAVER = 'NAVER',
  LINE = 'LINE',
}

export enum IAdminCommunityFindStatusEnum {
  VISIBLE = 'VISIBLE',
  HIDDEN = 'HIDDEN',
}

export enum IAdminCommunitySaveNoticeArticleStatusEnum {
  VISIBLE = 'VISIBLE',
  HIDDEN = 'HIDDEN',
}

export enum IConsultationFormPayloadDataNullableGenderEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum IConsultationFormPayloadDataNullableFlightBookedEnum {
  YES = 'YES',
  NO = 'NO',
}

export enum IAdminConsultationRequestRoChannelEnum {
  WEB_FORM = 'WEB_FORM',
  WHATSAPP = 'WHATSAPP',
  LINE = 'LINE',
  KAKAO = 'KAKAO',
  OTHER = 'OTHER',
}

export enum IAdminConsultationRequestRoStatusEnum {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  RESERVATION_CONFIRMED = 'RESERVATION_CONFIRMED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export enum IConsultationFormPayloadDataGenderEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum IConsultationFormPayloadDataFlightBookedEnum {
  YES = 'YES',
  NO = 'NO',
}

export enum IAdminConsultationRequestFindStatusEnum {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  RESERVATION_CONFIRMED = 'RESERVATION_CONFIRMED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export enum IAdminConsultationRequestCreateChannelEnum {
  WEB_FORM = 'WEB_FORM',
  WHATSAPP = 'WHATSAPP',
  LINE = 'LINE',
  KAKAO = 'KAKAO',
  OTHER = 'OTHER',
}

export enum IAdminConsultationRequestCreateStatusEnum {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  RESERVATION_CONFIRMED = 'RESERVATION_CONFIRMED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export enum IAdminConsultationRequestUpdateStatusEnum {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  RESERVATION_CONFIRMED = 'RESERVATION_CONFIRMED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export enum IAdminExperienceRoArticleStatusEnum {
  VISIBLE = 'VISIBLE',
  HIDDEN = 'HIDDEN',
}

export enum IClinicAdminRoO3NullableStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IAdminUserRoO4RoleEnum {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  PARTNER_CLINIC = 'PARTNER_CLINIC',
  SYSTEM = 'SYSTEM',
}

export enum IAdminUserRoO4StatusEnum {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  WITHDRAWN = 'WITHDRAWN',
  DELETED = 'DELETED',
}

export enum IContactPointRoO3TypeEnum {
  LINE = 'LINE',
  WHATSAPP = 'WHATSAPP',
  WECHAT = 'WECHAT',
  KAKAOTALK = 'KAKAOTALK',
}

export enum ISnsRoO3TypeEnum {
  INSTAGRAM = 'INSTAGRAM',
  TIKTOK = 'TIKTOK',
  YOUTUBE = 'YOUTUBE',
  ETC = 'ETC',
}

export enum IClinicAdminRoO3StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicSnsRoO4TypeEnum {
  YOUTUBE = 'YOUTUBE',
  INSTAGRAM = 'INSTAGRAM',
  KAKAOTALK = 'KAKAOTALK',
  HOMEPAGE = 'HOMEPAGE',
}

export enum IClinicScheduleRoO4DayEnum {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export enum IAuthOAuthO3OauthProviderEnum {
  KAKAO = 'KAKAO',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
  NAVER = 'NAVER',
  LINE = 'LINE',
}

export enum IFooterIconRoSideEnum {
  Left = 'left',
  Right = 'right',
}

export enum IAdminFooterIconSaveSideEnum {
  Left = 'left',
  Right = 'right',
}

export enum IAdminClinicNewEquipmentRoStatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export enum IAdminClinicNewEquipmentFindStatusListEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export enum IAdminClinicConfirmDoctorProfileRequestO1StatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export enum IAdminPointTransactionRoReferenceTypeEnum {
  SIGNUP = 'SIGNUP',
  WRITE_PROFILE = 'WRITE_PROFILE',
  ORDER = 'ORDER',
  EVENT = 'EVENT',
  REFERRAL = 'REFERRAL',
  REVIEW = 'REVIEW',
  COMMENT = 'COMMENT',
  DAILY = 'DAILY',
  EXPIRE = 'EXPIRE',
  ADMIN = 'ADMIN',
  COMMUNITY = 'COMMUNITY',
  FIRST_COMMENT = 'FIRST_COMMENT',
  FIRST_COMMUNITY = 'FIRST_COMMUNITY',
}

export enum IAdminPointTransactionRoTransactionTypeEnum {
  EARN = 'EARN',
  USE = 'USE',
  RECOVER = 'RECOVER',
  EXPIRE = 'EXPIRE',
}

export enum IClinicAdminRoO4NullableStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IAdminUserRoO5RoleEnum {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  PARTNER_CLINIC = 'PARTNER_CLINIC',
  SYSTEM = 'SYSTEM',
}

export enum IAdminUserRoO5StatusEnum {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  WITHDRAWN = 'WITHDRAWN',
  DELETED = 'DELETED',
}

export enum IContactPointRoO4TypeEnum {
  LINE = 'LINE',
  WHATSAPP = 'WHATSAPP',
  WECHAT = 'WECHAT',
  KAKAOTALK = 'KAKAOTALK',
}

export enum ISnsRoO4TypeEnum {
  INSTAGRAM = 'INSTAGRAM',
  TIKTOK = 'TIKTOK',
  YOUTUBE = 'YOUTUBE',
  ETC = 'ETC',
}

export enum IClinicAdminRoO4StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicSnsRoO5TypeEnum {
  YOUTUBE = 'YOUTUBE',
  INSTAGRAM = 'INSTAGRAM',
  KAKAOTALK = 'KAKAOTALK',
  HOMEPAGE = 'HOMEPAGE',
}

export enum IClinicScheduleRoO5DayEnum {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export enum IAuthOAuthO4OauthProviderEnum {
  KAKAO = 'KAKAO',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
  NAVER = 'NAVER',
  LINE = 'LINE',
}

export enum IAdminPointTransactionFindTypesEnum {
  EARN = 'EARN',
  USE = 'USE',
  RECOVER = 'RECOVER',
  EXPIRE = 'EXPIRE',
}

export enum IAdminPointTransactionFindReferenceTypesEnum {
  SIGNUP = 'SIGNUP',
  WRITE_PROFILE = 'WRITE_PROFILE',
  ORDER = 'ORDER',
  EVENT = 'EVENT',
  REFERRAL = 'REFERRAL',
  REVIEW = 'REVIEW',
  COMMENT = 'COMMENT',
  DAILY = 'DAILY',
  EXPIRE = 'EXPIRE',
  ADMIN = 'ADMIN',
  COMMUNITY = 'COMMUNITY',
  FIRST_COMMENT = 'FIRST_COMMENT',
  FIRST_COMMUNITY = 'FIRST_COMMUNITY',
}

export enum IAdminPointTransactionCreateTypeEnum {
  EARN = 'EARN',
  USE = 'USE',
  RECOVER = 'RECOVER',
  EXPIRE = 'EXPIRE',
}

export enum IAdminPointTransactionCreateReferenceTypeEnum {
  SIGNUP = 'SIGNUP',
  WRITE_PROFILE = 'WRITE_PROFILE',
  ORDER = 'ORDER',
  EVENT = 'EVENT',
  REFERRAL = 'REFERRAL',
  REVIEW = 'REVIEW',
  COMMENT = 'COMMENT',
  DAILY = 'DAILY',
  EXPIRE = 'EXPIRE',
  ADMIN = 'ADMIN',
  COMMUNITY = 'COMMUNITY',
  FIRST_COMMENT = 'FIRST_COMMENT',
  FIRST_COMMUNITY = 'FIRST_COMMUNITY',
}

export enum IAdminPointRuleRoReferenceTypeEnum {
  SIGNUP = 'SIGNUP',
  WRITE_PROFILE = 'WRITE_PROFILE',
  ORDER = 'ORDER',
  EVENT = 'EVENT',
  REFERRAL = 'REFERRAL',
  REVIEW = 'REVIEW',
  COMMENT = 'COMMENT',
  DAILY = 'DAILY',
  EXPIRE = 'EXPIRE',
  ADMIN = 'ADMIN',
  COMMUNITY = 'COMMUNITY',
  FIRST_COMMENT = 'FIRST_COMMENT',
  FIRST_COMMUNITY = 'FIRST_COMMUNITY',
}

export enum LoadedPointRuleneverNeverReferenceTypeEnum {
  SIGNUP = 'SIGNUP',
  WRITE_PROFILE = 'WRITE_PROFILE',
  ORDER = 'ORDER',
  EVENT = 'EVENT',
  REFERRAL = 'REFERRAL',
  REVIEW = 'REVIEW',
  COMMENT = 'COMMENT',
  DAILY = 'DAILY',
  EXPIRE = 'EXPIRE',
  ADMIN = 'ADMIN',
  COMMUNITY = 'COMMUNITY',
  FIRST_COMMENT = 'FIRST_COMMENT',
  FIRST_COMMUNITY = 'FIRST_COMMUNITY',
}

export enum PointRuleReferenceTypeEnum {
  SIGNUP = 'SIGNUP',
  WRITE_PROFILE = 'WRITE_PROFILE',
  ORDER = 'ORDER',
  EVENT = 'EVENT',
  REFERRAL = 'REFERRAL',
  REVIEW = 'REVIEW',
  COMMENT = 'COMMENT',
  DAILY = 'DAILY',
  EXPIRE = 'EXPIRE',
  ADMIN = 'ADMIN',
  COMMUNITY = 'COMMUNITY',
  FIRST_COMMENT = 'FIRST_COMMENT',
  FIRST_COMMUNITY = 'FIRST_COMMUNITY',
}

export enum IAdminProductRoCategoryEnum {
  Value기초케어 = '기초케어',
  Value진정관리 = '진정관리',
  Value시술후추천템 = '시술후추천템',
}

export enum IAdminProductRoStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IAdminProductFindCategoryEnum {
  Value기초케어 = '기초케어',
  Value진정관리 = '진정관리',
  Value시술후추천템 = '시술후추천템',
}

export enum IAdminProductFindStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IAdminProductFindOrderEnum {
  LATEST = 'LATEST',
  OLDEST = 'OLDEST',
  POPULAR = 'POPULAR',
  PRICE_HIGH = 'PRICE_HIGH',
  PRICE_LOW = 'PRICE_LOW',
}

export enum IAdminProductCreateCategoryEnum {
  Value기초케어 = '기초케어',
  Value진정관리 = '진정관리',
  Value시술후추천템 = '시술후추천템',
}

export enum IAdminProductUpdateCategoryEnum {
  Value기초케어 = '기초케어',
  Value진정관리 = '진정관리',
  Value시술후추천템 = '시술후추천템',
}

export enum IAdminProductUpdateStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicRoO1NullableStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IAdminPromotionRoTypeEnum {
  EVENT = 'EVENT',
  LIMITED = 'LIMITED',
  MEDICAL_PACKAGE = 'MEDICAL_PACKAGE',
}

export enum IAdminPromotionRoStatusEnum {
  BEFORE_START = 'BEFORE_START',
  ONGOING = 'ONGOING',
  ENDED = 'ENDED',
}

export enum IClinicRoO1StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicSnsRoO6TypeEnum {
  YOUTUBE = 'YOUTUBE',
  INSTAGRAM = 'INSTAGRAM',
  KAKAOTALK = 'KAKAOTALK',
  HOMEPAGE = 'HOMEPAGE',
}

export enum IClinicScheduleRoO6DayEnum {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export enum IAdminPromotionFindTypeEnum {
  EVENT = 'EVENT',
  LIMITED = 'LIMITED',
  MEDICAL_PACKAGE = 'MEDICAL_PACKAGE',
}

export enum IAdminPromotionFindStatusEnum {
  BEFORE_START = 'BEFORE_START',
  ONGOING = 'ONGOING',
  ENDED = 'ENDED',
}

export enum IAdminPromotionDetailRoTypeEnum {
  EVENT = 'EVENT',
  LIMITED = 'LIMITED',
  MEDICAL_PACKAGE = 'MEDICAL_PACKAGE',
}

export enum IAdminPromotionDetailRoStatusEnum {
  BEFORE_START = 'BEFORE_START',
  ONGOING = 'ONGOING',
  ENDED = 'ENDED',
}

export enum IClinicPromotionRoTypeEnum {
  EVENT = 'EVENT',
  LIMITED = 'LIMITED',
  MEDICAL_PACKAGE = 'MEDICAL_PACKAGE',
}

export enum IClinicPromotionRoStatusEnum {
  BEFORE_START = 'BEFORE_START',
  ONGOING = 'ONGOING',
  ENDED = 'ENDED',
}

export enum IAdminPromotionSaveTypeEnum {
  EVENT = 'EVENT',
  LIMITED = 'LIMITED',
  MEDICAL_PACKAGE = 'MEDICAL_PACKAGE',
}

export enum IAdminQnaRoInquiryStatusEnum {
  WAITING = 'WAITING',
  ANSWERED = 'ANSWERED',
}

export enum IAdminQnaRoArticleStatusEnum {
  VISIBLE = 'VISIBLE',
  HIDDEN = 'HIDDEN',
}

export enum IClinicAdminRoO5NullableStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IAdminUserRoO6RoleEnum {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  PARTNER_CLINIC = 'PARTNER_CLINIC',
  SYSTEM = 'SYSTEM',
}

export enum IAdminUserRoO6StatusEnum {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  WITHDRAWN = 'WITHDRAWN',
  DELETED = 'DELETED',
}

export enum IContactPointRoO5TypeEnum {
  LINE = 'LINE',
  WHATSAPP = 'WHATSAPP',
  WECHAT = 'WECHAT',
  KAKAOTALK = 'KAKAOTALK',
}

export enum ISnsRoO5TypeEnum {
  INSTAGRAM = 'INSTAGRAM',
  TIKTOK = 'TIKTOK',
  YOUTUBE = 'YOUTUBE',
  ETC = 'ETC',
}

export enum IClinicAdminRoO5StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicSnsRoO7TypeEnum {
  YOUTUBE = 'YOUTUBE',
  INSTAGRAM = 'INSTAGRAM',
  KAKAOTALK = 'KAKAOTALK',
  HOMEPAGE = 'HOMEPAGE',
}

export enum IClinicScheduleRoO7DayEnum {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export enum IAuthOAuthO5OauthProviderEnum {
  KAKAO = 'KAKAO',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
  NAVER = 'NAVER',
  LINE = 'LINE',
}

export enum IAdminQnaFindStatusEnum {
  WAITING = 'WAITING',
  ANSWERED = 'ANSWERED',
}

export enum IAdminQnaUpdateArticleStatusEnum {
  VISIBLE = 'VISIBLE',
  HIDDEN = 'HIDDEN',
}

export enum IAdminQnaUpdateInquiryStatusEnum {
  WAITING = 'WAITING',
  ANSWERED = 'ANSWERED',
}

export enum IReferralPartnerRoStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IReferralPartnerRoDefaultLocaleEnum {
  Ko = 'ko',
  En = 'en',
  Ja = 'ja',
  ZhCN = 'zh-CN',
  ZhTW = 'zh-TW',
  Th = 'th',
  Mn = 'mn',
  Ru = 'ru',
}

export enum IAdminReferralPartnerFindStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IAdminReferralPartnerSaveStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IAdminReferralPartnerSaveDefaultLocaleEnum {
  Ko = 'ko',
  En = 'en',
  Ja = 'ja',
  ZhCN = 'zh-CN',
  ZhTW = 'zh-TW',
  Th = 'th',
  Mn = 'mn',
  Ru = 'ru',
}

export enum IAdminReportRoReasonEnum {
  Value부적절한콘텐츠 = '부적절한 콘텐츠',
  Value광고홍보성콘텐츠 = '광고/홍보성 콘텐츠',
  Value사기피싱콘텐츠 = '사기/피싱 콘텐츠',
  Value기타 = '기타',
}

export enum IAdminReportRoStatusEnum {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
}

export enum IAdminReportRoTypeEnum {
  CommunityArticle = 'communityArticle',
  ClinicReview = 'clinicReview',
  ClinicNewEquipment = 'clinicNewEquipment',
}

export enum IClinicAdminRoO6NullableStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IAdminUserRoO7RoleEnum {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  PARTNER_CLINIC = 'PARTNER_CLINIC',
  SYSTEM = 'SYSTEM',
}

export enum IAdminUserRoO7StatusEnum {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  WITHDRAWN = 'WITHDRAWN',
  DELETED = 'DELETED',
}

export enum IContactPointRoO6TypeEnum {
  LINE = 'LINE',
  WHATSAPP = 'WHATSAPP',
  WECHAT = 'WECHAT',
  KAKAOTALK = 'KAKAOTALK',
}

export enum ISnsRoO6TypeEnum {
  INSTAGRAM = 'INSTAGRAM',
  TIKTOK = 'TIKTOK',
  YOUTUBE = 'YOUTUBE',
  ETC = 'ETC',
}

export enum IClinicAdminRoO6StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicSnsRoO8TypeEnum {
  YOUTUBE = 'YOUTUBE',
  INSTAGRAM = 'INSTAGRAM',
  KAKAOTALK = 'KAKAOTALK',
  HOMEPAGE = 'HOMEPAGE',
}

export enum IClinicScheduleRoO8DayEnum {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export enum IAuthOAuthO6OauthProviderEnum {
  KAKAO = 'KAKAO',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
  NAVER = 'NAVER',
  LINE = 'LINE',
}

export enum IAdminReportFindStatusEnum {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
}

export enum IAdminReportFindReasonEnum {
  Value부적절한콘텐츠 = '부적절한 콘텐츠',
  Value광고홍보성콘텐츠 = '광고/홍보성 콘텐츠',
  Value사기피싱콘텐츠 = '사기/피싱 콘텐츠',
  Value기타 = '기타',
}

export enum IAdminReportUpdateStatusEnum {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
}

export enum IClinicAdminRoO7NullableStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IAdminUserRoO8RoleEnum {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  PARTNER_CLINIC = 'PARTNER_CLINIC',
  SYSTEM = 'SYSTEM',
}

export enum IAdminUserRoO8StatusEnum {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  WITHDRAWN = 'WITHDRAWN',
  DELETED = 'DELETED',
}

export enum IContactPointRoO7TypeEnum {
  LINE = 'LINE',
  WHATSAPP = 'WHATSAPP',
  WECHAT = 'WECHAT',
  KAKAOTALK = 'KAKAOTALK',
}

export enum ISnsRoO7TypeEnum {
  INSTAGRAM = 'INSTAGRAM',
  TIKTOK = 'TIKTOK',
  YOUTUBE = 'YOUTUBE',
  ETC = 'ETC',
}

export enum IClinicAdminRoO7StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicSnsRoO9TypeEnum {
  YOUTUBE = 'YOUTUBE',
  INSTAGRAM = 'INSTAGRAM',
  KAKAOTALK = 'KAKAOTALK',
  HOMEPAGE = 'HOMEPAGE',
}

export enum IClinicScheduleRoO9DayEnum {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export enum IAuthOAuthO7OauthProviderEnum {
  KAKAO = 'KAKAO',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
  NAVER = 'NAVER',
  LINE = 'LINE',
}

export enum IAdminUserFindO1RoleEnum {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  PARTNER_CLINIC = 'PARTNER_CLINIC',
  SYSTEM = 'SYSTEM',
}

export enum IAdminUserFindO1StatusEnum {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  WITHDRAWN = 'WITHDRAWN',
  DELETED = 'DELETED',
}

export enum IAdminUserFindO1TypeEnum {
  USER = 'USER',
  CLINIC = 'CLINIC',
  ADMIN = 'ADMIN',
}

export enum IAdminUserUpdateO1RoleEnum {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  PARTNER_CLINIC = 'PARTNER_CLINIC',
  SYSTEM = 'SYSTEM',
}

export enum IAdminUserUpdateO1StatusEnum {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  WITHDRAWN = 'WITHDRAWN',
  DELETED = 'DELETED',
}

export enum IAdminUserUpdateO1TypeEnum {
  LINE = 'LINE',
  WHATSAPP = 'WHATSAPP',
  WECHAT = 'WECHAT',
  KAKAOTALK = 'KAKAOTALK',
}

export enum IAdminUserUpdateO1TypeEnum1 {
  INSTAGRAM = 'INSTAGRAM',
  TIKTOK = 'TIKTOK',
  YOUTUBE = 'YOUTUBE',
  ETC = 'ETC',
}

export enum IAdminUserUpdateO1DayEnum {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export enum IAdminUserUpdateO1TypeEnum2 {
  YOUTUBE = 'YOUTUBE',
  INSTAGRAM = 'INSTAGRAM',
  KAKAOTALK = 'KAKAOTALK',
  HOMEPAGE = 'HOMEPAGE',
}

export enum IAdminUserUpdateO1StatusEnum1 {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export enum IAdminUserUpdateO1LanguageEnum {
  ZhCN = 'zh-CN',
  ZhTW = 'zh-TW',
  Zh = 'zh',
  En = 'en',
  Ko = 'ko',
  Ja = 'ja',
  Th = 'th',
  Mn = 'mn',
  Ru = 'ru',
}

export enum IClinicDoctorProfileRoO1StatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export enum IClinicRoO2StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IReferralPartnerResolveRoDefaultLocaleEnum {
  Ko = 'ko',
  En = 'en',
  Ja = 'ja',
  ZhCN = 'zh-CN',
  ZhTW = 'zh-TW',
  Th = 'th',
  Mn = 'mn',
  Ru = 'ru',
}

export enum IReferralVisitTrackSourceEnum {
  QUERY = 'QUERY',
  SLUG = 'SLUG',
}

export enum IConsultationFormPayloadDataO1NullableGenderEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum IConsultationFormPayloadDataO1NullableFlightBookedEnum {
  YES = 'YES',
  NO = 'NO',
}

export enum IConsultationRequestRoChannelEnum {
  WEB_FORM = 'WEB_FORM',
  WHATSAPP = 'WHATSAPP',
  LINE = 'LINE',
  KAKAO = 'KAKAO',
  OTHER = 'OTHER',
}

export enum IConsultationRequestRoStatusEnum {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  RESERVATION_CONFIRMED = 'RESERVATION_CONFIRMED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export enum IConsultationFormPayloadDataO1GenderEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum IConsultationFormPayloadDataO1FlightBookedEnum {
  YES = 'YES',
  NO = 'NO',
}

export enum IConsultationRequestCreateChannelEnum {
  WEB_FORM = 'WEB_FORM',
  WHATSAPP = 'WHATSAPP',
  LINE = 'LINE',
  KAKAO = 'KAKAO',
  OTHER = 'OTHER',
}

export enum IMediaFindTypeEnum {
  REELS = 'REELS',
  TIKTOK = 'TIKTOK',
  SHORTS = 'SHORTS',
}

export enum IBannerRoO1LanguageEnum {
  ZhCN = 'zh-CN',
  ZhTW = 'zh-TW',
  Zh = 'zh',
  En = 'en',
  Ko = 'ko',
  Ja = 'ja',
  Th = 'th',
  Mn = 'mn',
  Ru = 'ru',
}

export enum IFooterIconRoO1SideEnum {
  Left = 'left',
  Right = 'right',
}

export enum IClinicDoctorProfileRoO3StatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export enum IClinicRoO4StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicSnsRoO11TypeEnum {
  YOUTUBE = 'YOUTUBE',
  INSTAGRAM = 'INSTAGRAM',
  KAKAOTALK = 'KAKAOTALK',
  HOMEPAGE = 'HOMEPAGE',
}

export enum IClinicScheduleRoO11DayEnum {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export enum IClinicDoctorProfileFindOrderEnum {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export enum IClinicDoctorProfileFindMyInterviewsStatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export enum ICommunityArticleArticleListRoInquiryStatusEnum {
  WAITING = 'WAITING',
  ANSWERED = 'ANSWERED',
}

export enum IClinicExperienceSearchQueryOrderByEnum {
  RECENT = 'RECENT',
  LATEST = 'LATEST',
  ORDER = 'ORDER',
  POPULAR = 'POPULAR',
}

export enum ICommunityArticleSiblingsQueryOrderByEnum {
  RECENT = 'RECENT',
  LATEST = 'LATEST',
  ORDER = 'ORDER',
  POPULAR = 'POPULAR',
}

export enum ICommunityArticleSiblingsQueryRangeTypeEnum {
  REALTIME = 'REALTIME',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

export enum ICommunityArticleArticleDetailRoInquiryStatusEnum {
  WAITING = 'WAITING',
  ANSWERED = 'ANSWERED',
}

export enum ICommunityArticleShareShareTypeEnum {
  URL = 'URL',
  FACEBOOK = 'FACEBOOK',
  TWITTER = 'TWITTER',
  WECHAT = 'WECHAT',
  KAKAO = 'KAKAO',
}

export enum IClinicNewEquipmentSiblingsQueryOrderByEnum {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export enum IClinicNewEquipmentRoStatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export enum IClinicRoO7StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicSnsRoO14TypeEnum {
  YOUTUBE = 'YOUTUBE',
  INSTAGRAM = 'INSTAGRAM',
  KAKAOTALK = 'KAKAOTALK',
  HOMEPAGE = 'HOMEPAGE',
}

export enum IClinicScheduleRoO14DayEnum {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export enum IClinicNewEquipmentFindOrderEnum {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export enum IClinicNewEquipmentFindMyEquipmentsStatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export enum ICommunityArticleShareO1ShareTypeEnum {
  URL = 'URL',
  FACEBOOK = 'FACEBOOK',
  TWITTER = 'TWITTER',
  WECHAT = 'WECHAT',
  KAKAO = 'KAKAO',
}

export enum IClinicRoO8NullableStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicPromotionRoO1TypeEnum {
  EVENT = 'EVENT',
  LIMITED = 'LIMITED',
  MEDICAL_PACKAGE = 'MEDICAL_PACKAGE',
}

export enum IClinicPromotionRoO1StatusEnum {
  BEFORE_START = 'BEFORE_START',
  ONGOING = 'ONGOING',
  ENDED = 'ENDED',
}

export enum IClinicRoO8StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicSnsRoO15TypeEnum {
  YOUTUBE = 'YOUTUBE',
  INSTAGRAM = 'INSTAGRAM',
  KAKAOTALK = 'KAKAOTALK',
  HOMEPAGE = 'HOMEPAGE',
}

export enum IClinicScheduleRoO15DayEnum {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export enum IClinicPromotionFindOrderEnum {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export enum IClinicPromotionFindTypesEnum {
  EVENT = 'EVENT',
  LIMITED = 'LIMITED',
  MEDICAL_PACKAGE = 'MEDICAL_PACKAGE',
}

export enum IClinicReviewRoTypeEnum {
  MEDICAL = 'MEDICAL',
  EXPERIMENT = 'EXPERIMENT',
  BEFORE_AFTER = 'BEFORE_AFTER',
}

export enum IClinicRoO9StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicSnsRoO16TypeEnum {
  YOUTUBE = 'YOUTUBE',
  INSTAGRAM = 'INSTAGRAM',
  KAKAOTALK = 'KAKAOTALK',
  HOMEPAGE = 'HOMEPAGE',
}

export enum IClinicScheduleRoO16DayEnum {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export enum IClinicReviewCreateTypeEnum {
  MEDICAL = 'MEDICAL',
  EXPERIMENT = 'EXPERIMENT',
  BEFORE_AFTER = 'BEFORE_AFTER',
}

export enum IClinicReviewFindMyClinicReviewTypesEnum {
  MEDICAL = 'MEDICAL',
  EXPERIMENT = 'EXPERIMENT',
  BEFORE_AFTER = 'BEFORE_AFTER',
}

export enum IClinicReviewFindClinicReviewTypesEnum {
  MEDICAL = 'MEDICAL',
  EXPERIMENT = 'EXPERIMENT',
  BEFORE_AFTER = 'BEFORE_AFTER',
}

export enum IClinicReviewFindClinicReviewOrderEnum {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export enum IClinicReviewDetailRoTypeEnum {
  MEDICAL = 'MEDICAL',
  EXPERIMENT = 'EXPERIMENT',
  BEFORE_AFTER = 'BEFORE_AFTER',
}

export enum IClinicReviewSiblingsQueryOrderByEnum {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export enum IClinicReviewSiblingsQueryTypeEnum {
  MEDICAL = 'MEDICAL',
  EXPERIMENT = 'EXPERIMENT',
  BEFORE_AFTER = 'BEFORE_AFTER',
}

export enum ICommunityArticleShareO2ShareTypeEnum {
  URL = 'URL',
  FACEBOOK = 'FACEBOOK',
  TWITTER = 'TWITTER',
  WECHAT = 'WECHAT',
  KAKAO = 'KAKAO',
}

export enum IClinicRoO10StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicSnsRoO17TypeEnum {
  YOUTUBE = 'YOUTUBE',
  INSTAGRAM = 'INSTAGRAM',
  KAKAOTALK = 'KAKAOTALK',
  HOMEPAGE = 'HOMEPAGE',
}

export enum IClinicScheduleRoO17DayEnum {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export enum IClinicDetailRoStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicDoctorProfileRoO10StatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export enum IClinicRoO11StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicSnsRoO18TypeEnum {
  YOUTUBE = 'YOUTUBE',
  INSTAGRAM = 'INSTAGRAM',
  KAKAOTALK = 'KAKAOTALK',
  HOMEPAGE = 'HOMEPAGE',
}

export enum IClinicScheduleRoO18DayEnum {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export enum IClinicSnsSaveTypeEnum {
  YOUTUBE = 'YOUTUBE',
  INSTAGRAM = 'INSTAGRAM',
  KAKAOTALK = 'KAKAOTALK',
  HOMEPAGE = 'HOMEPAGE',
}

export enum IClinicFindOrderEnum {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export enum IClinicMineStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum ICommunityArticleSiblingsQueryO1OrderByEnum {
  RECENT = 'RECENT',
  LATEST = 'LATEST',
  ORDER = 'ORDER',
  POPULAR = 'POPULAR',
}

export enum ICommunityArticleSiblingsQueryO1RangeTypeEnum {
  REALTIME = 'REALTIME',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

export enum ICommunityArticleArticleListRoO1InquiryStatusEnum {
  WAITING = 'WAITING',
  ANSWERED = 'ANSWERED',
}

export enum ICommunityArticleSearchQueryRangeTypeEnum {
  REALTIME = 'REALTIME',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

export enum ICommunityArticleSearchQueryOrderByEnum {
  RECENT = 'RECENT',
  LATEST = 'LATEST',
  ORDER = 'ORDER',
  POPULAR = 'POPULAR',
}

export enum ICommunityArticleBaseSearchQueryRangeTypeEnum {
  REALTIME = 'REALTIME',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

export enum ICommunityArticleBaseSearchQueryOrderByEnum {
  RECENT = 'RECENT',
  LATEST = 'LATEST',
  ORDER = 'ORDER',
  POPULAR = 'POPULAR',
}

export enum ICommunityArticleInquiryRoInquiryStatusEnum {
  WAITING = 'WAITING',
  ANSWERED = 'ANSWERED',
}

export enum IProductRoCategoryEnum {
  Value기초케어 = '기초케어',
  Value진정관리 = '진정관리',
  Value시술후추천템 = '시술후추천템',
}

export enum IProductRoStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IProductFindCategoryEnum {
  Value기초케어 = '기초케어',
  Value진정관리 = '진정관리',
  Value시술후추천템 = '시술후추천템',
}

export enum IProductFindOrderEnum {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export enum IReportCreateReportTargetEnum {
  CommunityArticle = 'communityArticle',
  ClinicReview = 'clinicReview',
  ClinicNewEquipment = 'clinicNewEquipment',
}

export enum IReportCreateReportReasonEnum {
  Value부적절한콘텐츠 = '부적절한 콘텐츠',
  Value광고홍보성콘텐츠 = '광고/홍보성 콘텐츠',
  Value사기피싱콘텐츠 = '사기/피싱 콘텐츠',
  Value기타 = '기타',
}

export enum IContactPointSignupTypeEnum {
  LINE = 'LINE',
  WHATSAPP = 'WHATSAPP',
  WECHAT = 'WECHAT',
  KAKAOTALK = 'KAKAOTALK',
}

export enum ISnsSignupTypeEnum {
  INSTAGRAM = 'INSTAGRAM',
  TIKTOK = 'TIKTOK',
  YOUTUBE = 'YOUTUBE',
  ETC = 'ETC',
}

export enum IUserCheckEmailRoStatusEnum {
  AVAILABLE = 'AVAILABLE',
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  INVALID_FORMAT = 'INVALID_FORMAT',
}

export enum IUserCheckEmailTypeEnum {
  Signup = 'signup',
  Modify = 'modify',
}

export enum IUserCheckNicknameRoStatusEnum {
  AVAILABLE = 'AVAILABLE',
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  MIN_LENGTH = 'MIN_LENGTH',
  MAX_LENGTH = 'MAX_LENGTH',
  FORBIDDEN = 'FORBIDDEN',
}

export enum IUserCheckNicknameTypeEnum {
  Signup = 'signup',
  Modify = 'modify',
}

export enum IUserMineRoleEnum {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  PARTNER_CLINIC = 'PARTNER_CLINIC',
  SYSTEM = 'SYSTEM',
}

export enum IContactPointRoO8TypeEnum {
  LINE = 'LINE',
  WHATSAPP = 'WHATSAPP',
  WECHAT = 'WECHAT',
  KAKAOTALK = 'KAKAOTALK',
}

export enum ISnsRoO8TypeEnum {
  INSTAGRAM = 'INSTAGRAM',
  TIKTOK = 'TIKTOK',
  YOUTUBE = 'YOUTUBE',
  ETC = 'ETC',
}

export enum IAuthOAuthO8OauthProviderEnum {
  KAKAO = 'KAKAO',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
  NAVER = 'NAVER',
  LINE = 'LINE',
}

export enum IClinicReviewRoO1TypeEnum {
  MEDICAL = 'MEDICAL',
  EXPERIMENT = 'EXPERIMENT',
  BEFORE_AFTER = 'BEFORE_AFTER',
}

export enum IClinicRoO14StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicSnsRoO21TypeEnum {
  YOUTUBE = 'YOUTUBE',
  INSTAGRAM = 'INSTAGRAM',
  KAKAOTALK = 'KAKAOTALK',
  HOMEPAGE = 'HOMEPAGE',
}

export enum IClinicScheduleRoO21DayEnum {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export enum IUserFindMyReviewTypesEnum {
  MEDICAL = 'MEDICAL',
  EXPERIMENT = 'EXPERIMENT',
  BEFORE_AFTER = 'BEFORE_AFTER',
}

export enum IClinicRoO14NullableStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IClinicPromotionRoO2TypeEnum {
  EVENT = 'EVENT',
  LIMITED = 'LIMITED',
  MEDICAL_PACKAGE = 'MEDICAL_PACKAGE',
}

export enum IClinicPromotionRoO2StatusEnum {
  BEFORE_START = 'BEFORE_START',
  ONGOING = 'ONGOING',
  ENDED = 'ENDED',
}

export enum IUserFindMyPromotionTypeEnum {
  EVENT = 'EVENT',
  LIMITED = 'LIMITED',
  MEDICAL_PACKAGE = 'MEDICAL_PACKAGE',
}

export enum ICommunityArticleArticleListRoO2InquiryStatusEnum {
  WAITING = 'WAITING',
  ANSWERED = 'ANSWERED',
}

export enum IUserFindMyLikeTypeEnum {
  COMMUNITY = 'COMMUNITY',
  CLINIC_REVIEW = 'CLINIC_REVIEW',
  ARTICLE = 'ARTICLE',
  CLINIC_EXPERIENCE = 'CLINIC_EXPERIENCE',
  CLINIC_NEW_EQUIPMENT = 'CLINIC_NEW_EQUIPMENT',
}

export enum ICommentCommentRoWithArticleInfoTypeEnum {
  COMMUNITY = 'COMMUNITY',
  CLINIC_REVIEW = 'CLINIC_REVIEW',
  ARTICLE = 'ARTICLE',
}

export enum IUserFindMyCommentsTypeEnum {
  COMMUNITY = 'COMMUNITY',
  CLINIC_REVIEW = 'CLINIC_REVIEW',
  ARTICLE = 'ARTICLE',
  CLINIC_EXPERIENCE = 'CLINIC_EXPERIENCE',
  CLINIC_NEW_EQUIPMENT = 'CLINIC_NEW_EQUIPMENT',
}

export enum IUserFindEmailRoStatusEnum {
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}

export enum IUserFindPasswordRoStatusEnum {
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}

export enum IUserResendPasswordRoStatusEnum {
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}

export enum IUserChangePasswordRoStatusEnum {
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
  EXPIRED = 'EXPIRED',
}

export enum IPointHistoryRoTypeEnum {
  EARN = 'EARN',
  USE = 'USE',
  RECOVER = 'RECOVER',
  EXPIRE = 'EXPIRE',
}

export enum IPointHistoryGetTransactionsQueryTransactionTypeEnum {
  EARN = 'EARN',
  USE = 'USE',
  RECOVER = 'RECOVER',
  EXPIRE = 'EXPIRE',
}

export enum IPointEarnReferenceTypeEnum {
  SIGNUP = 'SIGNUP',
  WRITE_PROFILE = 'WRITE_PROFILE',
  ORDER = 'ORDER',
  EVENT = 'EVENT',
  REFERRAL = 'REFERRAL',
  REVIEW = 'REVIEW',
  COMMENT = 'COMMENT',
  DAILY = 'DAILY',
  EXPIRE = 'EXPIRE',
  ADMIN = 'ADMIN',
  COMMUNITY = 'COMMUNITY',
  FIRST_COMMENT = 'FIRST_COMMENT',
  FIRST_COMMUNITY = 'FIRST_COMMUNITY',
}

export enum IPointUseReferenceTypeEnum {
  SIGNUP = 'SIGNUP',
  WRITE_PROFILE = 'WRITE_PROFILE',
  ORDER = 'ORDER',
  EVENT = 'EVENT',
  REFERRAL = 'REFERRAL',
  REVIEW = 'REVIEW',
  COMMENT = 'COMMENT',
  DAILY = 'DAILY',
  EXPIRE = 'EXPIRE',
  ADMIN = 'ADMIN',
  COMMUNITY = 'COMMUNITY',
  FIRST_COMMENT = 'FIRST_COMMENT',
  FIRST_COMMUNITY = 'FIRST_COMMUNITY',
}

export enum LoadedPointRuleneverNeverNullableReferenceTypeEnum {
  SIGNUP = 'SIGNUP',
  WRITE_PROFILE = 'WRITE_PROFILE',
  ORDER = 'ORDER',
  EVENT = 'EVENT',
  REFERRAL = 'REFERRAL',
  REVIEW = 'REVIEW',
  COMMENT = 'COMMENT',
  DAILY = 'DAILY',
  EXPIRE = 'EXPIRE',
  ADMIN = 'ADMIN',
  COMMUNITY = 'COMMUNITY',
  FIRST_COMMENT = 'FIRST_COMMENT',
  FIRST_COMMUNITY = 'FIRST_COMMUNITY',
}

export enum IAdminUserRoO8NullableRoleEnum {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  PARTNER_CLINIC = 'PARTNER_CLINIC',
  SYSTEM = 'SYSTEM',
}

export enum IAdminUserRoO8NullableStatusEnum {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  WITHDRAWN = 'WITHDRAWN',
  DELETED = 'DELETED',
}

export type GetNotificationHistoryListData = IAdminNotificationNotificationLogRO[]

export type GetNotificationHistoryDetailData = IAdminNotificationNotificationLogRO

export type SendNotificationData = IAdminNotificationNotificationLogRO

export type CreateAdminData = IAdminUserRO

export interface GetAdminsParams {
  q?: string
}

export type GetAdminsData = IAdminUserRO[]

export type UpdateAdminData = IAdminUserRO

export type DeleteAdminData = boolean

export type GetAdminData = IAdminUserRO

export type LoginData = IAuthLoginRO

export type AssetsDetailData = IAssetAssetRO

export type UploadCreateData = IAssetAssetRO

export interface ValidateParams {
  provider: ProviderEnum
  code?: string
  token?: string
  noRedirect?: boolean
}

export enum ProviderEnum {
  KAKAO = 'KAKAO',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
  NAVER = 'NAVER',
  LINE = 'LINE',
}

export type ValidateData = any

export enum ValidateParams1ProviderEnum {
  KAKAO = 'KAKAO',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
  NAVER = 'NAVER',
  LINE = 'LINE',
}

export interface ValidateCreateParams {
  provider: ProviderEnum1
}

export enum ProviderEnum1 {
  KAKAO = 'KAKAO',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
  NAVER = 'NAVER',
  LINE = 'LINE',
}

export type ValidateCreateData = any

export enum ValidateCreateParams1ProviderEnum {
  KAKAO = 'KAKAO',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
  NAVER = 'NAVER',
  LINE = 'LINE',
}

export type GetTokenData = IAuthAccessTokenRO

export type SigninEmailData = any

export type SigninSocialData = any

export type TranslateTextData = ITranslationResult

export interface TranslateMultipleTextsParams {
  texts: string[]
  sourceLanguage?: SourceLanguageEnum
  targetLanguage?: TargetLanguageEnum
}

export enum SourceLanguageEnum {
  ZhCN = 'zh-CN',
  ZhTW = 'zh-TW',
  Zh = 'zh',
  En = 'en',
  Ko = 'ko',
  Ja = 'ja',
  Th = 'th',
  Mn = 'mn',
  Ru = 'ru',
}

export enum TargetLanguageEnum {
  ZhCN = 'zh-CN',
  ZhTW = 'zh-TW',
  Zh = 'zh',
  En = 'en',
  Ko = 'ko',
  Ja = 'ja',
  Th = 'th',
  Mn = 'mn',
  Ru = 'ru',
}

export type TranslateMultipleTextsData = ITranslationResult[]

export enum TranslateMultipleTextsParams1SourceLanguageEnum {
  ZhCN = 'zh-CN',
  ZhTW = 'zh-TW',
  Zh = 'zh',
  En = 'en',
  Ko = 'ko',
  Ja = 'ja',
  Th = 'th',
  Mn = 'mn',
  Ru = 'ru',
}

export enum TranslateMultipleTextsParams1TargetLanguageEnum {
  ZhCN = 'zh-CN',
  ZhTW = 'zh-TW',
  Zh = 'zh',
  En = 'en',
  Ko = 'ko',
  Ja = 'ja',
  Th = 'th',
  Mn = 'mn',
  Ru = 'ru',
}

export type GetTranslateSpreadsheetData = RecordstringRecordstringstring

export interface SetCacheDurationParams {
  hours: number
}

export interface SetCacheDurationData {
  message: string
}

export interface InvalidateCacheData {
  message: string
}

export interface AdminBannerListData {
  items: IBannerRO[]
  total: number
}

export type AdminBannerCreateData = any

export type CheckOrderDetailData = boolean

export type AdminBannerDetailData = IBannerRO

export type AdminBannerUpdateData = any

export type AdminBannerDeleteData = any

export interface AdminBusinessInquiryListParams {
  page: number
  q?: string
  status?: StatusEnum
}

export enum StatusEnum {
  PENDING = 'PENDING',
  CONTACTING = 'CONTACTING',
  CONTACT_COMPLETED = 'CONTACT_COMPLETED',
  PARTNERSHIP_COMPLETED = 'PARTNERSHIP_COMPLETED',
  ON_HOLD = 'ON_HOLD',
  ENDED = 'ENDED',
}

export interface AdminBusinessInquiryListData {
  items: LoadedBusinessInquiryneverNever[]
  total: number
}

export enum AdminBusinessInquiryListParams1StatusEnum {
  PENDING = 'PENDING',
  CONTACTING = 'CONTACTING',
  CONTACT_COMPLETED = 'CONTACT_COMPLETED',
  PARTNERSHIP_COMPLETED = 'PARTNERSHIP_COMPLETED',
  ON_HOLD = 'ON_HOLD',
  ENDED = 'ENDED',
}

export type AdminBusinessInquiryDetailData = LoadedBusinessInquiryneverNever

export type AdminBusinessInquiryUpdateData = any

export type AdminBusinessInquiryDeleteData = any

export interface AdminCategoryListData {
  items: ICategoryROO1[]
  total: number
}

export type AdminCategoryCreateData = ICategoryROO1

export type AdminCategoryDetailData = ICategoryROO1

export type AdminCategoryUpdateData = ICategoryROO1

export type AdminCategoryDeleteData = any

export type ApproveNewEquipmentData = any

export interface AdminClinicListParams {
  page: number
  q?: string
  categoryIds: number[]
  regionIds: number[]
  status?: StatusEnum1
}

export enum StatusEnum1 {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export interface AdminClinicListData {
  users: IAdminUserROO1[]
  total: number
}

export enum AdminClinicListParams1StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export type AdminClinicCreateData = any

export type AdminClinicDetailData = IAdminUserROO1

export type AdminClinicCreate2Data = any

export type InactiveCreateData = any

export interface AdminClinicInterviewListParams {
  page: number
  q?: string
  statusList: StatusListEnum[]
}

export enum StatusListEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export type AdminClinicInterviewListData = IPaginationROIAdminClinicInterviewROnumber

export enum AdminClinicInterviewListParams1StatusListEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export type AdminClinicInterviewDetailData = IAdminClinicInterviewRO

export type ApproveClinicDoctorProfileData = any

export interface DoctorProfileRejectMultipleCreatePayload {
  ids: number[]
}

export type DoctorProfileRejectMultipleCreateData = any

export interface GetCommentListParams {
  q?: string
  /** 댓글 조회 시 게시글 아이디 */
  articleId?: number
  /**
   * 댓글 조회 시 게시글 타입
   * - CLINIC_REVIEW: 병원 리뷰
   * - CLINIC_EXPERIENCE: 체험단 구인구직
   * - COMMUNITY_ARTICLE: 커뮤니티 게시글
   * - CLINIC_EQUIPMENT: 병원 신규 장비
   */
  articleType: ArticleTypeEnum
  status?: StatusEnum2
  page: number
  pageSize: number
}

/**
 * 댓글 조회 시 게시글 타입
 * - CLINIC_REVIEW: 병원 리뷰
 * - CLINIC_EXPERIENCE: 체험단 구인구직
 * - COMMUNITY_ARTICLE: 커뮤니티 게시글
 * - CLINIC_EQUIPMENT: 병원 신규 장비
 */
export enum ArticleTypeEnum {
  ClinicReview = 'clinic_review',
  ClinicExperience = 'clinic_experience',
  CommunityArticle = 'community_article',
  ClinicEquipment = 'clinic_equipment',
}

export enum StatusEnum2 {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export type GetCommentListData = IAdminPaginationROIAdminCommentRO

/**
 * 댓글 조회 시 게시글 타입
 * - CLINIC_REVIEW: 병원 리뷰
 * - CLINIC_EXPERIENCE: 체험단 구인구직
 * - COMMUNITY_ARTICLE: 커뮤니티 게시글
 * - CLINIC_EQUIPMENT: 병원 신규 장비
 */
export enum GetCommentListParams1ArticleTypeEnum {
  ClinicReview = 'clinic_review',
  ClinicExperience = 'clinic_experience',
  CommunityArticle = 'community_article',
  ClinicEquipment = 'clinic_equipment',
}

export enum GetCommentListParams1StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export interface GetCommentDetailParams {
  q?: string
  /** 댓글 조회 시 게시글 아이디 */
  articleId?: number
  /**
   * 댓글 조회 시 게시글 타입
   * - CLINIC_REVIEW: 병원 리뷰
   * - CLINIC_EXPERIENCE: 체험단 구인구직
   * - COMMUNITY_ARTICLE: 커뮤니티 게시글
   * - CLINIC_EQUIPMENT: 병원 신규 장비
   */
  articleType: ArticleTypeEnum1
  status?: StatusEnum3
  page: number
  pageSize: number
  id: number
}

/**
 * 댓글 조회 시 게시글 타입
 * - CLINIC_REVIEW: 병원 리뷰
 * - CLINIC_EXPERIENCE: 체험단 구인구직
 * - COMMUNITY_ARTICLE: 커뮤니티 게시글
 * - CLINIC_EQUIPMENT: 병원 신규 장비
 */
export enum ArticleTypeEnum1 {
  ClinicReview = 'clinic_review',
  ClinicExperience = 'clinic_experience',
  CommunityArticle = 'community_article',
  ClinicEquipment = 'clinic_equipment',
}

export enum StatusEnum3 {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export type GetCommentDetailData = IAdminCommentRO

/**
 * 댓글 조회 시 게시글 타입
 * - CLINIC_REVIEW: 병원 리뷰
 * - CLINIC_EXPERIENCE: 체험단 구인구직
 * - COMMUNITY_ARTICLE: 커뮤니티 게시글
 * - CLINIC_EQUIPMENT: 병원 신규 장비
 */
export enum GetCommentDetailParams1ArticleTypeEnum {
  ClinicReview = 'clinic_review',
  ClinicExperience = 'clinic_experience',
  CommunityArticle = 'community_article',
  ClinicEquipment = 'clinic_equipment',
}

export enum GetCommentDetailParams1StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export type AdminCommentDeleteData = any

export type AdminCommentPartialUpdateData = any

export interface GetCommunityArticleListParams {
  page: number
  pageSize: number
  q?: string
  categoryId?: number
  boardId?: number
  status?: StatusEnum4
}

export enum StatusEnum4 {
  VISIBLE = 'VISIBLE',
  HIDDEN = 'HIDDEN',
}

export type GetCommunityArticleListData = IAdminPaginationROIAdminCommunityRO

export enum GetCommunityArticleListParams1StatusEnum {
  VISIBLE = 'VISIBLE',
  HIDDEN = 'HIDDEN',
}

export type CreateCommunityNoticeData = number

export type GetCommunityArticleDetailData = IAdminCommunityRO

export type UpdateCommunityArticleData = IAdminCommunityRO

export type DeleteCommunityArticleData = IAdminCommunityRO

export type UpdateCommunityNoticeData = number

export interface AdminConsultationRequestListParams {
  page: number
  q?: string
  status?: StatusEnum5
  referralPartnerId?: number
  fromDate?: string
  toDate?: string
}

export enum StatusEnum5 {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  RESERVATION_CONFIRMED = 'RESERVATION_CONFIRMED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export interface AdminConsultationRequestListData {
  items: IAdminConsultationRequestRO[]
  total: number
}

export enum AdminConsultationRequestListParams1StatusEnum {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  RESERVATION_CONFIRMED = 'RESERVATION_CONFIRMED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export type AdminConsultationRequestCreateData = IAdminConsultationRequestRO

export type AdminConsultationRequestDetailData = IAdminConsultationRequestRO

export type AdminConsultationRequestUpdateData = IAdminConsultationRequestRO

export type AdminConsultationRequestDeleteData = any

export interface GetExperienceListParams {
  q?: string
  page: number
  pageSize: number
  categoryId?: number
  regionId?: number
}

export type GetExperienceListData = IAdminPaginationROIAdminExperienceRO

export type GetExperienceDetailData = IAdminExperienceRO

export type UpdateExperienceData = IAdminExperienceRO

export interface AdminFaqListData {
  items: IFaqRO[]
  total: number
}

export type AdminFaqCreateData = any

export type AdminFaqDeleteData = any

export type AdminFaqDetailData = IFaqRO

export type AdminFaqUpdateData = any

export interface AdminFooterIconListData {
  items: IFooterIconRO[]
  total: number
}

export type AdminFooterIconCreateData = any

export type CheckOrderDetailResult = boolean

export enum CheckOrderDetailParams1SideEnum {
  Left = 'left',
  Right = 'right',
}

export enum CheckOrderDetailParams1Enum {
  Left = 'left',
  Right = 'right',
}

export type AdminFooterIconDetailData = IFooterIconRO

export type AdminFooterIconUpdateData = any

export type AdminFooterIconDeleteData = any

export interface AdminClinicNewEquipmentListParams {
  page: number
  q?: string
  statusList: StatusListEnum1[]
}

export enum StatusListEnum1 {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export type AdminClinicNewEquipmentListData = IPaginationROIAdminClinicNewEquipmentROnumber

export enum AdminClinicNewEquipmentListParams1StatusListEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export type AdminClinicNewEquipmentDetailData = IAdminClinicNewEquipmentRO

export type ApproveClinicNewEquipmentData = any

export interface RejectMultipleCreatePayload {
  ids: number[]
}

export type RejectMultipleCreateData = any

export interface AdminNoticeListData {
  items: INoticeRO[]
  total: number
}

export type AdminNoticeCreateData = INoticeRO

export type AdminNoticeDetailData = INoticeRO

export type AdminNoticeUpdateData = INoticeRO

export interface AdminNoticeDeleteData {
  success: boolean
}

export interface AdminPointListParams {
  page: number
  q?: string
  types: TypesEnum[]
  referenceTypes: ReferenceTypesEnum[]
  /** @format date */
  startDate?: string
  /** @format date */
  endDate?: string
  userId?: number
  flag?: string
}

export enum TypesEnum {
  EARN = 'EARN',
  USE = 'USE',
  RECOVER = 'RECOVER',
  EXPIRE = 'EXPIRE',
}

export enum ReferenceTypesEnum {
  SIGNUP = 'SIGNUP',
  WRITE_PROFILE = 'WRITE_PROFILE',
  ORDER = 'ORDER',
  EVENT = 'EVENT',
  REFERRAL = 'REFERRAL',
  REVIEW = 'REVIEW',
  COMMENT = 'COMMENT',
  DAILY = 'DAILY',
  EXPIRE = 'EXPIRE',
  ADMIN = 'ADMIN',
  COMMUNITY = 'COMMUNITY',
  FIRST_COMMENT = 'FIRST_COMMENT',
  FIRST_COMMUNITY = 'FIRST_COMMUNITY',
}

export type AdminPointListData = IPaginationROIAdminPointTransactionROnumber

export enum AdminPointListParams1TypesEnum {
  EARN = 'EARN',
  USE = 'USE',
  RECOVER = 'RECOVER',
  EXPIRE = 'EXPIRE',
}

export enum AdminPointListParams1ReferenceTypesEnum {
  SIGNUP = 'SIGNUP',
  WRITE_PROFILE = 'WRITE_PROFILE',
  ORDER = 'ORDER',
  EVENT = 'EVENT',
  REFERRAL = 'REFERRAL',
  REVIEW = 'REVIEW',
  COMMENT = 'COMMENT',
  DAILY = 'DAILY',
  EXPIRE = 'EXPIRE',
  ADMIN = 'ADMIN',
  COMMUNITY = 'COMMUNITY',
  FIRST_COMMENT = 'FIRST_COMMENT',
  FIRST_COMMUNITY = 'FIRST_COMMUNITY',
}

export type AdminPointCreateData = any

export type AdminPointDetailData = IAdminPointTransactionRO

export type AdminPointRuleListData = IPaginationROIAdminPointRuleROnumber

export type AdminPointRuleDetailData = LoadedPointRuleneverNeverNullable

export type AdminPointRuleUpdateData = any

export type AdminPointRuleDeleteData = any

export interface GetAdminProductsParams {
  q?: string
  page: number
  category?: CategoryEnum
  status?: StatusEnum6
  order?: OrderEnum
}

export enum CategoryEnum {
  Value기초케어 = '기초케어',
  Value진정관리 = '진정관리',
  Value시술후추천템 = '시술후추천템',
}

export enum StatusEnum6 {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum OrderEnum {
  LATEST = 'LATEST',
  OLDEST = 'OLDEST',
  POPULAR = 'POPULAR',
  PRICE_HIGH = 'PRICE_HIGH',
  PRICE_LOW = 'PRICE_LOW',
}

export type GetAdminProductsData = IPaginationROIAdminProductROnumber

export enum GetAdminProductsParams1CategoryEnum {
  Value기초케어 = '기초케어',
  Value진정관리 = '진정관리',
  Value시술후추천템 = '시술후추천템',
}

export enum GetAdminProductsParams1StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum GetAdminProductsParams1OrderEnum {
  LATEST = 'LATEST',
  OLDEST = 'OLDEST',
  POPULAR = 'POPULAR',
  PRICE_HIGH = 'PRICE_HIGH',
  PRICE_LOW = 'PRICE_LOW',
}

export type CreateAdminProductData = IAdminProductRO

export type GetAdminProductData = IAdminProductRO

export type UpdateAdminProductData = IAdminProductRO

export interface DeleteAdminProductData {
  success: boolean
}

export interface AdminPromotionListParams {
  q?: string
  type: TypeEnum[]
  categoryIds: number[]
  regionIds: number[]
  status: StatusEnum7[]
  page: number
  /** @format date */
  startDate?: string
  /** @format date */
  endDate?: string
}

export enum TypeEnum {
  EVENT = 'EVENT',
  LIMITED = 'LIMITED',
  MEDICAL_PACKAGE = 'MEDICAL_PACKAGE',
}

export enum StatusEnum7 {
  BEFORE_START = 'BEFORE_START',
  ONGOING = 'ONGOING',
  ENDED = 'ENDED',
}

export interface AdminPromotionListData {
  items: IAdminPromotionRO[]
  total: number
}

export enum AdminPromotionListParams1TypeEnum {
  EVENT = 'EVENT',
  LIMITED = 'LIMITED',
  MEDICAL_PACKAGE = 'MEDICAL_PACKAGE',
}

export enum AdminPromotionListParams1StatusEnum {
  BEFORE_START = 'BEFORE_START',
  ONGOING = 'ONGOING',
  ENDED = 'ENDED',
}

export type AdminPromotionCreateData = IClinicPromotionRO

export type AdminPromotionDetailData = IAdminPromotionDetailRO

export type AdminPromotionUpdateData = IClinicPromotionRO

export type FinishUpdateData = any

export type ParticipantDeleteData = any

export interface GetQnaListParams {
  q?: string
  status?: StatusEnum8
  page: number
  pageSize: number
}

export enum StatusEnum8 {
  WAITING = 'WAITING',
  ANSWERED = 'ANSWERED',
}

export type GetQnaListData = IAdminPaginationROIAdminQnaRO

export enum GetQnaListParams1StatusEnum {
  WAITING = 'WAITING',
  ANSWERED = 'ANSWERED',
}

export type GetQnaDetailData = IAdminQnaRO

export type UpdateQnaData = IAdminQnaRO

export interface AdminReferralPartnerListParams {
  page: number
  q?: string
  status?: StatusEnum9
}

export enum StatusEnum9 {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export interface AdminReferralPartnerListData {
  items: IReferralPartnerRO[]
  total: number
}

export enum AdminReferralPartnerListParams1StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export type AdminReferralPartnerCreateData = IReferralPartnerRO

export interface CheckCodeListParams {
  code: string
  excludeId?: number
}

export type CheckCodeListData = IAdminReferralPartnerCheckCodeRO

export type AdminReferralPartnerDetailData = IReferralPartnerRO

export type AdminReferralPartnerUpdateData = IReferralPartnerRO

export interface AdminReferralRevenueListParams {
  page: number
  referralPartnerId?: number
  fromDate?: string
  toDate?: string
}

export interface AdminReferralRevenueListData {
  items: IAdminReferralRevenueRO[]
  total: number
}

export type AdminReferralRevenueCreateData = any

export type AdminReferralRevenueDetailData = IAdminReferralRevenueRO

export type AdminReferralRevenueUpdateData = IAdminReferralRevenueRO

export type AdminReferralRevenueDeleteData = any

export interface AdminReferralStatsListParams {
  referralPartnerId?: number
  fromDate?: string
  toDate?: string
}

export type AdminReferralStatsListData = IAdminReferralStatsRO

export interface RevenueDetailsListParams {
  referralPartnerId: number
  fromDate?: string
  toDate?: string
}

export type RevenueDetailsListData = IAdminReferralStatsRevenueDetailsRO

export interface ReservationDetailsListParams {
  referralPartnerId: number
  fromDate?: string
  toDate?: string
}

export type ReservationDetailsListData = IAdminReferralStatsReservationDetailsRO

export interface AdminRegionListData {
  items: IRegionROO8[]
  total: number
}

export type AdminRegionCreateData = IRegionROO8

export type AdminRegionDetailData = IRegionROO8

export type AdminRegionUpdateData = IRegionROO8

export type AdminRegionDeleteData = any

export interface GetReportListParams {
  page: number
  pageSize: number
  q?: string
  status?: StatusEnum10
  reason?: ReasonEnum
}

export enum StatusEnum10 {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
}

export enum ReasonEnum {
  Value부적절한콘텐츠 = '부적절한 콘텐츠',
  Value광고홍보성콘텐츠 = '광고/홍보성 콘텐츠',
  Value사기피싱콘텐츠 = '사기/피싱 콘텐츠',
  Value기타 = '기타',
}

export type GetReportListData = IAdminPaginationROIAdminReportRO

export enum GetReportListParams1StatusEnum {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
}

export enum GetReportListParams1ReasonEnum {
  Value부적절한콘텐츠 = '부적절한 콘텐츠',
  Value광고홍보성콘텐츠 = '광고/홍보성 콘텐츠',
  Value사기피싱콘텐츠 = '사기/피싱 콘텐츠',
  Value기타 = '기타',
}

export type GetReportDetailData = IAdminReportRO

export type UpdateReportData = IAdminReportRO

export interface AdminUserListParams {
  q?: string
  page: number
  role?: RoleEnum
  status?: StatusEnum11
  type: TypeEnum1
  nation?: string
  pageSize?: number
}

export enum RoleEnum {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  PARTNER_CLINIC = 'PARTNER_CLINIC',
  SYSTEM = 'SYSTEM',
}

export enum StatusEnum11 {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  WITHDRAWN = 'WITHDRAWN',
  DELETED = 'DELETED',
}

export enum TypeEnum1 {
  USER = 'USER',
  CLINIC = 'CLINIC',
  ADMIN = 'ADMIN',
}

export interface AdminUserListData {
  users: IAdminUserROO8[]
  total: number
}

export enum AdminUserListParams1RoleEnum {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  PARTNER_CLINIC = 'PARTNER_CLINIC',
  SYSTEM = 'SYSTEM',
}

export enum AdminUserListParams1StatusEnum {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  WITHDRAWN = 'WITHDRAWN',
  DELETED = 'DELETED',
}

export enum AdminUserListParams1TypeEnum {
  USER = 'USER',
  CLINIC = 'CLINIC',
  ADMIN = 'ADMIN',
}

export type AdminUserDetailData = IAdminUserROO8Nullable

export type AdminUserUpdateData = IAdminUserROO8Nullable

export type CreateBusinessInquiryData = IBusinessInquiryRO

export interface ResolveReferralBySlugParams {
  slug: string
}

export type ResolveReferralBySlugData = IReferralPartnerResolveRO

export interface ValidateReferralCodeParams {
  code: string
}

export type ValidateReferralCodeData = IReferralPartnerValidateRO

export type ListReferralPartnersData = IReferralPartnerPublicListItem[]

export type TrackReferralVisitData = any

export type CreateConsultationRequestData = IConsultationRequestRO

export interface GetCategoryListParams {
  includeCommon?: boolean
}

export type GetCategoryListData = ICategoryROO11[]

export type GetRegionListData = IRegionROO11[]

export interface GetMediaParams {
  type: TypeEnum2
  categoryIds: number[]
  regionIds: number[]
  search?: string
  page?: number
  cursor?: number
}

export enum TypeEnum2 {
  REELS = 'REELS',
  TIKTOK = 'TIKTOK',
  SHORTS = 'SHORTS',
}

export type GetMediaData = IPaginationROIMediaROnumber

export enum GetMediaParams1TypeEnum {
  REELS = 'REELS',
  TIKTOK = 'TIKTOK',
  SHORTS = 'SHORTS',
}

export type GetBannerListData = IBannerROO1[]

export type GetNoticeListData = INoticeROO1[]

export type GetFooterIconListData = IFooterIconROO1[]

export type CreateErrorLogData = IErrorLogRO

export type CreateClinicDoctorProfileData = IClinicDoctorProfileROO3

export interface FindClinicDoctorProfilesParams {
  order: OrderEnum1
  categoryIds: number[]
  regionIds: number[]
  keyword?: string
  page?: number
  cursor?: number
  interviewOnly?: boolean
}

export enum OrderEnum1 {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export type FindClinicDoctorProfilesData = IPaginationROIClinicDoctorProfileROnumber

export enum FindClinicDoctorProfilesParams1OrderEnum {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export type UpdateClinicDoctorProfileData = IClinicDoctorProfileROO3

export type DeleteClinicDoctorProfileData = any

export type GetClinicDoctorProfileDetailData = IClinicDoctorProfileROO3

export interface FindMyClinicDoctorProfilesParams {
  status: StatusEnum12[]
  page?: number
  cursor?: number
}

export enum StatusEnum12 {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export type FindMyClinicDoctorProfilesData = IPaginationROIClinicDoctorProfileROnumber

export enum FindMyClinicDoctorProfilesParams1StatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export interface GetArticleListParams {
  pageSize: number
  keyword?: string
  page?: number
  cursor?: string
  orderBy?: OrderByEnum
  categoryIds?: number[]
  regionId?: number
}

export enum OrderByEnum {
  RECENT = 'RECENT',
  LATEST = 'LATEST',
  ORDER = 'ORDER',
  POPULAR = 'POPULAR',
}

export type GetArticleListData = IPaginationROICommunityArticleArticleListROstring

export enum GetArticleListParams1OrderByEnum {
  RECENT = 'RECENT',
  LATEST = 'LATEST',
  ORDER = 'ORDER',
  POPULAR = 'POPULAR',
}

export interface GetArticleSiblingsParams {
  slug?: string
  categoryId?: number
  regionId?: number
  orderBy?: OrderByEnum1
  rangeType?: RangeTypeEnum
  articleId: string
}

export enum OrderByEnum1 {
  RECENT = 'RECENT',
  LATEST = 'LATEST',
  ORDER = 'ORDER',
  POPULAR = 'POPULAR',
}

export enum RangeTypeEnum {
  REALTIME = 'REALTIME',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

export type GetArticleSiblingsData = ICommunityArticleSiblingsRO

export enum GetArticleSiblingsParams1OrderByEnum {
  RECENT = 'RECENT',
  LATEST = 'LATEST',
  ORDER = 'ORDER',
  POPULAR = 'POPULAR',
}

export enum GetArticleSiblingsParams1RangeTypeEnum {
  REALTIME = 'REALTIME',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

export type GetArticleDetailData = ICommunityArticleArticleDetailRO

export type UpdateArticleData = ICommunityArticleArticleDetailRO

export type DeleteArticleData = any

export type ToggleLikeData = boolean

export type ToggleBookmarkData = boolean

export type IncreaseViewCountData = any

export type CreateArticleData = ICommunityArticleArticleDetailRO

export type IncreaseShareCountData = any

export interface GetCommentListParams2 {
  articleId: string
  cursor?: string
  page?: number
  pageSize: number
}

export type GetCommentListResult = IPaginationROICommentCommentROstring

export type CreateCommentData = ICommentCommentRO

export type UpdateCommentData = ICommentCommentRO

export type DeleteCommentData = any

export interface GetArticleSiblingsParams2 {
  categoryId?: number
  regionId?: number
  orderBy?: OrderByEnum2
  articleId: string
}

export enum OrderByEnum2 {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export type GetArticleSiblingsResult = IClinicNewEquipmentSiblingsRO

export enum GetArticleSiblingsParams3OrderByEnum {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export type CreateClinicNewEquipmentData = IClinicNewEquipmentRO

export interface FindClinicNewEquipmentsParams {
  order: OrderEnum2
  categoryIds: number[]
  regionIds: number[]
  keyword?: string
  page?: number
  cursor?: number
}

export enum OrderEnum2 {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export interface FindClinicNewEquipmentsData {
  rows: IClinicNewEquipmentRO[]
  count: number
  cursor: number | null
}

export enum FindClinicNewEquipmentsParams1OrderEnum {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export type UpdateClinicNewEquipmentData = IClinicNewEquipmentRO

export type DeleteClinicNewEquipmentData = any

export type GetClinicNewEquipmentDetailData = IClinicNewEquipmentRO

export interface FindMyEquipmentsParams {
  status?: StatusEnum13[]
  page?: number
  cursor?: number
}

export enum StatusEnum13 {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export type FindMyEquipmentsData = IPaginationROIClinicNewEquipmentROnumber

export enum FindMyEquipmentsParams1StatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  PENDING_UPDATE = 'PENDING_UPDATE',
  REJECTED = 'REJECTED',
}

export type IncreaseViewCountResult = any

export type ToggleLikeResult = boolean

export type IncreaseShareCountResult = any

export interface FindClinicPromotionsParams {
  order: OrderEnum3
  types: TypesEnum1[]
  categoryIds: number[]
  regionIds: number[]
  keyword?: string
  page?: number
  cursor?: number
}

export enum OrderEnum3 {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export enum TypesEnum1 {
  EVENT = 'EVENT',
  LIMITED = 'LIMITED',
  MEDICAL_PACKAGE = 'MEDICAL_PACKAGE',
}

export type FindClinicPromotionsData = IPaginationROIClinicPromotionROnumber

export enum FindClinicPromotionsParams1OrderEnum {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export enum FindClinicPromotionsParams1TypesEnum {
  EVENT = 'EVENT',
  LIMITED = 'LIMITED',
  MEDICAL_PACKAGE = 'MEDICAL_PACKAGE',
}

export type ParticipatePromotionData = IClinicPromotionParticipantROO1

export type GetClinicPromotionData = IClinicPromotionROO1

export interface GetCommentListParams4 {
  articleId: string
  cursor?: string
  page?: number
  pageSize: number
}

export type GetCommentListOutput = IPaginationROICommentCommentROstring

export type CreateCommentResult = ICommentCommentRO

export type UpdateCommentResult = ICommentCommentRO

export type DeleteCommentResult = any

export type CreateClinicReviewData = IClinicReviewRO

export interface FindMyClinicReviewParams {
  /** @format date */
  startDate?: string
  /** @format date */
  endDate?: string
  types: TypesEnum2[]
  page?: number
  cursor?: number
}

export enum TypesEnum2 {
  MEDICAL = 'MEDICAL',
  EXPERIMENT = 'EXPERIMENT',
  BEFORE_AFTER = 'BEFORE_AFTER',
}

export type FindMyClinicReviewData = IPaginationROIClinicReviewROnumber

export enum FindMyClinicReviewParams1TypesEnum {
  MEDICAL = 'MEDICAL',
  EXPERIMENT = 'EXPERIMENT',
  BEFORE_AFTER = 'BEFORE_AFTER',
}

export interface FindClinicReviewParams {
  types: TypesEnum3[]
  page?: number
  cursor?: number
  order: OrderEnum4
  categoryIds: number[]
  q?: string
  clinicId?: number
  pageSize?: number
}

export enum TypesEnum3 {
  MEDICAL = 'MEDICAL',
  EXPERIMENT = 'EXPERIMENT',
  BEFORE_AFTER = 'BEFORE_AFTER',
}

export enum OrderEnum4 {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export type FindClinicReviewData = IPaginationROIClinicReviewROstringnumber

export enum FindClinicReviewParams1TypesEnum {
  MEDICAL = 'MEDICAL',
  EXPERIMENT = 'EXPERIMENT',
  BEFORE_AFTER = 'BEFORE_AFTER',
}

export enum FindClinicReviewParams1OrderEnum {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export type GetClinicDetailData = IClinicReviewDetailRO

export type UpdateClinicReviewData = IClinicReviewRO

export type DeleteClinicReviewData = any

export interface GetArticleSiblingsParams4 {
  categoryId?: number
  orderBy?: OrderByEnum3
  type?: TypeEnum3
  articleId: string
}

export enum OrderByEnum3 {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export enum TypeEnum3 {
  MEDICAL = 'MEDICAL',
  EXPERIMENT = 'EXPERIMENT',
  BEFORE_AFTER = 'BEFORE_AFTER',
}

export type GetArticleSiblingsOutput = IClinicReviewSiblingsRO

export enum GetArticleSiblingsParams5OrderByEnum {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export enum GetArticleSiblingsParams5TypeEnum {
  MEDICAL = 'MEDICAL',
  EXPERIMENT = 'EXPERIMENT',
  BEFORE_AFTER = 'BEFORE_AFTER',
}

export type IncreaseViewCountOutput = any

export type ToggleLikeOutput = boolean

export type IncreaseShareCountOutput = any

export type ToggleClinicWishlistData = IClinicWishlistToggleRO

export interface GetMyClinicWishlistParams {
  cursor?: number
  categoryIds?: number[]
  regionIds?: number[]
  page?: number
  pageSize?: number
}

export type GetMyClinicWishlistData = IPaginationROIClinicWishlistROnumber

export interface GetClinicWishlistParams {
  cursor?: number
  categoryIds?: number[]
  regionIds?: number[]
  page?: number
  pageSize?: number
}

export type GetClinicWishlistData = IPaginationROIClinicWishlistROnumber

export type CreateClinicData = IClinicDetailRO

export interface FindClinicsParams {
  categoryIds: number[]
  regionIds: number[]
  order: OrderEnum5
  cursor?: number
  page?: number
  q?: string
}

export enum OrderEnum5 {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export type FindClinicsData = IPaginationROIClinicROnumber

export enum FindClinicsParams1OrderEnum {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export type UpdateClinicData = IClinicDetailRO

export type GetOneClinicData = IClinicDetailRO

export type GetMyClinicData = IClinicMine

export interface GetCommentListParams6 {
  articleId: string
  cursor?: string
  page?: number
  pageSize: number
}

export type GetCommentListResult1 = IPaginationROICommentCommentROstring

export type CreateCommentOutput = ICommentCommentRO

export type UpdateCommentOutput = ICommentCommentRO

export type DeleteCommentOutput = any

export interface GetArticleSiblingsParams6 {
  slug?: string
  categoryId?: number
  regionId?: number
  orderBy?: OrderByEnum4
  rangeType?: RangeTypeEnum1
  articleId: string
}

export enum OrderByEnum4 {
  RECENT = 'RECENT',
  LATEST = 'LATEST',
  ORDER = 'ORDER',
  POPULAR = 'POPULAR',
}

export enum RangeTypeEnum1 {
  REALTIME = 'REALTIME',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

export type GetArticleSiblingsResult1 = ICommunityArticleSiblingsROO1

export enum GetArticleSiblingsParams7OrderByEnum {
  RECENT = 'RECENT',
  LATEST = 'LATEST',
  ORDER = 'ORDER',
  POPULAR = 'POPULAR',
}

export enum GetArticleSiblingsParams7RangeTypeEnum {
  REALTIME = 'REALTIME',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

export interface GetArticleListParams2 {
  boardSlug?: string
  regionId?: number
  pageSize: number
  rangeType: RangeTypeEnum2
  keyword?: string
  page?: number
  cursor?: string
  orderBy?: OrderByEnum5
  categoryIds?: number[]
}

export enum RangeTypeEnum2 {
  REALTIME = 'REALTIME',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

export enum OrderByEnum5 {
  RECENT = 'RECENT',
  LATEST = 'LATEST',
  ORDER = 'ORDER',
  POPULAR = 'POPULAR',
}

export type GetArticleListResult = IPaginationROICommunityArticleArticleListROstringO1

export enum GetArticleListParams3RangeTypeEnum {
  REALTIME = 'REALTIME',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

export enum GetArticleListParams3OrderByEnum {
  RECENT = 'RECENT',
  LATEST = 'LATEST',
  ORDER = 'ORDER',
  POPULAR = 'POPULAR',
}

export type CreateArticleResult = ICommunityArticleArticleDetailRO

export interface GetPopularListParams {
  pageSize: number
  rangeType: RangeTypeEnum3
  keyword?: string
  page?: number
  cursor?: string
  orderBy?: OrderByEnum6
  categoryIds?: number[]
}

export enum RangeTypeEnum3 {
  REALTIME = 'REALTIME',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

export enum OrderByEnum6 {
  RECENT = 'RECENT',
  LATEST = 'LATEST',
  ORDER = 'ORDER',
  POPULAR = 'POPULAR',
}

export type GetPopularListData = IPaginationROICommunityArticleArticleListROstringO1

export enum GetPopularListParams1RangeTypeEnum {
  REALTIME = 'REALTIME',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

export enum GetPopularListParams1OrderByEnum {
  RECENT = 'RECENT',
  LATEST = 'LATEST',
  ORDER = 'ORDER',
  POPULAR = 'POPULAR',
}

export interface GetFaqListParams {
  keyword?: string
}

export type GetFaqListData = IPaginationROIFaqROstring

export interface GetInquiryListParams {
  pageSize: number
  rangeType: RangeTypeEnum4
  keyword?: string
  page?: number
  cursor?: string
  orderBy?: OrderByEnum7
  categoryIds?: number[]
}

export enum RangeTypeEnum4 {
  REALTIME = 'REALTIME',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

export enum OrderByEnum7 {
  RECENT = 'RECENT',
  LATEST = 'LATEST',
  ORDER = 'ORDER',
  POPULAR = 'POPULAR',
}

export type GetInquiryListData = IPaginationROICommunityArticleInquiryROstring

export enum GetInquiryListParams1RangeTypeEnum {
  REALTIME = 'REALTIME',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

export enum GetInquiryListParams1OrderByEnum {
  RECENT = 'RECENT',
  LATEST = 'LATEST',
  ORDER = 'ORDER',
  POPULAR = 'POPULAR',
}

export interface GetNoticeListParams1 {
  pageSize: number
  rangeType: RangeTypeEnum5
  keyword?: string
  page?: number
  cursor?: string
  orderBy?: OrderByEnum8
  categoryIds?: number[]
}

export enum RangeTypeEnum5 {
  REALTIME = 'REALTIME',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

export enum OrderByEnum8 {
  RECENT = 'RECENT',
  LATEST = 'LATEST',
  ORDER = 'ORDER',
  POPULAR = 'POPULAR',
}

export type GetNoticeListResult = IPaginationROICommunityArticleArticleListROstringO1

export enum GetNoticeListParams2RangeTypeEnum {
  REALTIME = 'REALTIME',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

export enum GetNoticeListParams2OrderByEnum {
  RECENT = 'RECENT',
  LATEST = 'LATEST',
  ORDER = 'ORDER',
  POPULAR = 'POPULAR',
}

export type GetArticleDetailResult = ICommunityArticleArticleDetailRO

export type UpdateArticleResult = ICommunityArticleArticleDetailRO

export type DeleteArticleResult = any

export type ToggleLikeResult1 = boolean

export type ToggleBookmarkResult = boolean

export type IncreaseViewCountResult1 = any

export type IncreaseShareCountData1 = any

export interface FindProductsParams {
  q?: string
  category?: CategoryEnum1[]
  order: OrderEnum6
  cursor?: number
  page?: number
}

export enum CategoryEnum1 {
  Value기초케어 = '기초케어',
  Value진정관리 = '진정관리',
  Value시술후추천템 = '시술후추천템',
}

export enum OrderEnum6 {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export type FindProductsData = IPaginationROIProductROnumber

export enum FindProductsParams1CategoryEnum {
  Value기초케어 = '기초케어',
  Value진정관리 = '진정관리',
  Value시술후추천템 = '시술후추천템',
}

export enum FindProductsParams1OrderEnum {
  LATEST = 'LATEST',
  POPULAR = 'POPULAR',
}

export type GetProductDetailData = IProductRO

export type CreateReportData = number

export type SignupData = IUserROO4

export type AttendanceData = boolean

export type UpdateProfileData = IUserROO4

export interface CheckEmailParams {
  email: string
  type: TypeEnum4
}

export enum TypeEnum4 {
  Signup = 'signup',
  Modify = 'modify',
}

export type CheckEmailData = IUserCheckEmailRO

export enum CheckEmailParams1TypeEnum {
  Signup = 'signup',
  Modify = 'modify',
}

export interface CheckNicknameParams {
  nickname: string
  type: TypeEnum5
}

export enum TypeEnum5 {
  Signup = 'signup',
  Modify = 'modify',
}

export type CheckNicknameData = IUserCheckNicknameRO

export enum CheckNicknameParams1TypeEnum {
  Signup = 'signup',
  Modify = 'modify',
}

export type GetMyProfileData = IUserMine

export type GetMySummaryData = IUserSummaryRO

export type GetMyPointData = number

export interface GetMyReviewParams {
  types: TypesEnum4[]
  /** @format date */
  startDate?: string
  /** @format date */
  endDate?: string
  categoryIds: number[]
  page?: number
  cursor?: number
}

export enum TypesEnum4 {
  MEDICAL = 'MEDICAL',
  EXPERIMENT = 'EXPERIMENT',
  BEFORE_AFTER = 'BEFORE_AFTER',
}

export type GetMyReviewData = IPaginationROIClinicReviewROnumberO1

export enum GetMyReviewParams1TypesEnum {
  MEDICAL = 'MEDICAL',
  EXPERIMENT = 'EXPERIMENT',
  BEFORE_AFTER = 'BEFORE_AFTER',
}

export interface GetMyPromotionParams {
  /** @format date */
  startDate?: string
  /** @format date */
  endDate?: string
  type?: TypeEnum6
  categoryIds: number[]
  regionIds: number[]
  page?: number
  cursor?: number
}

export enum TypeEnum6 {
  EVENT = 'EVENT',
  LIMITED = 'LIMITED',
  MEDICAL_PACKAGE = 'MEDICAL_PACKAGE',
}

export type GetMyPromotionData = IPaginationROIClinicPromotionParticipantROnumber

export enum GetMyPromotionParams1TypeEnum {
  EVENT = 'EVENT',
  LIMITED = 'LIMITED',
  MEDICAL_PACKAGE = 'MEDICAL_PACKAGE',
}

export interface GetMyBoardArticleParams {
  /** @format date */
  startDate?: string
  /** @format date */
  endDate?: string
  categoryIds: number[]
  pageSize: number
  page?: number
  cursor?: string
  slug?: string
}

export type GetMyBoardArticleData = IPaginationROICommunityArticleArticleListROstringO2

export interface GetMyBookmarkParams {
  /** @format date */
  startDate?: string
  /** @format date */
  endDate?: string
  categoryIds: number[]
  pageSize: number
  page?: number
  cursor?: string
  slug?: string
}

export type GetMyBookmarkData = IPaginationROICommunityArticleArticleListROstringO2

export interface GetMyLikeParams {
  pageSize: number
  page?: number
  cursor?: string
  type: TypeEnum7
}

export enum TypeEnum7 {
  COMMUNITY = 'COMMUNITY',
  CLINIC_REVIEW = 'CLINIC_REVIEW',
  ARTICLE = 'ARTICLE',
  CLINIC_EXPERIENCE = 'CLINIC_EXPERIENCE',
  CLINIC_NEW_EQUIPMENT = 'CLINIC_NEW_EQUIPMENT',
}

export type GetMyLikeData = IPaginationROROArticleListROstring

export enum GetMyLikeParams1TypeEnum {
  COMMUNITY = 'COMMUNITY',
  CLINIC_REVIEW = 'CLINIC_REVIEW',
  ARTICLE = 'ARTICLE',
  CLINIC_EXPERIENCE = 'CLINIC_EXPERIENCE',
  CLINIC_NEW_EQUIPMENT = 'CLINIC_NEW_EQUIPMENT',
}

export interface GetMyCommentsParams {
  type: TypeEnum8
  pageSize: number
  page?: number
  cursor?: string
}

export enum TypeEnum8 {
  COMMUNITY = 'COMMUNITY',
  CLINIC_REVIEW = 'CLINIC_REVIEW',
  ARTICLE = 'ARTICLE',
  CLINIC_EXPERIENCE = 'CLINIC_EXPERIENCE',
  CLINIC_NEW_EQUIPMENT = 'CLINIC_NEW_EQUIPMENT',
}

export type GetMyCommentsData = IPaginationROICommentCommentROWithArticleInfostring

export enum GetMyCommentsParams1TypeEnum {
  COMMUNITY = 'COMMUNITY',
  CLINIC_REVIEW = 'CLINIC_REVIEW',
  ARTICLE = 'ARTICLE',
  CLINIC_EXPERIENCE = 'CLINIC_EXPERIENCE',
  CLINIC_NEW_EQUIPMENT = 'CLINIC_NEW_EQUIPMENT',
}

export interface FindEmailParams {
  name: string
  nationNumber: string
  phoneNumber: string
}

export type FindEmailData = IUserFindEmailRO

export interface FindPasswordParams {
  email: string
  name: string
}

export type FindPasswordData = IUserFindPasswordRO

export interface ResendPasswordParams {
  email: string
}

export type ResendPasswordData = IUserResendPasswordRO

export type ChangePasswordData = IUserChangePasswordRO

export type WithdrawData = any

export interface GetPointHistoryParams {
  /** @format date */
  startDate?: string
  /** @format date */
  endDate?: string
  transactionType?: TransactionTypeEnum
  amount?: number
  cursor?: number
  page?: number
}

export enum TransactionTypeEnum {
  EARN = 'EARN',
  USE = 'USE',
  RECOVER = 'RECOVER',
  EXPIRE = 'EXPIRE',
}

export type GetPointHistoryData = IPaginationROIPointHistoryROnumber

export enum GetPointHistoryParams1TransactionTypeEnum {
  EARN = 'EARN',
  USE = 'USE',
  RECOVER = 'RECOVER',
  EXPIRE = 'EXPIRE',
}

export interface EarnPointsParams {
  amount?: number
  referenceId?: string
  referenceType: ReferenceTypeEnum
  /** @format date */
  expiresDate?: string
}

export enum ReferenceTypeEnum {
  SIGNUP = 'SIGNUP',
  WRITE_PROFILE = 'WRITE_PROFILE',
  ORDER = 'ORDER',
  EVENT = 'EVENT',
  REFERRAL = 'REFERRAL',
  REVIEW = 'REVIEW',
  COMMENT = 'COMMENT',
  DAILY = 'DAILY',
  EXPIRE = 'EXPIRE',
  ADMIN = 'ADMIN',
  COMMUNITY = 'COMMUNITY',
  FIRST_COMMENT = 'FIRST_COMMENT',
  FIRST_COMMUNITY = 'FIRST_COMMUNITY',
}

export type EarnPointsData = IPointRO

export enum EarnPointsParams1ReferenceTypeEnum {
  SIGNUP = 'SIGNUP',
  WRITE_PROFILE = 'WRITE_PROFILE',
  ORDER = 'ORDER',
  EVENT = 'EVENT',
  REFERRAL = 'REFERRAL',
  REVIEW = 'REVIEW',
  COMMENT = 'COMMENT',
  DAILY = 'DAILY',
  EXPIRE = 'EXPIRE',
  ADMIN = 'ADMIN',
  COMMUNITY = 'COMMUNITY',
  FIRST_COMMENT = 'FIRST_COMMENT',
  FIRST_COMMUNITY = 'FIRST_COMMUNITY',
}

export interface UsePointsParams {
  amount: number
  description: string
  referenceId?: string
  referenceType: ReferenceTypeEnum1
}

export enum ReferenceTypeEnum1 {
  SIGNUP = 'SIGNUP',
  WRITE_PROFILE = 'WRITE_PROFILE',
  ORDER = 'ORDER',
  EVENT = 'EVENT',
  REFERRAL = 'REFERRAL',
  REVIEW = 'REVIEW',
  COMMENT = 'COMMENT',
  DAILY = 'DAILY',
  EXPIRE = 'EXPIRE',
  ADMIN = 'ADMIN',
  COMMUNITY = 'COMMUNITY',
  FIRST_COMMENT = 'FIRST_COMMENT',
  FIRST_COMMUNITY = 'FIRST_COMMUNITY',
}

export type UsePointsData = IPointRO

export enum UsePointsParams1ReferenceTypeEnum {
  SIGNUP = 'SIGNUP',
  WRITE_PROFILE = 'WRITE_PROFILE',
  ORDER = 'ORDER',
  EVENT = 'EVENT',
  REFERRAL = 'REFERRAL',
  REVIEW = 'REVIEW',
  COMMENT = 'COMMENT',
  DAILY = 'DAILY',
  EXPIRE = 'EXPIRE',
  ADMIN = 'ADMIN',
  COMMUNITY = 'COMMUNITY',
  FIRST_COMMENT = 'FIRST_COMMENT',
  FIRST_COMMUNITY = 'FIRST_COMMUNITY',
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat
  /** request body */
  body?: unknown
  /** base url */
  baseUrl?: string
  /** request cancellation token */
  cancelToken?: CancelToken
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void
  customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D
  error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = 'http://localhost:3199'
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private abortControllers = new Map<CancelToken, AbortController>()
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams)

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  }

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig)
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key)
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key])
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key]
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {}
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key])
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&')
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery)
    return queryString ? `?${queryString}` : ''
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) => {
      const append = (formData: FormData, key: string, value: any) =>
        formData.append(
          key,
          value instanceof Blob
            ? value
            : typeof value === 'object' && value !== null
              ? JSON.stringify(value)
              : `${value}`,
        )

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key]
        if (Array.isArray(property) && property.length === property.filter((p) => p instanceof Blob).length) {
          property.forEach((element) => {
            append(formData, key, element)
          })
        } else {
          append(formData, key, property)
        }
        return formData
      }, new FormData())
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  }

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken)
      if (abortController) {
        return abortController.signal
      }
      return void 0
    }

    const abortController = new AbortController()
    this.abortControllers.set(cancelToken, abortController)
    return abortController.signal
  }

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken)

    if (abortController) {
      abortController.abort()
      this.abortControllers.delete(cancelToken)
    }
  }

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const queryString = query && this.toQueryString(query)
    const payloadFormatter = this.contentFormatters[type || ContentType.Json]
    const responseFormat = format || requestParams.format

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>
      r.data = null as unknown as T
      r.error = null as unknown as E

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data
              } else {
                r.error = data
              }
              return r
            })
            .catch((e) => {
              r.error = e
              return r
            })

      if (cancelToken) {
        this.abortControllers.delete(cancelToken)
      }

      if (!response.ok) throw data
      return data.data
    })
  }
}

/**
 * @title lalamedi-backend
 * @version 0.0.1
 * @license UNLICENSED
 * @baseUrl http://localhost:3199
 *
 * lalamedi-backend
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  admin = {
    /**
     * No description
     *
     * @tags 관리자 > 알림 API
     * @name GetNotificationHistoryList
     * @request GET:/admin/notification
     * @secure
     */
    getNotificationHistoryList: (params: RequestParams = {}) =>
      this.request<GetNotificationHistoryListData, any>({
        path: `/admin/notification`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 알림 API
     * @name GetNotificationHistoryDetail
     * @request GET:/admin/notification/{id}
     * @secure
     */
    getNotificationHistoryDetail: (id: number, params: RequestParams = {}) =>
      this.request<GetNotificationHistoryDetailData, any>({
        path: `/admin/notification/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 알림 API
     * @name SendNotification
     * @request POST:/admin/notification/send
     * @secure
     */
    sendNotification: (data: IAdminNotificationSendNotificationAll, params: RequestParams = {}) =>
      this.request<SendNotificationData, any>({
        path: `/admin/notification/send`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자
     * @name CreateAdmin
     * @request POST:/admin/admin
     * @secure
     */
    createAdmin: (data: IAdminUserCreate, params: RequestParams = {}) =>
      this.request<CreateAdminData, any>({
        path: `/admin/admin`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자
     * @name GetAdmins
     * @request GET:/admin/admin
     * @secure
     */
    getAdmins: (query: GetAdminsParams, params: RequestParams = {}) =>
      this.request<GetAdminsData, any>({
        path: `/admin/admin`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자
     * @name UpdateAdmin
     * @request PATCH:/admin/admin/{id}
     * @secure
     */
    updateAdmin: (id: string, data: IAdminUserUpdate, params: RequestParams = {}) =>
      this.request<UpdateAdminData, any>({
        path: `/admin/admin/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자
     * @name DeleteAdmin
     * @request DELETE:/admin/admin/{id}
     * @secure
     */
    deleteAdmin: (id: string, params: RequestParams = {}) =>
      this.request<DeleteAdminData, any>({
        path: `/admin/admin/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자
     * @name GetAdmin
     * @request GET:/admin/admin/{id}
     * @secure
     */
    getAdmin: (id: string, params: RequestParams = {}) =>
      this.request<GetAdminData, any>({
        path: `/admin/admin/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자
     * @name Login
     * @request POST:/admin/admin/login
     * @secure
     */
    login: (data: IAdminUserLogin, params: RequestParams = {}) =>
      this.request<LoginData, any>({
        path: `/admin/admin/login`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > QNA
     * @name GetQnaList
     * @request GET:/admin/qna
     * @secure
     */
    getQnaList: (query: GetQnaListParams, params: RequestParams = {}) =>
      this.request<GetQnaListData, any>({
        path: `/admin/qna`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > QNA
     * @name GetQnaDetail
     * @request GET:/admin/qna/{id}
     * @secure
     */
    getQnaDetail: (id: number, params: RequestParams = {}) =>
      this.request<GetQnaDetailData, any>({
        path: `/admin/qna/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > QNA
     * @name UpdateQna
     * @request PUT:/admin/qna/{id}
     * @secure
     */
    updateQna: (id: number, data: IAdminQnaUpdate, params: RequestParams = {}) =>
      this.request<UpdateQnaData, any>({
        path: `/admin/qna/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  assets = {
    /**
     * No description
     *
     * @tags 에셋/파일 API
     * @name AssetsDetail
     * @request GET:/assets/{id}
     */
    assetsDetail: (id: number, params: RequestParams = {}) =>
      this.request<AssetsDetailData, any>({
        path: `/assets/${id}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 에셋/파일 API
     * @name UploadCreate
     * @request POST:/assets/upload
     */
    uploadCreate: (data: IAssetUpload, params: RequestParams = {}) =>
      this.request<UploadCreateData, any>({
        path: `/assets/upload`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        ...params,
      }),
  }
  auth = {
    /**
     * @description OAuth2 Redirect. Kakao, Google, Naver, Line
     *
     * @tags 인증/권한 API
     * @name Validate
     * @summary OAuth2 Redirect
     * @request GET:/auth/validate
     */
    validate: (query: ValidateParams, params: RequestParams = {}) =>
      this.request<ValidateData, any>({
        path: `/auth/validate`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description OAuth2 Redirect. Apple
     *
     * @tags 인증/권한 API
     * @name ValidateCreate
     * @summary OAuth2 Redirect
     * @request POST:/auth/validate
     */
    validateCreate: (query: ValidateCreateParams, data: AppleValidateDto, params: RequestParams = {}) =>
      this.request<ValidateCreateData, any>({
        path: `/auth/validate`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증/권한 API
     * @name GetToken
     * @request GET:/auth/token
     */
    getToken: (params: RequestParams = {}) =>
      this.request<GetTokenData, any>({
        path: `/auth/token`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증/권한 API
     * @name SigninEmail
     * @request POST:/auth/signin/email
     */
    signinEmail: (data: IAuthSignIn, params: RequestParams = {}) =>
      this.request<SigninEmailData, any>({
        path: `/auth/signin/email`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증/권한 API
     * @name SigninSocial
     * @request POST:/auth/signin/social
     * @secure
     */
    signinSocial: (params: RequestParams = {}) =>
      this.request<SigninSocialData, any>({
        path: `/auth/signin/social`,
        method: 'POST',
        secure: true,
        ...params,
      }),
  }
  translation = {
    /**
     * No description
     *
     * @tags 번역 API
     * @name TranslateText
     * @request POST:/translation/translate
     * @secure
     */
    translateText: (data: ITranslationQuery, params: RequestParams = {}) =>
      this.request<TranslateTextData, any>({
        path: `/translation/translate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 번역 API
     * @name TranslateMultipleTexts
     * @request POST:/translation/translate-multiple
     * @secure
     */
    translateMultipleTexts: (query: TranslateMultipleTextsParams, params: RequestParams = {}) =>
      this.request<TranslateMultipleTextsData, any>({
        path: `/translation/translate-multiple`,
        method: 'POST',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 번역 API
     * @name GetTranslateSpreadsheet
     * @request GET:/translation/translate-spreadsheet
     * @secure
     */
    getTranslateSpreadsheet: (params: RequestParams = {}) =>
      this.request<GetTranslateSpreadsheetData, any>({
        path: `/translation/translate-spreadsheet`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 번역 API
     * @name SetCacheDuration
     * @request POST:/translation/cache/duration
     * @secure
     */
    setCacheDuration: (query: SetCacheDurationParams, params: RequestParams = {}) =>
      this.request<SetCacheDurationData, any>({
        path: `/translation/cache/duration`,
        method: 'POST',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 번역 API
     * @name InvalidateCache
     * @request POST:/translation/cache/invalidate
     * @secure
     */
    invalidateCache: (params: RequestParams = {}) =>
      this.request<InvalidateCacheData, any>({
        path: `/translation/cache/invalidate`,
        method: 'POST',
        secure: true,
        ...params,
      }),
  }
  adminBanner = {
    /**
     * No description
     *
     * @tags 관리자 > 배너
     * @name AdminBannerList
     * @request GET:/admin-banner
     * @secure
     */
    adminBannerList: (params: RequestParams = {}) =>
      this.request<AdminBannerListData, any>({
        path: `/admin-banner`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 배너
     * @name AdminBannerCreate
     * @request POST:/admin-banner
     * @secure
     */
    adminBannerCreate: (data: IAdminBannerSave, params: RequestParams = {}) =>
      this.request<AdminBannerCreateData, any>({
        path: `/admin-banner`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 배너
     * @name CheckOrderDetail
     * @request GET:/admin-banner/{order}/check-order
     * @secure
     */
    checkOrderDetail: (order: number, params: RequestParams = {}) =>
      this.request<CheckOrderDetailData, any>({
        path: `/admin-banner/${order}/check-order`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 배너
     * @name AdminBannerDetail
     * @request GET:/admin-banner/{id}
     * @secure
     */
    adminBannerDetail: (id: number, params: RequestParams = {}) =>
      this.request<AdminBannerDetailData, any>({
        path: `/admin-banner/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 배너
     * @name AdminBannerUpdate
     * @request PUT:/admin-banner/{id}
     * @secure
     */
    adminBannerUpdate: (id: number, data: IAdminBannerSave, params: RequestParams = {}) =>
      this.request<AdminBannerUpdateData, any>({
        path: `/admin-banner/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 배너
     * @name AdminBannerDelete
     * @request DELETE:/admin-banner/{id}
     * @secure
     */
    adminBannerDelete: (id: number, params: RequestParams = {}) =>
      this.request<AdminBannerDeleteData, any>({
        path: `/admin-banner/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  adminBusinessInquiry = {
    /**
     * No description
     *
     * @tags 관리자 > 비즈니스 문의
     * @name AdminBusinessInquiryList
     * @request GET:/admin-business-inquiry
     * @secure
     */
    adminBusinessInquiryList: (query: AdminBusinessInquiryListParams, params: RequestParams = {}) =>
      this.request<AdminBusinessInquiryListData, any>({
        path: `/admin-business-inquiry`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 비즈니스 문의
     * @name AdminBusinessInquiryDetail
     * @request GET:/admin-business-inquiry/{id}
     * @secure
     */
    adminBusinessInquiryDetail: (id: number, params: RequestParams = {}) =>
      this.request<AdminBusinessInquiryDetailData, any>({
        path: `/admin-business-inquiry/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 비즈니스 문의
     * @name AdminBusinessInquiryUpdate
     * @request PUT:/admin-business-inquiry/{id}
     * @secure
     */
    adminBusinessInquiryUpdate: (id: number, data: IAdminBusinessInquiryUpdate, params: RequestParams = {}) =>
      this.request<AdminBusinessInquiryUpdateData, any>({
        path: `/admin-business-inquiry/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 비즈니스 문의
     * @name AdminBusinessInquiryDelete
     * @request DELETE:/admin-business-inquiry/{id}
     * @secure
     */
    adminBusinessInquiryDelete: (id: number, params: RequestParams = {}) =>
      this.request<AdminBusinessInquiryDeleteData, any>({
        path: `/admin-business-inquiry/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  adminCategory = {
    /**
     * No description
     *
     * @tags 관리자 > 카테고리
     * @name AdminCategoryList
     * @request GET:/admin-category
     * @secure
     */
    adminCategoryList: (params: RequestParams = {}) =>
      this.request<AdminCategoryListData, any>({
        path: `/admin-category`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 카테고리
     * @name AdminCategoryCreate
     * @request POST:/admin-category
     * @secure
     */
    adminCategoryCreate: (data: IAdminCategorySave, params: RequestParams = {}) =>
      this.request<AdminCategoryCreateData, any>({
        path: `/admin-category`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 카테고리
     * @name AdminCategoryDetail
     * @request GET:/admin-category/{id}
     * @secure
     */
    adminCategoryDetail: (id: number, params: RequestParams = {}) =>
      this.request<AdminCategoryDetailData, any>({
        path: `/admin-category/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 카테고리
     * @name AdminCategoryUpdate
     * @request PUT:/admin-category/{id}
     * @secure
     */
    adminCategoryUpdate: (id: number, data: IAdminCategorySave, params: RequestParams = {}) =>
      this.request<AdminCategoryUpdateData, any>({
        path: `/admin-category/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 카테고리
     * @name AdminCategoryDelete
     * @request DELETE:/admin-category/{id}
     * @secure
     */
    adminCategoryDelete: (id: number, params: RequestParams = {}) =>
      this.request<AdminCategoryDeleteData, any>({
        path: `/admin-category/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  adminClinic = {
    /**
     * No description
     *
     * @tags 관리자 > 병원
     * @name ApproveNewEquipment
     * @request POST:/admin-clinic/new-equipment/{id}/confirm
     * @secure
     */
    approveNewEquipment: (id: number, data: IAdminClinicConfirmNewEquipmentRequest, params: RequestParams = {}) =>
      this.request<ApproveNewEquipmentData, any>({
        path: `/admin-clinic/new-equipment/${id}/confirm`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 병원
     * @name AdminClinicList
     * @request GET:/admin-clinic
     * @secure
     */
    adminClinicList: (query: AdminClinicListParams, params: RequestParams = {}) =>
      this.request<AdminClinicListData, any>({
        path: `/admin-clinic`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 병원
     * @name AdminClinicCreate
     * @request POST:/admin-clinic
     * @secure
     */
    adminClinicCreate: (data: IAdminClinicSave, params: RequestParams = {}) =>
      this.request<AdminClinicCreateData, any>({
        path: `/admin-clinic`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 병원
     * @name AdminClinicDetail
     * @request GET:/admin-clinic/{id}
     * @secure
     */
    adminClinicDetail: (id: number, params: RequestParams = {}) =>
      this.request<AdminClinicDetailData, any>({
        path: `/admin-clinic/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 병원
     * @name AdminClinicCreate2
     * @request POST:/admin-clinic/{id}
     * @originalName adminClinicCreate
     * @duplicate
     * @secure
     */
    adminClinicCreate2: (id: number, data: IAdminClinicSave, params: RequestParams = {}) =>
      this.request<AdminClinicCreate2Data, any>({
        path: `/admin-clinic/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 병원
     * @name InactiveCreate
     * @request POST:/admin-clinic/{id}/inactive
     * @secure
     */
    inactiveCreate: (id: number, params: RequestParams = {}) =>
      this.request<InactiveCreateData, any>({
        path: `/admin-clinic/${id}/inactive`,
        method: 'POST',
        secure: true,
        ...params,
      }),
  }
  adminClinicInterview = {
    /**
     * No description
     *
     * @tags 관리자 > 병원 인터뷰
     * @name AdminClinicInterviewList
     * @request GET:/admin-clinic-interview
     * @secure
     */
    adminClinicInterviewList: (query: AdminClinicInterviewListParams, params: RequestParams = {}) =>
      this.request<AdminClinicInterviewListData, any>({
        path: `/admin-clinic-interview`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 병원 인터뷰
     * @name AdminClinicInterviewDetail
     * @request GET:/admin-clinic-interview/{id}
     * @secure
     */
    adminClinicInterviewDetail: (id: number, params: RequestParams = {}) =>
      this.request<AdminClinicInterviewDetailData, any>({
        path: `/admin-clinic-interview/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 병원 인터뷰
     * @name ApproveClinicDoctorProfile
     * @request POST:/admin-clinic-interview/doctor-profile/{id}/confirm
     * @secure
     */
    approveClinicDoctorProfile: (
      id: number,
      data: IAdminClinicConfirmDoctorProfileRequest,
      params: RequestParams = {},
    ) =>
      this.request<ApproveClinicDoctorProfileData, any>({
        path: `/admin-clinic-interview/doctor-profile/${id}/confirm`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 병원 인터뷰
     * @name DoctorProfileRejectMultipleCreate
     * @request POST:/admin-clinic-interview/doctor-profile/reject-multiple
     * @secure
     */
    doctorProfileRejectMultipleCreate: (data: DoctorProfileRejectMultipleCreatePayload, params: RequestParams = {}) =>
      this.request<DoctorProfileRejectMultipleCreateData, any>({
        path: `/admin-clinic-interview/doctor-profile/reject-multiple`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  adminComment = {
    /**
     * No description
     *
     * @name GetCommentList
     * @request GET:/admin-comment
     * @secure
     */
    getCommentList: (query: GetCommentListParams, params: RequestParams = {}) =>
      this.request<GetCommentListData, any>({
        path: `/admin-comment`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCommentDetail
     * @request GET:/admin-comment/{id}
     * @secure
     */
    getCommentDetail: ({ id, ...query }: GetCommentDetailParams, params: RequestParams = {}) =>
      this.request<GetCommentDetailData, any>({
        path: `/admin-comment/${id}`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminCommentDelete
     * @request DELETE:/admin-comment/{id}
     */
    adminCommentDelete: (id: number, data: IAdminCommentDelete, params: RequestParams = {}) =>
      this.request<AdminCommentDeleteData, any>({
        path: `/admin-comment/${id}`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminCommentPartialUpdate
     * @request PATCH:/admin-comment/{id}
     */
    adminCommentPartialUpdate: (id: number, data: IAdminCommentUpdateStatus, params: RequestParams = {}) =>
      this.request<AdminCommentPartialUpdateData, any>({
        path: `/admin-comment/${id}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  }
  adminCommunity = {
    /**
     * No description
     *
     * @tags 관리자 > 커뮤니티
     * @name GetCommunityArticleList
     * @request GET:/admin-community
     * @secure
     */
    getCommunityArticleList: (query: GetCommunityArticleListParams, params: RequestParams = {}) =>
      this.request<GetCommunityArticleListData, any>({
        path: `/admin-community`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 커뮤니티
     * @name CreateCommunityNotice
     * @request POST:/admin-community
     * @secure
     */
    createCommunityNotice: (data: IAdminCommunitySaveNotice, params: RequestParams = {}) =>
      this.request<CreateCommunityNoticeData, any>({
        path: `/admin-community`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 커뮤니티
     * @name GetCommunityArticleDetail
     * @request GET:/admin-community/{id}
     * @secure
     */
    getCommunityArticleDetail: (id: number, params: RequestParams = {}) =>
      this.request<GetCommunityArticleDetailData, any>({
        path: `/admin-community/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 커뮤니티
     * @name UpdateCommunityArticle
     * @request PUT:/admin-community/{id}
     * @secure
     */
    updateCommunityArticle: (id: number, data: IAdminCommunityUpdate, params: RequestParams = {}) =>
      this.request<UpdateCommunityArticleData, any>({
        path: `/admin-community/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 커뮤니티
     * @name DeleteCommunityArticle
     * @request DELETE:/admin-community/{id}
     * @secure
     */
    deleteCommunityArticle: (id: number, params: RequestParams = {}) =>
      this.request<DeleteCommunityArticleData, any>({
        path: `/admin-community/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 커뮤니티
     * @name UpdateCommunityNotice
     * @request PUT:/admin-community/notice/{id}
     * @secure
     */
    updateCommunityNotice: (id: number, data: IAdminCommunitySaveNotice, params: RequestParams = {}) =>
      this.request<UpdateCommunityNoticeData, any>({
        path: `/admin-community/notice/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  adminConsultationRequest = {
    /**
     * No description
     *
     * @tags 관리자 > 상담 신청
     * @name AdminConsultationRequestList
     * @request GET:/admin-consultation-request
     */
    adminConsultationRequestList: (query: AdminConsultationRequestListParams, params: RequestParams = {}) =>
      this.request<AdminConsultationRequestListData, any>({
        path: `/admin-consultation-request`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 상담 신청
     * @name AdminConsultationRequestCreate
     * @request POST:/admin-consultation-request
     */
    adminConsultationRequestCreate: (data: IAdminConsultationRequestCreate, params: RequestParams = {}) =>
      this.request<AdminConsultationRequestCreateData, any>({
        path: `/admin-consultation-request`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 상담 신청
     * @name AdminConsultationRequestDetail
     * @request GET:/admin-consultation-request/{id}
     */
    adminConsultationRequestDetail: (id: number, params: RequestParams = {}) =>
      this.request<AdminConsultationRequestDetailData, any>({
        path: `/admin-consultation-request/${id}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 상담 신청
     * @name AdminConsultationRequestUpdate
     * @request PUT:/admin-consultation-request/{id}
     */
    adminConsultationRequestUpdate: (id: number, data: IAdminConsultationRequestUpdate, params: RequestParams = {}) =>
      this.request<AdminConsultationRequestUpdateData, any>({
        path: `/admin-consultation-request/${id}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 상담 신청
     * @name AdminConsultationRequestDelete
     * @request DELETE:/admin-consultation-request/{id}
     */
    adminConsultationRequestDelete: (id: number, params: RequestParams = {}) =>
      this.request<AdminConsultationRequestDeleteData, any>({
        path: `/admin-consultation-request/${id}`,
        method: 'DELETE',
        ...params,
      }),
  }
  adminExperience = {
    /**
     * No description
     *
     * @tags 관리자 > 체험단관리
     * @name GetExperienceList
     * @request GET:/admin-experience
     * @secure
     */
    getExperienceList: (query: GetExperienceListParams, params: RequestParams = {}) =>
      this.request<GetExperienceListData, any>({
        path: `/admin-experience`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 체험단관리
     * @name GetExperienceDetail
     * @request GET:/admin-experience/{id}
     * @secure
     */
    getExperienceDetail: (id: number, params: RequestParams = {}) =>
      this.request<GetExperienceDetailData, any>({
        path: `/admin-experience/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 체험단관리
     * @name UpdateExperience
     * @request PUT:/admin-experience/{id}
     * @secure
     */
    updateExperience: (id: number, data: IAdminExperienceUpdate, params: RequestParams = {}) =>
      this.request<UpdateExperienceData, any>({
        path: `/admin-experience/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  adminFaq = {
    /**
     * No description
     *
     * @tags 관리자 > FAQ
     * @name AdminFaqList
     * @request GET:/admin-faq
     * @secure
     */
    adminFaqList: (params: RequestParams = {}) =>
      this.request<AdminFaqListData, any>({
        path: `/admin-faq`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > FAQ
     * @name AdminFaqCreate
     * @request POST:/admin-faq
     * @secure
     */
    adminFaqCreate: (data: IAdminFaqSave, params: RequestParams = {}) =>
      this.request<AdminFaqCreateData, any>({
        path: `/admin-faq`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > FAQ
     * @name AdminFaqDelete
     * @request DELETE:/admin-faq
     * @secure
     */
    adminFaqDelete: (data: IAdminFaqDelete, params: RequestParams = {}) =>
      this.request<AdminFaqDeleteData, any>({
        path: `/admin-faq`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > FAQ
     * @name AdminFaqDetail
     * @request GET:/admin-faq/{id}
     * @secure
     */
    adminFaqDetail: (id: number, params: RequestParams = {}) =>
      this.request<AdminFaqDetailData, any>({
        path: `/admin-faq/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > FAQ
     * @name AdminFaqUpdate
     * @request PUT:/admin-faq/{id}
     * @secure
     */
    adminFaqUpdate: (id: number, data: IAdminFaqSave, params: RequestParams = {}) =>
      this.request<AdminFaqUpdateData, any>({
        path: `/admin-faq/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  adminFooterIcon = {
    /**
     * No description
     *
     * @tags 관리자 > 푸터 아이콘
     * @name AdminFooterIconList
     * @request GET:/admin-footer-icon
     * @secure
     */
    adminFooterIconList: (params: RequestParams = {}) =>
      this.request<AdminFooterIconListData, any>({
        path: `/admin-footer-icon`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 푸터 아이콘
     * @name AdminFooterIconCreate
     * @request POST:/admin-footer-icon
     * @secure
     */
    adminFooterIconCreate: (data: IAdminFooterIconSave, params: RequestParams = {}) =>
      this.request<AdminFooterIconCreateData, any>({
        path: `/admin-footer-icon`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 푸터 아이콘
     * @name CheckOrderDetail
     * @request GET:/admin-footer-icon/{order}/{side}/check-order
     * @secure
     */
    checkOrderDetail: (order: number, side: CheckOrderDetailParams1Enum, params: RequestParams = {}) =>
      this.request<CheckOrderDetailResult, any>({
        path: `/admin-footer-icon/${order}/${side}/check-order`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 푸터 아이콘
     * @name AdminFooterIconDetail
     * @request GET:/admin-footer-icon/{id}
     * @secure
     */
    adminFooterIconDetail: (id: number, params: RequestParams = {}) =>
      this.request<AdminFooterIconDetailData, any>({
        path: `/admin-footer-icon/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 푸터 아이콘
     * @name AdminFooterIconUpdate
     * @request PUT:/admin-footer-icon/{id}
     * @secure
     */
    adminFooterIconUpdate: (id: number, data: IAdminFooterIconSave, params: RequestParams = {}) =>
      this.request<AdminFooterIconUpdateData, any>({
        path: `/admin-footer-icon/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 푸터 아이콘
     * @name AdminFooterIconDelete
     * @request DELETE:/admin-footer-icon/{id}
     * @secure
     */
    adminFooterIconDelete: (id: number, params: RequestParams = {}) =>
      this.request<AdminFooterIconDeleteData, any>({
        path: `/admin-footer-icon/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  adminClinicNewEquipment = {
    /**
     * No description
     *
     * @tags 관리자 > 병원 신규 장비
     * @name AdminClinicNewEquipmentList
     * @request GET:/admin-clinic-new-equipment
     * @secure
     */
    adminClinicNewEquipmentList: (query: AdminClinicNewEquipmentListParams, params: RequestParams = {}) =>
      this.request<AdminClinicNewEquipmentListData, any>({
        path: `/admin-clinic-new-equipment`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 병원 신규 장비
     * @name AdminClinicNewEquipmentDetail
     * @request GET:/admin-clinic-new-equipment/{id}
     * @secure
     */
    adminClinicNewEquipmentDetail: (id: number, params: RequestParams = {}) =>
      this.request<AdminClinicNewEquipmentDetailData, any>({
        path: `/admin-clinic-new-equipment/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 병원 신규 장비
     * @name ApproveClinicNewEquipment
     * @request POST:/admin-clinic-new-equipment/{id}/confirm
     * @secure
     */
    approveClinicNewEquipment: (
      id: number,
      data: IAdminClinicConfirmDoctorProfileRequestO1,
      params: RequestParams = {},
    ) =>
      this.request<ApproveClinicNewEquipmentData, any>({
        path: `/admin-clinic-new-equipment/${id}/confirm`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 병원 신규 장비
     * @name RejectMultipleCreate
     * @request POST:/admin-clinic-new-equipment/reject-multiple
     * @secure
     */
    rejectMultipleCreate: (data: RejectMultipleCreatePayload, params: RequestParams = {}) =>
      this.request<RejectMultipleCreateData, any>({
        path: `/admin-clinic-new-equipment/reject-multiple`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  adminNotice = {
    /**
     * No description
     *
     * @tags 관리자 > 공지사항
     * @name AdminNoticeList
     * @request GET:/admin-notice
     * @secure
     */
    adminNoticeList: (params: RequestParams = {}) =>
      this.request<AdminNoticeListData, any>({
        path: `/admin-notice`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 공지사항
     * @name AdminNoticeCreate
     * @request POST:/admin-notice
     * @secure
     */
    adminNoticeCreate: (data: INoticeSave, params: RequestParams = {}) =>
      this.request<AdminNoticeCreateData, any>({
        path: `/admin-notice`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 공지사항
     * @name AdminNoticeDetail
     * @request GET:/admin-notice/{id}
     * @secure
     */
    adminNoticeDetail: (id: number, params: RequestParams = {}) =>
      this.request<AdminNoticeDetailData, any>({
        path: `/admin-notice/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 공지사항
     * @name AdminNoticeUpdate
     * @request PUT:/admin-notice/{id}
     * @secure
     */
    adminNoticeUpdate: (id: number, data: INoticeSave, params: RequestParams = {}) =>
      this.request<AdminNoticeUpdateData, any>({
        path: `/admin-notice/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 공지사항
     * @name AdminNoticeDelete
     * @request DELETE:/admin-notice/{id}
     * @secure
     */
    adminNoticeDelete: (id: number, params: RequestParams = {}) =>
      this.request<AdminNoticeDeleteData, any>({
        path: `/admin-notice/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  adminPoint = {
    /**
     * No description
     *
     * @tags 관리자 > 포인트
     * @name AdminPointList
     * @request GET:/admin-point
     * @secure
     */
    adminPointList: (query: AdminPointListParams, params: RequestParams = {}) =>
      this.request<AdminPointListData, any>({
        path: `/admin-point`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 포인트
     * @name AdminPointCreate
     * @request POST:/admin-point
     * @secure
     */
    adminPointCreate: (data: IAdminPointTransactionCreate, params: RequestParams = {}) =>
      this.request<AdminPointCreateData, any>({
        path: `/admin-point`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 포인트
     * @name AdminPointDetail
     * @request GET:/admin-point/{id}
     * @secure
     */
    adminPointDetail: (id: number, params: RequestParams = {}) =>
      this.request<AdminPointDetailData, any>({
        path: `/admin-point/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  }
  adminPointRule = {
    /**
     * No description
     *
     * @tags 관리자 > 포인트 규칙
     * @name AdminPointRuleList
     * @request GET:/admin-point-rule
     * @secure
     */
    adminPointRuleList: (params: RequestParams = {}) =>
      this.request<AdminPointRuleListData, any>({
        path: `/admin-point-rule`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 포인트 규칙
     * @name AdminPointRuleDetail
     * @request GET:/admin-point-rule/{id}
     * @secure
     */
    adminPointRuleDetail: (id: number, params: RequestParams = {}) =>
      this.request<AdminPointRuleDetailData, any>({
        path: `/admin-point-rule/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 포인트 규칙
     * @name AdminPointRuleUpdate
     * @request PUT:/admin-point-rule/{id}
     * @secure
     */
    adminPointRuleUpdate: (id: number, data: IAdminPointRuleUpdate, params: RequestParams = {}) =>
      this.request<AdminPointRuleUpdateData, any>({
        path: `/admin-point-rule/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 포인트 규칙
     * @name AdminPointRuleDelete
     * @request DELETE:/admin-point-rule/{id}
     * @secure
     */
    adminPointRuleDelete: (id: number, params: RequestParams = {}) =>
      this.request<AdminPointRuleDeleteData, any>({
        path: `/admin-point-rule/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  adminProduct = {
    /**
     * @description 상품 목록 조회
     *
     * @tags 관리자 > 상품
     * @name GetAdminProducts
     * @request GET:/admin-product
     * @secure
     */
    getAdminProducts: (query: GetAdminProductsParams, params: RequestParams = {}) =>
      this.request<GetAdminProductsData, any>({
        path: `/admin-product`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 상품 생성
     *
     * @tags 관리자 > 상품
     * @name CreateAdminProduct
     * @request POST:/admin-product
     * @secure
     */
    createAdminProduct: (data: IAdminProductCreate, params: RequestParams = {}) =>
      this.request<CreateAdminProductData, any>({
        path: `/admin-product`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 상품 상세 조회
     *
     * @tags 관리자 > 상품
     * @name GetAdminProduct
     * @request GET:/admin-product/{id}
     * @secure
     */
    getAdminProduct: (id: number, params: RequestParams = {}) =>
      this.request<GetAdminProductData, any>({
        path: `/admin-product/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 상품 수정
     *
     * @tags 관리자 > 상품
     * @name UpdateAdminProduct
     * @request PUT:/admin-product/{id}
     * @secure
     */
    updateAdminProduct: (id: number, data: IAdminProductUpdate, params: RequestParams = {}) =>
      this.request<UpdateAdminProductData, any>({
        path: `/admin-product/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 상품 삭제
     *
     * @tags 관리자 > 상품
     * @name DeleteAdminProduct
     * @request DELETE:/admin-product/{id}
     * @secure
     */
    deleteAdminProduct: (id: number, params: RequestParams = {}) =>
      this.request<DeleteAdminProductData, any>({
        path: `/admin-product/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  adminPromotion = {
    /**
     * No description
     *
     * @tags 관리자 > 프로모션
     * @name AdminPromotionList
     * @request GET:/admin-promotion
     * @secure
     */
    adminPromotionList: (query: AdminPromotionListParams, params: RequestParams = {}) =>
      this.request<AdminPromotionListData, any>({
        path: `/admin-promotion`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 프로모션
     * @name AdminPromotionCreate
     * @request POST:/admin-promotion
     * @secure
     */
    adminPromotionCreate: (data: IAdminPromotionSave, params: RequestParams = {}) =>
      this.request<AdminPromotionCreateData, any>({
        path: `/admin-promotion`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 프로모션
     * @name AdminPromotionDetail
     * @request GET:/admin-promotion/{id}
     * @secure
     */
    adminPromotionDetail: (id: number, params: RequestParams = {}) =>
      this.request<AdminPromotionDetailData, any>({
        path: `/admin-promotion/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 프로모션
     * @name AdminPromotionUpdate
     * @request PUT:/admin-promotion/{id}
     * @secure
     */
    adminPromotionUpdate: (id: number, data: IAdminPromotionSave, params: RequestParams = {}) =>
      this.request<AdminPromotionUpdateData, any>({
        path: `/admin-promotion/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 프로모션
     * @name FinishUpdate
     * @request PUT:/admin-promotion/{id}/finish
     * @secure
     */
    finishUpdate: (id: number, params: RequestParams = {}) =>
      this.request<FinishUpdateData, any>({
        path: `/admin-promotion/${id}/finish`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 프로모션
     * @name ParticipantDelete
     * @request DELETE:/admin-promotion/{promotionId}/participant/{participantId}
     * @secure
     */
    participantDelete: (promotionId: number, participantId: number, params: RequestParams = {}) =>
      this.request<ParticipantDeleteData, any>({
        path: `/admin-promotion/${promotionId}/participant/${participantId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  adminReferralPartner = {
    /**
     * No description
     *
     * @tags 관리자 > 추천인 파트너
     * @name AdminReferralPartnerList
     * @request GET:/admin-referral-partner
     */
    adminReferralPartnerList: (query: AdminReferralPartnerListParams, params: RequestParams = {}) =>
      this.request<AdminReferralPartnerListData, any>({
        path: `/admin-referral-partner`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 추천인 파트너
     * @name AdminReferralPartnerCreate
     * @request POST:/admin-referral-partner
     */
    adminReferralPartnerCreate: (data: IAdminReferralPartnerSave, params: RequestParams = {}) =>
      this.request<AdminReferralPartnerCreateData, any>({
        path: `/admin-referral-partner`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 추천인 파트너
     * @name CheckCodeList
     * @request GET:/admin-referral-partner/check-code
     */
    checkCodeList: (query: CheckCodeListParams, params: RequestParams = {}) =>
      this.request<CheckCodeListData, any>({
        path: `/admin-referral-partner/check-code`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 추천인 파트너
     * @name AdminReferralPartnerDetail
     * @request GET:/admin-referral-partner/{id}
     */
    adminReferralPartnerDetail: (id: number, params: RequestParams = {}) =>
      this.request<AdminReferralPartnerDetailData, any>({
        path: `/admin-referral-partner/${id}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 추천인 파트너
     * @name AdminReferralPartnerUpdate
     * @request PUT:/admin-referral-partner/{id}
     */
    adminReferralPartnerUpdate: (id: number, data: IAdminReferralPartnerSave, params: RequestParams = {}) =>
      this.request<AdminReferralPartnerUpdateData, any>({
        path: `/admin-referral-partner/${id}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  }
  adminReferralRevenue = {
    /**
     * No description
     *
     * @tags 관리자 > 추천인 매출
     * @name AdminReferralRevenueList
     * @request GET:/admin-referral-revenue
     */
    adminReferralRevenueList: (query: AdminReferralRevenueListParams, params: RequestParams = {}) =>
      this.request<AdminReferralRevenueListData, any>({
        path: `/admin-referral-revenue`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 추천인 매출
     * @name AdminReferralRevenueCreate
     * @request POST:/admin-referral-revenue
     */
    adminReferralRevenueCreate: (data: IAdminReferralRevenueSave, params: RequestParams = {}) =>
      this.request<AdminReferralRevenueCreateData, any>({
        path: `/admin-referral-revenue`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 추천인 매출
     * @name AdminReferralRevenueDetail
     * @request GET:/admin-referral-revenue/{id}
     */
    adminReferralRevenueDetail: (id: number, params: RequestParams = {}) =>
      this.request<AdminReferralRevenueDetailData, any>({
        path: `/admin-referral-revenue/${id}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 추천인 매출
     * @name AdminReferralRevenueUpdate
     * @request PUT:/admin-referral-revenue/{id}
     */
    adminReferralRevenueUpdate: (id: number, data: IAdminReferralRevenueUpdate, params: RequestParams = {}) =>
      this.request<AdminReferralRevenueUpdateData, any>({
        path: `/admin-referral-revenue/${id}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 추천인 매출
     * @name AdminReferralRevenueDelete
     * @request DELETE:/admin-referral-revenue/{id}
     */
    adminReferralRevenueDelete: (id: number, params: RequestParams = {}) =>
      this.request<AdminReferralRevenueDeleteData, any>({
        path: `/admin-referral-revenue/${id}`,
        method: 'DELETE',
        ...params,
      }),
  }
  adminReferralStats = {
    /**
     * No description
     *
     * @tags 관리자 > 추천인 실적
     * @name AdminReferralStatsList
     * @request GET:/admin-referral-stats
     */
    adminReferralStatsList: (query: AdminReferralStatsListParams, params: RequestParams = {}) =>
      this.request<AdminReferralStatsListData, any>({
        path: `/admin-referral-stats`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 추천인 실적
     * @name RevenueDetailsList
     * @request GET:/admin-referral-stats/revenue-details
     */
    revenueDetailsList: (query: RevenueDetailsListParams, params: RequestParams = {}) =>
      this.request<RevenueDetailsListData, any>({
        path: `/admin-referral-stats/revenue-details`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 추천인 실적
     * @name ReservationDetailsList
     * @request GET:/admin-referral-stats/reservation-details
     */
    reservationDetailsList: (query: ReservationDetailsListParams, params: RequestParams = {}) =>
      this.request<ReservationDetailsListData, any>({
        path: `/admin-referral-stats/reservation-details`,
        method: 'GET',
        query: query,
        ...params,
      }),
  }
  adminRegion = {
    /**
     * No description
     *
     * @tags 관리자 > 지역
     * @name AdminRegionList
     * @request GET:/admin-region
     * @secure
     */
    adminRegionList: (params: RequestParams = {}) =>
      this.request<AdminRegionListData, any>({
        path: `/admin-region`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 지역
     * @name AdminRegionCreate
     * @request POST:/admin-region
     * @secure
     */
    adminRegionCreate: (data: IAdminRegionSave, params: RequestParams = {}) =>
      this.request<AdminRegionCreateData, any>({
        path: `/admin-region`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 지역
     * @name AdminRegionDetail
     * @request GET:/admin-region/{id}
     * @secure
     */
    adminRegionDetail: (id: number, params: RequestParams = {}) =>
      this.request<AdminRegionDetailData, any>({
        path: `/admin-region/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 지역
     * @name AdminRegionUpdate
     * @request PUT:/admin-region/{id}
     * @secure
     */
    adminRegionUpdate: (id: number, data: IAdminRegionSave, params: RequestParams = {}) =>
      this.request<AdminRegionUpdateData, any>({
        path: `/admin-region/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 지역
     * @name AdminRegionDelete
     * @request DELETE:/admin-region/{id}
     * @secure
     */
    adminRegionDelete: (id: number, params: RequestParams = {}) =>
      this.request<AdminRegionDeleteData, any>({
        path: `/admin-region/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  adminReport = {
    /**
     * No description
     *
     * @tags 관리자 > 신고관리
     * @name GetReportList
     * @request GET:/admin-report
     * @secure
     */
    getReportList: (query: GetReportListParams, params: RequestParams = {}) =>
      this.request<GetReportListData, any>({
        path: `/admin-report`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 신고관리
     * @name GetReportDetail
     * @request GET:/admin-report/{id}
     * @secure
     */
    getReportDetail: (id: number, params: RequestParams = {}) =>
      this.request<GetReportDetailData, any>({
        path: `/admin-report/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 신고관리
     * @name UpdateReport
     * @request PUT:/admin-report/{id}
     * @secure
     */
    updateReport: (id: number, data: IAdminReportUpdate, params: RequestParams = {}) =>
      this.request<UpdateReportData, any>({
        path: `/admin-report/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  adminUser = {
    /**
     * No description
     *
     * @tags 관리자 > 유저
     * @name AdminUserList
     * @request GET:/admin-user
     * @secure
     */
    adminUserList: (query: AdminUserListParams, params: RequestParams = {}) =>
      this.request<AdminUserListData, any>({
        path: `/admin-user`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 유저
     * @name AdminUserDetail
     * @request GET:/admin-user/{id}
     * @secure
     */
    adminUserDetail: (id: number, params: RequestParams = {}) =>
      this.request<AdminUserDetailData, any>({
        path: `/admin-user/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 관리자 > 유저
     * @name AdminUserUpdate
     * @request PUT:/admin-user/{id}
     * @secure
     */
    adminUserUpdate: (id: number, data: IAdminUserUpdateO1, params: RequestParams = {}) =>
      this.request<AdminUserUpdateData, any>({
        path: `/admin-user/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  app = {
    /**
     * No description
     *
     * @tags 앱 API
     * @name CreateBusinessInquiry
     * @request POST:/app/business-inquiry
     * @secure
     */
    createBusinessInquiry: (data: IBusinessInquiryCreate, params: RequestParams = {}) =>
      this.request<CreateBusinessInquiryData, any>({
        path: `/app/business-inquiry`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 앱 API
     * @name ResolveReferralBySlug
     * @request GET:/app/referral/resolve
     */
    resolveReferralBySlug: (query: ResolveReferralBySlugParams, params: RequestParams = {}) =>
      this.request<ResolveReferralBySlugData, any>({
        path: `/app/referral/resolve`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 앱 API
     * @name ValidateReferralCode
     * @request GET:/app/referral/validate
     */
    validateReferralCode: (query: ValidateReferralCodeParams, params: RequestParams = {}) =>
      this.request<ValidateReferralCodeData, any>({
        path: `/app/referral/validate`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 앱 API
     * @name ListReferralPartners
     * @request GET:/app/referral/partners
     */
    listReferralPartners: (params: RequestParams = {}) =>
      this.request<ListReferralPartnersData, any>({
        path: `/app/referral/partners`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 앱 API
     * @name TrackReferralVisit
     * @request POST:/app/referral/visit
     */
    trackReferralVisit: (data: IReferralVisitTrack, params: RequestParams = {}) =>
      this.request<TrackReferralVisitData, any>({
        path: `/app/referral/visit`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 앱 API
     * @name CreateConsultationRequest
     * @request POST:/app/consultation-request
     */
    createConsultationRequest: (data: IConsultationRequestCreate, params: RequestParams = {}) =>
      this.request<CreateConsultationRequestData, any>({
        path: `/app/consultation-request`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 앱 API
     * @name GetCategoryList
     * @request GET:/app/category
     */
    getCategoryList: (query: GetCategoryListParams, params: RequestParams = {}) =>
      this.request<GetCategoryListData, any>({
        path: `/app/category`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 앱 API
     * @name GetRegionList
     * @request GET:/app/region
     */
    getRegionList: (params: RequestParams = {}) =>
      this.request<GetRegionListData, any>({
        path: `/app/region`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 앱 API
     * @name GetMedia
     * @request GET:/app/media
     */
    getMedia: (query: GetMediaParams, params: RequestParams = {}) =>
      this.request<GetMediaData, any>({
        path: `/app/media`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 앱 API
     * @name GetBannerList
     * @request GET:/app/banner
     */
    getBannerList: (params: RequestParams = {}) =>
      this.request<GetBannerListData, any>({
        path: `/app/banner`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 앱 API
     * @name GetNoticeList
     * @request GET:/app/notice
     */
    getNoticeList: (params: RequestParams = {}) =>
      this.request<GetNoticeListData, any>({
        path: `/app/notice`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 앱 API
     * @name GetFooterIconList
     * @request GET:/app/footer-icon
     */
    getFooterIconList: (params: RequestParams = {}) =>
      this.request<GetFooterIconListData, any>({
        path: `/app/footer-icon`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 앱 API
     * @name CreateErrorLog
     * @request POST:/app/error-log
     */
    createErrorLog: (data: IErrorLogCreate, params: RequestParams = {}) =>
      this.request<CreateErrorLogData, any>({
        path: `/app/error-log`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  }
  clinicDoctorProfile = {
    /**
     * No description
     *
     * @tags 병원 의사 프로필 API
     * @name CreateClinicDoctorProfile
     * @request POST:/clinic-doctor-profile
     * @secure
     */
    createClinicDoctorProfile: (data: IClinicDoctorProfileSaveO1, params: RequestParams = {}) =>
      this.request<CreateClinicDoctorProfileData, any>({
        path: `/clinic-doctor-profile`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 의사 프로필 API
     * @name FindClinicDoctorProfiles
     * @request GET:/clinic-doctor-profile
     * @secure
     */
    findClinicDoctorProfiles: (query: FindClinicDoctorProfilesParams, params: RequestParams = {}) =>
      this.request<FindClinicDoctorProfilesData, any>({
        path: `/clinic-doctor-profile`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 의사 프로필 API
     * @name UpdateClinicDoctorProfile
     * @request PUT:/clinic-doctor-profile/{id}
     * @secure
     */
    updateClinicDoctorProfile: (id: number, data: IClinicDoctorProfileSaveO1, params: RequestParams = {}) =>
      this.request<UpdateClinicDoctorProfileData, any>({
        path: `/clinic-doctor-profile/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 의사 프로필 API
     * @name DeleteClinicDoctorProfile
     * @request DELETE:/clinic-doctor-profile/{id}
     * @secure
     */
    deleteClinicDoctorProfile: (id: number, params: RequestParams = {}) =>
      this.request<DeleteClinicDoctorProfileData, any>({
        path: `/clinic-doctor-profile/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 의사 프로필 API
     * @name GetClinicDoctorProfileDetail
     * @request GET:/clinic-doctor-profile/{id}
     * @secure
     */
    getClinicDoctorProfileDetail: (id: number, params: RequestParams = {}) =>
      this.request<GetClinicDoctorProfileDetailData, any>({
        path: `/clinic-doctor-profile/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 의사 프로필 API
     * @name FindMyClinicDoctorProfiles
     * @request GET:/clinic-doctor-profile/my/profiles
     * @secure
     */
    findMyClinicDoctorProfiles: (query: FindMyClinicDoctorProfilesParams, params: RequestParams = {}) =>
      this.request<FindMyClinicDoctorProfilesData, any>({
        path: `/clinic-doctor-profile/my/profiles`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),
  }
  clinicExperience = {
    /**
     * No description
     *
     * @tags 체험단 구인구직 API
     * @name GetArticleList
     * @request GET:/clinic-experience
     */
    getArticleList: (query: GetArticleListParams, params: RequestParams = {}) =>
      this.request<GetArticleListData, any>({
        path: `/clinic-experience`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 체험단 구인구직 API
     * @name GetArticleSiblings
     * @request GET:/clinic-experience/article/{articleId}/siblings
     */
    getArticleSiblings: ({ articleId, ...query }: GetArticleSiblingsParams, params: RequestParams = {}) =>
      this.request<GetArticleSiblingsData, any>({
        path: `/clinic-experience/article/${articleId}/siblings`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 체험단 구인구직 API
     * @name GetArticleDetail
     * @request GET:/clinic-experience/article/{articleId}
     */
    getArticleDetail: (articleId: string, params: RequestParams = {}) =>
      this.request<GetArticleDetailData, any>({
        path: `/clinic-experience/article/${articleId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 체험단 구인구직 API
     * @name UpdateArticle
     * @request PATCH:/clinic-experience/article/{articleId}
     */
    updateArticle: (articleId: string, data: ICommunityArticleUpdate, params: RequestParams = {}) =>
      this.request<UpdateArticleData, any>({
        path: `/clinic-experience/article/${articleId}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 체험단 구인구직 API
     * @name DeleteArticle
     * @request DELETE:/clinic-experience/article/{articleId}
     */
    deleteArticle: (articleId: string, params: RequestParams = {}) =>
      this.request<DeleteArticleData, any>({
        path: `/clinic-experience/article/${articleId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 체험단 구인구직 API
     * @name ToggleLike
     * @request POST:/clinic-experience/article/{articleId}/like
     */
    toggleLike: (articleId: string, params: RequestParams = {}) =>
      this.request<ToggleLikeData, any>({
        path: `/clinic-experience/article/${articleId}/like`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 체험단 구인구직 API
     * @name ToggleBookmark
     * @request POST:/clinic-experience/article/{articleId}/bookmark
     */
    toggleBookmark: (articleId: string, params: RequestParams = {}) =>
      this.request<ToggleBookmarkData, any>({
        path: `/clinic-experience/article/${articleId}/bookmark`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 체험단 구인구직 API
     * @name IncreaseViewCount
     * @request POST:/clinic-experience/article/{articleId}/view
     */
    increaseViewCount: (articleId: string, params: RequestParams = {}) =>
      this.request<IncreaseViewCountData, any>({
        path: `/clinic-experience/article/${articleId}/view`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 체험단 구인구직 API
     * @name CreateArticle
     * @request POST:/clinic-experience/article
     */
    createArticle: (data: ICommunityArticleCreate, params: RequestParams = {}) =>
      this.request<CreateArticleData, any>({
        path: `/clinic-experience/article`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 체험단 구인구직 API
     * @name IncreaseShareCount
     * @request POST:/clinic-experience/article/{articleId}/share
     */
    increaseShareCount: (articleId: string, data: ICommunityArticleShare, params: RequestParams = {}) =>
      this.request<IncreaseShareCountData, any>({
        path: `/clinic-experience/article/${articleId}/share`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  }
  clinicNewEquipment = {
    /**
     * No description
     *
     * @tags 병원별 신규 장비 댓글 API
     * @name GetCommentList
     * @request GET:/clinic-new-equipment/comment
     */
    getCommentList: (query: GetCommentListParams2, params: RequestParams = {}) =>
      this.request<GetCommentListResult, any>({
        path: `/clinic-new-equipment/comment`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원별 신규 장비 댓글 API
     * @name CreateComment
     * @request POST:/clinic-new-equipment/comment
     */
    createComment: (data: ICommentCommentCreate, params: RequestParams = {}) =>
      this.request<CreateCommentData, any>({
        path: `/clinic-new-equipment/comment`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원별 신규 장비 댓글 API
     * @name UpdateComment
     * @request PATCH:/clinic-new-equipment/comment/{commentId}
     */
    updateComment: (commentId: number, data: ICommentCommentUpdate, params: RequestParams = {}) =>
      this.request<UpdateCommentData, any>({
        path: `/clinic-new-equipment/comment/${commentId}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원별 신규 장비 댓글 API
     * @name DeleteComment
     * @request DELETE:/clinic-new-equipment/comment/{commentId}
     */
    deleteComment: (commentId: number, params: RequestParams = {}) =>
      this.request<DeleteCommentData, any>({
        path: `/clinic-new-equipment/comment/${commentId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 신규 장비 API
     * @name GetArticleSiblings
     * @request GET:/clinic-new-equipment/article/{articleId}/siblings
     */
    getArticleSiblings: ({ articleId, ...query }: GetArticleSiblingsParams2, params: RequestParams = {}) =>
      this.request<GetArticleSiblingsResult, any>({
        path: `/clinic-new-equipment/article/${articleId}/siblings`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 신규 장비 API
     * @name CreateClinicNewEquipment
     * @request POST:/clinic-new-equipment
     * @secure
     */
    createClinicNewEquipment: (data: IClinicNewEquipmentSave, params: RequestParams = {}) =>
      this.request<CreateClinicNewEquipmentData, any>({
        path: `/clinic-new-equipment`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 신규 장비 API
     * @name FindClinicNewEquipments
     * @request GET:/clinic-new-equipment
     * @secure
     */
    findClinicNewEquipments: (query: FindClinicNewEquipmentsParams, params: RequestParams = {}) =>
      this.request<FindClinicNewEquipmentsData, any>({
        path: `/clinic-new-equipment`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 신규 장비 API
     * @name UpdateClinicNewEquipment
     * @request PUT:/clinic-new-equipment/{articleId}
     * @secure
     */
    updateClinicNewEquipment: (articleId: string, data: IClinicNewEquipmentSave, params: RequestParams = {}) =>
      this.request<UpdateClinicNewEquipmentData, any>({
        path: `/clinic-new-equipment/${articleId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 신규 장비 API
     * @name DeleteClinicNewEquipment
     * @request DELETE:/clinic-new-equipment/{articleId}
     * @secure
     */
    deleteClinicNewEquipment: (articleId: string, params: RequestParams = {}) =>
      this.request<DeleteClinicNewEquipmentData, any>({
        path: `/clinic-new-equipment/${articleId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 신규 장비 API
     * @name GetClinicNewEquipmentDetail
     * @request GET:/clinic-new-equipment/{articleId}
     * @secure
     */
    getClinicNewEquipmentDetail: (articleId: string, params: RequestParams = {}) =>
      this.request<GetClinicNewEquipmentDetailData, any>({
        path: `/clinic-new-equipment/${articleId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 신규 장비 API
     * @name FindMyEquipments
     * @request GET:/clinic-new-equipment/my/equipments
     * @secure
     */
    findMyEquipments: (query: FindMyEquipmentsParams, params: RequestParams = {}) =>
      this.request<FindMyEquipmentsData, any>({
        path: `/clinic-new-equipment/my/equipments`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 신규 장비 API
     * @name IncreaseViewCount
     * @request POST:/clinic-new-equipment/{articleId}/view
     * @secure
     */
    increaseViewCount: (articleId: string, params: RequestParams = {}) =>
      this.request<IncreaseViewCountResult, any>({
        path: `/clinic-new-equipment/${articleId}/view`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 신규 장비 API
     * @name ToggleLike
     * @request POST:/clinic-new-equipment/{articleId}/like
     */
    toggleLike: (articleId: string, params: RequestParams = {}) =>
      this.request<ToggleLikeResult, any>({
        path: `/clinic-new-equipment/${articleId}/like`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 신규 장비 API
     * @name IncreaseShareCount
     * @request POST:/clinic-new-equipment/{articleId}/share
     */
    increaseShareCount: (articleId: string, data: ICommunityArticleShareO1, params: RequestParams = {}) =>
      this.request<IncreaseShareCountResult, any>({
        path: `/clinic-new-equipment/${articleId}/share`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  }
  clinicPromotion = {
    /**
     * No description
     *
     * @tags 병원 프로모션 API
     * @name FindClinicPromotions
     * @request GET:/clinic-promotion
     * @secure
     */
    findClinicPromotions: (query: FindClinicPromotionsParams, params: RequestParams = {}) =>
      this.request<FindClinicPromotionsData, any>({
        path: `/clinic-promotion`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 프로모션 API
     * @name ParticipatePromotion
     * @request POST:/clinic-promotion
     * @secure
     */
    participatePromotion: (data: IClinicPromotionParticipantParticipate, params: RequestParams = {}) =>
      this.request<ParticipatePromotionData, any>({
        path: `/clinic-promotion`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 프로모션 API
     * @name GetClinicPromotion
     * @request GET:/clinic-promotion/{id}
     * @secure
     */
    getClinicPromotion: (id: number, params: RequestParams = {}) =>
      this.request<GetClinicPromotionData, any>({
        path: `/clinic-promotion/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  }
  clinicReview = {
    /**
     * No description
     *
     * @tags 리뷰 댓글 API
     * @name GetCommentList
     * @request GET:/clinic-review/comment
     */
    getCommentList: (query: GetCommentListParams4, params: RequestParams = {}) =>
      this.request<GetCommentListOutput, any>({
        path: `/clinic-review/comment`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 리뷰 댓글 API
     * @name CreateComment
     * @request POST:/clinic-review/comment
     */
    createComment: (data: ICommentCommentCreate, params: RequestParams = {}) =>
      this.request<CreateCommentResult, any>({
        path: `/clinic-review/comment`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 리뷰 댓글 API
     * @name UpdateComment
     * @request PATCH:/clinic-review/comment/{commentId}
     */
    updateComment: (commentId: number, data: ICommentCommentUpdate, params: RequestParams = {}) =>
      this.request<UpdateCommentResult, any>({
        path: `/clinic-review/comment/${commentId}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 리뷰 댓글 API
     * @name DeleteComment
     * @request DELETE:/clinic-review/comment/{commentId}
     */
    deleteComment: (commentId: number, params: RequestParams = {}) =>
      this.request<DeleteCommentResult, any>({
        path: `/clinic-review/comment/${commentId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 리뷰 API
     * @name CreateClinicReview
     * @request POST:/clinic-review
     * @secure
     */
    createClinicReview: (data: IClinicReviewCreate, params: RequestParams = {}) =>
      this.request<CreateClinicReviewData, any>({
        path: `/clinic-review`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 리뷰 API
     * @name FindMyClinicReview
     * @request GET:/clinic-review/my-clinic-review
     * @secure
     */
    findMyClinicReview: (query: FindMyClinicReviewParams, params: RequestParams = {}) =>
      this.request<FindMyClinicReviewData, any>({
        path: `/clinic-review/my-clinic-review`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 리뷰 API
     * @name FindClinicReview
     * @request GET:/clinic-review/clinic-review
     * @secure
     */
    findClinicReview: (query: FindClinicReviewParams, params: RequestParams = {}) =>
      this.request<FindClinicReviewData, any>({
        path: `/clinic-review/clinic-review`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 리뷰 API
     * @name GetClinicDetail
     * @request GET:/clinic-review/{articleId}
     * @secure
     */
    getClinicDetail: (articleId: string, params: RequestParams = {}) =>
      this.request<GetClinicDetailData, any>({
        path: `/clinic-review/${articleId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 리뷰 API
     * @name UpdateClinicReview
     * @request PUT:/clinic-review/{articleId}
     * @secure
     */
    updateClinicReview: (articleId: string, data: IClinicReviewCreate, params: RequestParams = {}) =>
      this.request<UpdateClinicReviewData, any>({
        path: `/clinic-review/${articleId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 리뷰 API
     * @name DeleteClinicReview
     * @request DELETE:/clinic-review/{articleId}
     * @secure
     */
    deleteClinicReview: (articleId: string, params: RequestParams = {}) =>
      this.request<DeleteClinicReviewData, any>({
        path: `/clinic-review/${articleId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 리뷰 API
     * @name GetArticleSiblings
     * @request GET:/clinic-review/{articleId}/siblings
     */
    getArticleSiblings: ({ articleId, ...query }: GetArticleSiblingsParams4, params: RequestParams = {}) =>
      this.request<GetArticleSiblingsOutput, any>({
        path: `/clinic-review/${articleId}/siblings`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 리뷰 API
     * @name IncreaseViewCount
     * @request POST:/clinic-review/{articleId}/view
     * @secure
     */
    increaseViewCount: (articleId: string, params: RequestParams = {}) =>
      this.request<IncreaseViewCountOutput, any>({
        path: `/clinic-review/${articleId}/view`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 리뷰 API
     * @name ToggleLike
     * @request POST:/clinic-review/{articleId}/like
     * @secure
     */
    toggleLike: (articleId: string, params: RequestParams = {}) =>
      this.request<ToggleLikeOutput, any>({
        path: `/clinic-review/${articleId}/like`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 리뷰 API
     * @name IncreaseShareCount
     * @request POST:/clinic-review/review/{articleId}/share
     */
    increaseShareCount: (articleId: string, data: ICommunityArticleShareO2, params: RequestParams = {}) =>
      this.request<IncreaseShareCountOutput, any>({
        path: `/clinic-review/review/${articleId}/share`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  }
  clinicWishlist = {
    /**
     * No description
     *
     * @tags 병원 찜 API
     * @name ToggleClinicWishlist
     * @request POST:/clinic-wishlist/{clinicId}
     * @secure
     */
    toggleClinicWishlist: (clinicId: number, params: RequestParams = {}) =>
      this.request<ToggleClinicWishlistData, any>({
        path: `/clinic-wishlist/${clinicId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 찜 API
     * @name GetMyClinicWishlist
     * @request GET:/clinic-wishlist/my/wishlist
     * @secure
     */
    getMyClinicWishlist: (query: GetMyClinicWishlistParams, params: RequestParams = {}) =>
      this.request<GetMyClinicWishlistData, any>({
        path: `/clinic-wishlist/my/wishlist`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 찜 API
     * @name GetClinicWishlist
     * @request GET:/clinic-wishlist/clinic/wishlist
     * @secure
     */
    getClinicWishlist: (query: GetClinicWishlistParams, params: RequestParams = {}) =>
      this.request<GetClinicWishlistData, any>({
        path: `/clinic-wishlist/clinic/wishlist`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),
  }
  clinics = {
    /**
     * No description
     *
     * @tags 병원 API
     * @name CreateClinic
     * @request POST:/clinics
     * @secure
     */
    createClinic: (data: IClinicSave, params: RequestParams = {}) =>
      this.request<CreateClinicData, any>({
        path: `/clinics`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 API
     * @name FindClinics
     * @request GET:/clinics
     * @secure
     */
    findClinics: (query: FindClinicsParams, params: RequestParams = {}) =>
      this.request<FindClinicsData, any>({
        path: `/clinics`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 API
     * @name UpdateClinic
     * @request POST:/clinics/{id}
     * @secure
     */
    updateClinic: (id: number, data: IClinicSave, params: RequestParams = {}) =>
      this.request<UpdateClinicData, any>({
        path: `/clinics/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 API
     * @name GetOneClinic
     * @request GET:/clinics/{id}
     * @secure
     */
    getOneClinic: (id: number, params: RequestParams = {}) =>
      this.request<GetOneClinicData, any>({
        path: `/clinics/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 병원 API
     * @name GetMyClinic
     * @request GET:/clinics/my
     * @secure
     */
    getMyClinic: (params: RequestParams = {}) =>
      this.request<GetMyClinicData, any>({
        path: `/clinics/my`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  }
  community = {
    /**
     * No description
     *
     * @tags 커뮤니티 댓글 API
     * @name GetCommentList
     * @request GET:/community/comment
     */
    getCommentList: (query: GetCommentListParams6, params: RequestParams = {}) =>
      this.request<GetCommentListResult1, any>({
        path: `/community/comment`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 커뮤니티 댓글 API
     * @name CreateComment
     * @request POST:/community/comment
     */
    createComment: (data: ICommentCommentCreate, params: RequestParams = {}) =>
      this.request<CreateCommentOutput, any>({
        path: `/community/comment`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 커뮤니티 댓글 API
     * @name UpdateComment
     * @request PATCH:/community/comment/{commentId}
     */
    updateComment: (commentId: number, data: ICommentCommentUpdate, params: RequestParams = {}) =>
      this.request<UpdateCommentOutput, any>({
        path: `/community/comment/${commentId}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 커뮤니티 댓글 API
     * @name DeleteComment
     * @request DELETE:/community/comment/{commentId}
     */
    deleteComment: (commentId: number, params: RequestParams = {}) =>
      this.request<DeleteCommentOutput, any>({
        path: `/community/comment/${commentId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 커뮤니티 API
     * @name GetArticleSiblings
     * @request GET:/community/article/{articleId}/siblings
     */
    getArticleSiblings: ({ articleId, ...query }: GetArticleSiblingsParams6, params: RequestParams = {}) =>
      this.request<GetArticleSiblingsResult1, any>({
        path: `/community/article/${articleId}/siblings`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 커뮤니티 API
     * @name GetArticleList
     * @request GET:/community/article
     */
    getArticleList: (query: GetArticleListParams2, params: RequestParams = {}) =>
      this.request<GetArticleListResult, any>({
        path: `/community/article`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 커뮤니티 API
     * @name CreateArticle
     * @request POST:/community/article
     */
    createArticle: (data: ICommunityArticleCreate, params: RequestParams = {}) =>
      this.request<CreateArticleResult, any>({
        path: `/community/article`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 커뮤니티 API
     * @name GetPopularList
     * @request GET:/community/popular
     */
    getPopularList: (query: GetPopularListParams, params: RequestParams = {}) =>
      this.request<GetPopularListData, any>({
        path: `/community/popular`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 커뮤니티 API
     * @name GetFaqList
     * @request GET:/community/faq
     */
    getFaqList: (query: GetFaqListParams, params: RequestParams = {}) =>
      this.request<GetFaqListData, any>({
        path: `/community/faq`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 커뮤니티 API
     * @name GetInquiryList
     * @request GET:/community/inquiry
     */
    getInquiryList: (query: GetInquiryListParams, params: RequestParams = {}) =>
      this.request<GetInquiryListData, any>({
        path: `/community/inquiry`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 커뮤니티 API
     * @name GetNoticeList
     * @request GET:/community/notice
     */
    getNoticeList: (query: GetNoticeListParams1, params: RequestParams = {}) =>
      this.request<GetNoticeListResult, any>({
        path: `/community/notice`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 커뮤니티 API
     * @name GetArticleDetail
     * @request GET:/community/article/{articleId}
     */
    getArticleDetail: (articleId: string, params: RequestParams = {}) =>
      this.request<GetArticleDetailResult, any>({
        path: `/community/article/${articleId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 커뮤니티 API
     * @name UpdateArticle
     * @request PATCH:/community/article/{articleId}
     */
    updateArticle: (articleId: string, data: ICommunityArticleUpdate, params: RequestParams = {}) =>
      this.request<UpdateArticleResult, any>({
        path: `/community/article/${articleId}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 커뮤니티 API
     * @name DeleteArticle
     * @request DELETE:/community/article/{articleId}
     */
    deleteArticle: (articleId: string, params: RequestParams = {}) =>
      this.request<DeleteArticleResult, any>({
        path: `/community/article/${articleId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 커뮤니티 API
     * @name ToggleLike
     * @request POST:/community/article/{articleId}/like
     */
    toggleLike: (articleId: string, params: RequestParams = {}) =>
      this.request<ToggleLikeResult1, any>({
        path: `/community/article/${articleId}/like`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 커뮤니티 API
     * @name ToggleBookmark
     * @request POST:/community/article/{articleId}/bookmark
     */
    toggleBookmark: (articleId: string, params: RequestParams = {}) =>
      this.request<ToggleBookmarkResult, any>({
        path: `/community/article/${articleId}/bookmark`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 커뮤니티 API
     * @name IncreaseViewCount
     * @request POST:/community/article/{articleId}/view
     */
    increaseViewCount: (articleId: string, params: RequestParams = {}) =>
      this.request<IncreaseViewCountResult1, any>({
        path: `/community/article/${articleId}/view`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags 커뮤니티 API
     * @name IncreaseShareCount
     * @request POST:/community/article/{articleId}/share
     */
    increaseShareCount: (articleId: string, data: ICommunityArticleShare, params: RequestParams = {}) =>
      this.request<IncreaseShareCountData1, any>({
        path: `/community/article/${articleId}/share`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  }
  products = {
    /**
     * No description
     *
     * @tags 상품 API
     * @name FindProducts
     * @request GET:/products
     * @secure
     */
    findProducts: (query: FindProductsParams, params: RequestParams = {}) =>
      this.request<FindProductsData, any>({
        path: `/products`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 상품 API
     * @name GetProductDetail
     * @request GET:/products/{id}
     * @secure
     */
    getProductDetail: (id: number, params: RequestParams = {}) =>
      this.request<GetProductDetailData, any>({
        path: `/products/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  }
  report = {
    /**
     * No description
     *
     * @tags 신고 API
     * @name CreateReport
     * @request POST:/report/create
     * @secure
     */
    createReport: (data: IReportCreateReport, params: RequestParams = {}) =>
      this.request<CreateReportData, any>({
        path: `/report/create`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  users = {
    /**
     * No description
     *
     * @tags 유저 API
     * @name Signup
     * @request POST:/users/signup
     * @secure
     */
    signup: (data: IUserSignup, params: RequestParams = {}) =>
      this.request<SignupData, any>({
        path: `/users/signup`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 API
     * @name Attendance
     * @request POST:/users/attendance
     * @secure
     */
    attendance: (params: RequestParams = {}) =>
      this.request<AttendanceData, any>({
        path: `/users/attendance`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 API
     * @name UpdateProfile
     * @request PATCH:/users
     * @secure
     */
    updateProfile: (data: IUserUpdateProfile, params: RequestParams = {}) =>
      this.request<UpdateProfileData, any>({
        path: `/users`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 API
     * @name CheckEmail
     * @request GET:/users/checkEmail
     * @secure
     */
    checkEmail: (query: CheckEmailParams, params: RequestParams = {}) =>
      this.request<CheckEmailData, any>({
        path: `/users/checkEmail`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 API
     * @name CheckNickname
     * @request GET:/users/checkNickname
     * @secure
     */
    checkNickname: (query: CheckNicknameParams, params: RequestParams = {}) =>
      this.request<CheckNicknameData, any>({
        path: `/users/checkNickname`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 API
     * @name GetMyProfile
     * @request GET:/users/my/profile
     * @secure
     */
    getMyProfile: (params: RequestParams = {}) =>
      this.request<GetMyProfileData, any>({
        path: `/users/my/profile`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 API
     * @name GetMySummary
     * @request GET:/users/my/summary
     * @secure
     */
    getMySummary: (params: RequestParams = {}) =>
      this.request<GetMySummaryData, any>({
        path: `/users/my/summary`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 API
     * @name GetMyPoint
     * @request GET:/users/my/point
     * @secure
     */
    getMyPoint: (params: RequestParams = {}) =>
      this.request<GetMyPointData, any>({
        path: `/users/my/point`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 API
     * @name GetMyReview
     * @request GET:/users/my/review
     * @secure
     */
    getMyReview: (query: GetMyReviewParams, params: RequestParams = {}) =>
      this.request<GetMyReviewData, any>({
        path: `/users/my/review`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 API
     * @name GetMyPromotion
     * @request GET:/users/my/promotion
     * @secure
     */
    getMyPromotion: (query: GetMyPromotionParams, params: RequestParams = {}) =>
      this.request<GetMyPromotionData, any>({
        path: `/users/my/promotion`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 API
     * @name GetMyBoardArticle
     * @request GET:/users/my/boardArticle
     * @secure
     */
    getMyBoardArticle: (query: GetMyBoardArticleParams, params: RequestParams = {}) =>
      this.request<GetMyBoardArticleData, any>({
        path: `/users/my/boardArticle`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 API
     * @name GetMyBookmark
     * @request GET:/users/my/bookmark
     * @secure
     */
    getMyBookmark: (query: GetMyBookmarkParams, params: RequestParams = {}) =>
      this.request<GetMyBookmarkData, any>({
        path: `/users/my/bookmark`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 API
     * @name GetMyLike
     * @request GET:/users/my/like
     * @secure
     */
    getMyLike: (query: GetMyLikeParams, params: RequestParams = {}) =>
      this.request<GetMyLikeData, any>({
        path: `/users/my/like`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 API
     * @name GetMyComments
     * @request GET:/users/my/comments
     * @secure
     */
    getMyComments: (query: GetMyCommentsParams, params: RequestParams = {}) =>
      this.request<GetMyCommentsData, any>({
        path: `/users/my/comments`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 API
     * @name FindEmail
     * @request POST:/users/find/email
     */
    findEmail: (query: FindEmailParams, params: RequestParams = {}) =>
      this.request<FindEmailData, any>({
        path: `/users/find/email`,
        method: 'POST',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 API
     * @name FindPassword
     * @request POST:/users/find/password
     */
    findPassword: (query: FindPasswordParams, params: RequestParams = {}) =>
      this.request<FindPasswordData, any>({
        path: `/users/find/password`,
        method: 'POST',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 API
     * @name ResendPassword
     * @request POST:/users/resend/password
     */
    resendPassword: (query: ResendPasswordParams, params: RequestParams = {}) =>
      this.request<ResendPasswordData, any>({
        path: `/users/resend/password`,
        method: 'POST',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 API
     * @name ChangePassword
     * @request POST:/users/change/password
     */
    changePassword: (data: IUserChangePassword, params: RequestParams = {}) =>
      this.request<ChangePasswordData, any>({
        path: `/users/change/password`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 API
     * @name Withdraw
     * @request POST:/users/withdraw
     * @secure
     */
    withdraw: (params: RequestParams = {}) =>
      this.request<WithdrawData, any>({
        path: `/users/withdraw`,
        method: 'POST',
        secure: true,
        ...params,
      }),
  }
  userPoints = {
    /**
     * No description
     *
     * @tags 유저 포인트 API
     * @name GetPointHistory
     * @request GET:/user-points/history
     * @secure
     */
    getPointHistory: (query: GetPointHistoryParams, params: RequestParams = {}) =>
      this.request<GetPointHistoryData, any>({
        path: `/user-points/history`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 포인트 API
     * @name EarnPoints
     * @request POST:/user-points/earn
     * @secure
     */
    earnPoints: (query: EarnPointsParams, params: RequestParams = {}) =>
      this.request<EarnPointsData, any>({
        path: `/user-points/earn`,
        method: 'POST',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저 포인트 API
     * @name UsePoints
     * @request POST:/user-points/use
     * @secure
     */
    usePoints: (query: UsePointsParams, params: RequestParams = {}) =>
      this.request<UsePointsData, any>({
        path: `/user-points/use`,
        method: 'POST',
        query: query,
        secure: true,
        ...params,
      }),
  }
}
